import { TranslationKey } from './fr';

const translationZhTw: Record<TranslationKey, string> = {
    'metadata.description': 'Innovorder 後台管理系統',
    'cookies.banner.message':
        '本網站使用 Cookie 以改善您的使用體驗。繼續瀏覽即表示您同意使用這些 Cookie。如需了解我們的隱私政策及管理您的 Cookie 偏好設定，請瀏覽我們的專屬頁面。',
    'cookies.banner.accept': '接受',
    'cookies.banner.decline': '拒絕',
    'legend.DELIVERY': '外送',
    'legend.DRIVE': '得來速',
    'legend.SIT_IN': '內用',
    'legend.TAKE_AWAY': '外帶',
    'legend.KIOSK': '自助點餐機',
    'legend.WEB': '線上訂餐',
    'legend.RECEPTION': '接待台',
    'legend.POS': '收銀台',
    'legend.LOYALTY': '會員積點',
    'legend.EWALLET_KIOSK': '電子錢包自助機',
    'legend.VENDING_MACHINE': '自動販賣機',
    'analyticsPage.needBrandSelection': '由於您是管理員，您必須至少選擇一個品牌。',
    'analyticsPage.notAuthorizedToSeeBrand': '您無權查看此品牌。',
    'analyticsPage.cannotMixEducationAndNonEducationBrands': '您不能同時選擇團膳品牌與商業餐飲品牌。',
    'analyticsPage.reload': '重新整理資料',
    'beta_banner.message': '👋 此為 <b>Beta</b> 版本，後續將持續進行改進與修正。',
    'analytics.metabaseError': '發生錯誤，請稍後再試。',
    'analytics.noAdmin': '很遺憾，IO Analytics 尚未支援管理員模式……敬請期待，即將推出！',
    'analytics.realTime': '即時',
    'analytics.ranking': '排行榜',
    'analytics.products': '產品',
    'analytics.sales': '銷售',
    'analytics.salesSummary': '財務摘要',
    'analytics.demoStaging': '展示（測試環境）',
    'analytics.attendance': '來客量',
    'analytics.billing': '帳單',
    'analytics.dashboard': 'Metabase 儀表板',
    'analytics.filter.restaurant': '依餐廳篩選',
    'analytics.filter.group': '依群組篩選',
    'analytics.filter.consumption': '消費模式',
    'analytics.filter.channel': '通路',
    'analytics.filter.HT': '未稅',
    'analytics.filter.TTC': '含稅',
    'analytics.filter.takeAway': '外帶',
    'analytics.filter.sitIn': '內用',
    'analytics.filter.delivery': '外送',
    'analytics.filter.drive': '得來速',
    'analytics.filter.kiosk': '自助點餐機',
    'analytics.filter.web': '線上訂餐',
    'analytics.filter.pos': '收銀台',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': '自動販賣',
    'leaderboard.title': '餐廳排行榜',
    'leaderboard.ranking': '排名',
    'leaderboard.restaurantName': '餐廳',
    'leaderboard.revenue': '營業額',
    'leaderboard.averageBasket': '平均客單價',
    'leaderboard.ordersCount': '訂單數',
    'leaderboard.RestaurantSearchPlaceholder': '搜尋餐廳',
    'tile.genericErrorMessage': '發生錯誤！',
    'tile.errorHint': '請重新整理資料',
    'random.or': '或',
    'tooltip.example.label': '範例：',
    'iopay.configuration.title': 'Adyen 設定',
    'iopay.commissions.online.title': '線上手續費',
    'iopay.commissions.proximity.title': '近端手續費',
    'iopay.form.name': '標籤',
    'iopay.form.placeholder.name': '標籤',
    'iopay.form.accountHolder': '帳戶持有人識別碼',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': '資金帳戶識別碼',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': '賣家識別碼',
    'iopay.form.placeholder.storeId': '賣家識別碼',
    'iopay.form.transferInstrumentId': '轉帳工具識別碼',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': '固定手續費金額（以歐分為單位）',
    'iopay.form.fixProximityCommissionAmount': '固定手續費金額（以歐分為單位）',
    'iopay.form.placeholder.fixOnlineCommissionAmount': '固定手續費金額（以歐分為單位）',
    'iopay.form.placeholder.fixProximityCommissionAmount': '固定手續費金額（以歐分為單位）',
    'iopay.form.variableOnlineCommissionPercent': '浮動手續費百分比',
    'iopay.form.variableProximityCommissionPercent': '浮動手續費百分比',
    'iopay.form.placeholder.variableOnlineCommissionPercent': '浮動手續費百分比',
    'iopay.form.placeholder.variableProximityCommissionPercent': '浮動手續費百分比',
    'edenred.configuration.title': 'Edenred 模組設定',
    'edenred.form.description': '請填寫必要資訊以設定 Edenred 整合。儲存後，系統將自動取得餐廳的 Merchant ID。',
    'edenred.form.warning.toSend': '資訊已儲存，在送出至 Edenred 前仍可修改。',
    'edenred.form.warning.sent': 'Edenred 處理中。',
    'edenred.form.mid': 'Merchant ID',
    'edenred.form.name': '餐廳名稱',
    'edenred.form.placeholder.name': '我的餐廳名稱',
    'edenred.form.siret': 'Siret',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': '地址',
    'edenred.form.placeholder.address': '5 avenue Anatole France',
    'edenred.form.zipCode': '郵遞區號',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': '城市',
    'edenred.form.placeholder.city': 'Paris',
    'paygreen.configuration.title': '餐券模組設定',
    'paygreen.form.description': '透過上方提供的表單建立帳戶後，您將收到公鑰與私鑰以完成模組設定。',
    'paygreen.form.ongoing_v3_migration': 'Paygreen 版本遷移正在準備中，您無需在後台進行任何操作',
    'paygreen.form.enablePaygreenV3': '啟用 Paygreen V3',
    'paygreen.form.label': '整合名稱',
    'paygreen.form.publicKey': 'V2 公鑰（shopId）',
    'paygreen.form.privateKey': 'V2 私鑰（token）',
    'paygreen.form.secretKey': 'V3 密鑰',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.subShopId': 'V3 子商店 ID（僅在市集模式下填寫）',
    'paygreen.form.supportsLuncheon': '支援 Pass Restaurant（Sodexo）或 Chèque Déjeuner（Up）付款',
    'paygreen.form.supportsSwile': '支援 Swile（原 Lunchr）付款',
    'paygreen.form.supportsRestoflash': '支援 Resto Flash 付款',
    'paygreen.form.placeholder.enablePaygreenV3': '啟用 Paygreen V3',
    'paygreen.form.placeholder.label': '整合名稱',
    'paygreen.form.placeholder.publicKey': 'V2 公鑰（shopId）',
    'paygreen.form.placeholder.privateKey': 'V2 私鑰（token）',
    'paygreen.form.placeholder.secretKey': 'V3 密鑰',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 子商店 ID（僅在市集模式下填寫）',
    'paygreen.form.placeholder.supportsLuncheon': '支援 Pass Restaurant（Sodexo）或 Chèque Déjeuner（Up）付款',
    'paygreen.form.placeholder.supportsSwile': '支援 Swile（原 Lunchr）付款',
    'paygreen.form.placeholder.supportsRestoflash': '支援 Resto Flash 付款',
    'ubereats.title': 'UberEats 設定',
    'ubereats.description.firstpart':
        '請從您的餐廳 Ubereats 介面取得 UUID 參考編號以設定 Ubereats 整合。如果您不知道如何取得此資訊：',
    'ubereats.description.secondpart': '如何查詢我的餐廳 Store ID？',
    'ubereats.description.thirdpart': '完成設定後，您的收銀系統將自動接收外送分類下的 Ubereats 訂單。',
    'ubereats.storid': '商店 ID',
    'ubereats.activestorids': '有效的 Store ID',
    'deliverect.title': 'Deliverect 模組設定',
    'deliverect.subtitle': '如何設定與 Deliverect 的整合？',
    'deliverect.description.firstpart': '您需要先聯繫客戶經理，以便在 Deliverect 環境中建立帳戶。',
    'deliverect.description.secondpart': '帳戶啟用後，您可直接從此介面啟用所選通路的訂單傳送功能。',
    'deliverect.description.thirdpart': '您也可以從此介面同步您的產品。',
    'deliverect.contact': '聯繫客戶經理',
    'deliveroo.title': 'Deliveroo 模組設定',
    'deliveroo.subtitle': '如何設定與 Deliveroo 的整合？',
    'deliveroo.description.firstpart': '您需要先聯繫客戶經理，以便在 Deliveroo 環境中建立帳戶。',
    'deliveroo.description.secondpart': '帳戶設定完成後，您的收銀系統將自動接收外送分類下的 Deliveroo 訂單。',
    'deliveroo.description.thirdpart': '您也可以從 Deliveroo 介面同步您的產品。',
    'deliveroo.contact': '聯繫客戶經理',
    'crous.title': 'CROUS 目錄同步模組設定',
    'crous.description': '請選擇您想匯入目錄的餐廳，並輸入客戶提供的 CROUS 收銀台編號（pos_id）',
    'crous.listcrousrestaurants.label': 'CROUS 餐廳',
    'crous.listcrousrestaurants.placeholder': '選擇餐廳',
    'crous.numerocaisse.label': 'CROUS 收銀台編號',
    'crous.numerocaisse.placeholder': '請輸入 CROUS 收銀台編號',
    'crous.apikey.label': 'CROUS API 金鑰',
    'crous.apikey.placeholder': '請輸入 CROUS API 金鑰',
    'marketplace.vatdefault.placeholder': '預設稅率（%）',
    'marketplace.vatdefault.message': '預設稅率',
    'marketplace.storid.label': '您的門市 ID：',
    'marketplace.storid.placeholder': '輸入一個或多個門市 ID',
    'marketplace.storid.unknown': '未知的商店 ID',
    'marketplace.storid.alreadyused': '此 UUID 已存在（{name}）',
    'marketplace.activestorids.label': '有效虛擬品牌：',
    'marketplace.activestorids.emptystate': '您尚未啟用任何虛擬品牌',
    'marketplace.location.title': '品牌 {counter}',
    'marketplace.location.delete': '刪除',
    'status.status': '狀態',
    'status.active': '啟用',
    'status.inactive': '停用',
    'status.disabled': '不可用',
    'status.loading': '載入中',
    'status.unknown': '未知',
    'status.new': '新建',
    'status.file_uploaded': '檔案已上傳',
    'status.processing': '處理中',
    'status.done': '完成',
    'status.error': '錯誤',
    'date.created': '建立日期',
    'date.updated': '更新日期',
    'external_pos.pos_ref.label': 'Deliverect POS ID：',
    'external_pos.pos_ref.placeholder': '輸入您的 Deliverect POS ID',
    'external_pos.title': 'Deliverect 外部 POS 設定',
    'external_pos.subtitle': '如何設定我的 Deliverect 外部 POS？',
    'external_pos.description.firstpart': '您需要先聯繫客戶經理，以便在 Deliverect 環境中建立帳戶。',
    'external_pos.description.secondpart':
        'Deliverect 外部 POS 設定完成後，它將接收透過已啟用的 Innovorder 通路所下的訂單。',
    'external_pos.description.thirdpart': '使用此整合時，建議您從 Deliverect 管理並同步您的菜單。',
    'external_pos.contact': '聯繫客戶經理',
    'external_pos.channels.title': 'Deliverect 外部 POS 整合：',
    'external_pos.channels.subtitle': '有效通路：',
    'webhook_url.label': 'Webhook URL',
    'webhook_url.placeholder': 'Webhook URL',
    'webhook_secret.label': 'Webhook 密鑰',
    'webhook_secret.placeholder': '輸入 Webhook 密鑰',
    'webhook.headers.label': '附加 HTTP 標頭',
    'webhook.headers.name.placeholder': '標頭名稱',
    'webhook.headers.value.placeholder': '標頭值',
    'webhook.channels.title': 'Webhook 觸發通路',
    'webhook.channels.subtitle': '可用通路：',
    'webhook.title': 'Webhook 設定',
    'webhook.firstpart.subtitle': '此 Webhook 的功能',
    'webhook.firstpart.description':
        '此 Webhook 的功能是通知您的用餐者已在 Innovorder 上完成訂單。\n若某筆銷售是由已以徽章識別的用餐者所產生，系統將呼叫此 Webhook 以傳送該訂單的相關資訊。',
    'webhook.secondpart.subtitle': '如何設定 Webhook？',
    'webhook.secondpart.description':
        '請填寫 Webhook URL。\nWebhook 密鑰將自動產生。\n點擊要為此 Webhook 啟用的通路即可。\n設定完成後，服務必須回傳 HTTP 200 狀態碼及空白回應主體，以確認已收到 Webhook 事件。',
    'webhook.documentationLink': '查閱此 Webhook 的說明文件',
    'webhook.modal.warning': '注意',
    'webhook.modal.confirmDelete': '您確定要刪除嗎？',
    'webhook.channels.kiosk': '自助點餐機',
    'webhook.channels.web': '線上訂餐',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': '托盤掃描',
    'webhook.channels.vendingMachine': '自動\n販賣機',
    'webhook.eventTypes.title': '事件類型',
    'webhook.eventTypes.subtitle': '可用事件類型：',
    'webhook.brand.title': 'Webhook 設定',
    'webhook.brand.firstpart.subtitle': '此 Webhook 的功能',
    'webhook.brand.firstpart.description':
        'Webhook 可讓您在 Innovorder 系統中發生特定事件時即時接收通知。您可以設定 Webhook 以回應各種事件，例如客戶資料更新、交易事件或訂單通知。當事件發生時，Innovorder 將傳送 HTTP POST 請求至您指定的端點，並附上相關資料。',
    'webhook.brand.secondpart.subtitle': '如何設定 Webhook？',
    'webhook.brand.secondpart.description':
        '1. 提供您希望接收通知的 Webhook URL。\n2. 從可用選項中選擇您要監控的事件類型。\n3. 選擇應觸發 Webhook 的通路。\n4. 如端點有需求，可新增附加 HTTP 標頭。\n5. Webhook 密鑰將自動產生以確保安全性。\n\n您的端點必須回傳 HTTP 200 狀態碼以確認已收到 Webhook 事件。',
    'webhook.system.badge': '系統',
    'webhook.system.readonly': '此 Webhook 由系統管理，無法修改。',
    'login.panelTitle': '歡迎使用後台管理系統',
    'login.login': '登入',
    'login.password': '密碼',
    'login.ssoChecking': 'SSO 驗證中…',
    'login.ssoEnabled': '此電子郵件已啟用 SSO。',
    'login.ssoLogin': '以 SSO 登入',
    'login.ssoFailed': 'SSO 登入失敗，請重試。',
    'login.ssoLoginRequired': '此帳戶需要 SSO 登入，正在重新導向…',
    'login.noBrandsConfigured': '此使用者未設定任何品牌。',
    'login.guestBrandLoginFailed': '登入失敗，請重試。',
    'login.rememberMe': '記住我',
    'login.forgotPassword': '忘記密碼？',
    'login.accountLocked': '帳戶暫時被鎖定。請在 {minutes} 分鐘後重試。',
    'login.captchaRequired': '需要安全驗證。',
    'login.ipNotAllowed': '不允許從此 IP 位址登入。',
    'login.accountDisabled': '此帳戶因長期未使用已被停用。',
    'extendAccount.title': '帳戶延期',
    'extendAccount.loadingBody': '正在驗證連結…',
    'extendAccount.successTitle': '帳戶已延期',
    'extendAccount.successBody': '您的帳戶已延期。您現在可以重新登入。',
    'extendAccount.invalidTitle': '連結無效',
    'extendAccount.invalidBody': '此延期連結無效或已過期。',
    'extendAccount.expiredHint': '若要恢復帳戶存取權限，請聯絡您的管理員。',
    'extendAccount.missingTokenBody': '連結不完整，請從您的電子郵件重新開啟連結。',
    'extendAccount.backToLogin': '返回登入',
    'forgotPassword.title': '忘記密碼',
    'forgotPassword.subtitle': '輸入您的電子郵件以接收重設連結。',
    'forgotPassword.submit': '傳送連結',
    'forgotPassword.backToLogin': '返回登入',
    'forgotPassword.successTitle': '電子郵件已傳送',
    'forgotPassword.successMessage': '若此電子郵件帳戶存在，重設連結已傳送。請查收您的收件匣。',
    'forgotPassword.recaptchaLoading': 'reCAPTCHA 載入中…',
    'forgotPassword.recaptchaFailed': 'reCAPTCHA 驗證失敗，請重試。',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA 不可用，請重新整理頁面後再試。',
    'forgotPassword.recaptchaNotConfigured': '設定缺失（REACT_APP_RECAPTCHA_SITE_KEY），請聯繫管理員。',
    'resetPassword.title': '新密碼',
    'resetPassword.subtitle': '請為您的帳戶設定新密碼。',
    'resetPassword.submit': '重設',
    'resetPassword.backToLogin': '返回登入',
    'resetPassword.successTitle': '密碼已更新',
    'resetPassword.successMessage': '您的密碼已成功更新，現在可以登入。',
    'resetPassword.invalidLinkTitle': '無效連結',
    'resetPassword.invalidLink': '此重設連結無效或已過期，請從登入頁面申請新的連結。',
    'resetPassword.passwordTooShort': '密碼長度必須至少 {min} 個字元。',
    'resetPassword.passwordsMismatch': '兩次輸入的密碼不一致。',
    'mfa.verify.title': '兩步驟驗證',
    'mfa.verify.subtitle': '請輸入驗證應用程式產生的 6 位數代碼。',
    'mfa.verify.backupTitle': '備用代碼',
    'mfa.verify.backupSubtitle': '請輸入您的一次性備用代碼。',
    'mfa.verify.submit': '驗證',
    'mfa.verify.useBackupInstead': '改用備用代碼',
    'mfa.verify.useTotpInstead': '使用驗證應用程式',
    'mfa.verify.useDifferentMethod': '使用其他方式',
    'mfa.verify.chooser.title': '選擇驗證方式',
    'mfa.verify.chooser.subtitle': '您想使用哪種方式來驗證身分？',
    'mfa.verify.chooser.webauthnHint': '使用您的安全金鑰或生物辨識。',
    'mfa.verify.chooser.totpHint': '輸入您驗證應用程式中的代碼。',
    'mfa.verify.failed': '代碼無效，請重試。',
    'mfa.verify.tokenExpired': 'MFA 工作階段已過期，請重新登入。',
    'mfa.verify.tabs.totp': '驗證器應用程式',
    'mfa.verify.tabs.webauthn': '安全金鑰 / 生物辨識',
    'mfa.verify.webauthn.title': '使用安全金鑰驗證',
    'mfa.verify.webauthn.subtitle': '請輕觸您的安全金鑰，或使用 Touch ID 或其他平台驗證器。',
    'mfa.verify.webauthn.authenticate': '驗證',
    'mfa.verify.webauthn.failed': '驗證失敗，請改用其他方式。',
    'mfa.verify.webauthn.noCredentials': '此帳戶尚未註冊安全金鑰。',
    'mfa.verify.webauthn.ceremonyFailed': '驗證已取消或瀏覽器拒絕了請求，請重試。',
    'mfa.setup.title': '設定雙重驗證',
    'mfa.setup.subtitle':
        '使用您的驗證應用程式（Google Authenticator、1Password 等）掃描此 QR 碼，然後輸入產生的代碼。',
    'mfa.setup.loadingQr': 'QR 碼載入中...',
    'mfa.setup.copySecret': '複製金鑰',
    'mfa.setup.copied': '已複製！',
    'mfa.setup.confirm': '確認',
    'mfa.setup.invalidCode': '代碼無效，請確認您的應用程式時間同步是否正確。',
    'mfa.setup.backupTitle': '儲存您的備用代碼',
    'mfa.setup.backupSubtitle':
        '請將這些代碼存放在安全的地方。若您無法使用驗證應用程式，可透過這些代碼登入。每組代碼只能使用一次。',
    'mfa.setup.backupAcknowledge': '我已儲存代碼，繼續',
    'mfa.setup.tabs.totp': '驗證器應用程式',
    'mfa.setup.tabs.webauthn': '安全金鑰 / 生物辨識',
    'mfa.setup.webauthn.title': '註冊安全金鑰',
    'mfa.setup.webauthn.subtitle':
        '使用硬體金鑰（YubiKey）、Touch ID、Windows Hello 或其他平台驗證器。您可以為此裝置命名，方便日後辨識。',
    'mfa.setup.webauthn.deviceNamePlaceholder': "裝置名稱（例如：'我的筆電'）",
    'mfa.setup.webauthn.register': '註冊',
    'mfa.setup.webauthn.ceremonyFailed': '註冊已取消或瀏覽器拒絕了請求，請重試。',
    'mfa.setup.webauthn.finalizing': '正在完成安全金鑰設定…',
    'activateAccount.title': '帳戶啟用',
    'activateAccount.submit': '啟用帳戶',
    'activateAccount.submitting': '啟用中...',
    'activateAccount.loading': '驗證 Token 中...',
    'activateAccount.resend': '重新傳送啟用郵件',
    'activateAccount.resending': '傳送中...',
    'activateAccount.renewSuccess': '新的啟用郵件已傳送，請查收您的收件匣。',
    'activateAccount.error.missingToken': 'Token 缺失',
    'activateAccount.error.invalidToken': 'Token 已過期',
    'activateAccount.error.password.minLength': '密碼長度必須至少 {min} 個字元',
    'activateAccount.error.password.maxLength': '密碼長度不得超過 {max} 個字元',
    'activateAccount.error.password.requireUppercase': '密碼必須包含至少一個大寫字母',
    'activateAccount.error.password.requireLowercase': '密碼必須包含至少一個小寫字母',
    'activateAccount.error.password.requireNumbers': '密碼必須包含至少一個數字',
    'activateAccount.error.password.requireSpecialCharacters': '密碼必須包含至少一個特殊字元',
    'activateAccount.password.placeholder': '密碼',
    'activateAccount.confirmPassword.placeholder': '確認密碼',
    'sidebar.overview': '總覽',
    'sidebar.orders': '訂單',
    'sidebar.customers': '客戶',
    'sidebar.brand': '品牌',
    'sidebar.brands': '品牌',
    'sidebar.restaurants': '餐廳',
    'sidebar.loyalty': '會員積點',
    'sidebar.coupons': '優惠碼',
    'sidebar.paymentMeans': '付款方式',
    'sidebar.integrations': '整合',
    'sidebar.reports': '報表',
    'sidebar.reportsSales': '銷售',
    'sidebar.reportsEwallets': '徽章餘額',
    'sidebar.monthly_sales_report': '月銷售報表',
    'sidebar.exports': '匯出',
    'sidebar.exportsAccounting': '會計',
    'sidebar.exportsEwallets': '電子錢包',
    'sidebar.exportsSales': '財務摘要',
    'sidebar.salesSummary': '財務摘要',
    'sidebar.exportsPreInvoicing': '預開發票',
    'sidebar.exportsBadge': '徽章異動記錄',
    'sidebar.reportGenerationsHistory': '產生歷程',
    'sidebar.help': '需要協助？',
    'sidebar.languages': '語言',
    'sidebar.account': '我的帳戶',
    'sidebar.media': '媒體',
    'sidebar.marketplaces': '市集',
    'sidebar.urssaf': 'URSSAF 最低標準',
    'sidebar.vatRatesMatrix': '稅率參考資料',
    'sidebar.autoBilling': '自動帳單',
    'sidebar.logout': '登出',
    'sidebar.password': '我的密碼',
    'sidebar.security': '安全性',
    'security.title': '安全性',
    'security.loading': '載入中…',
    'security.actions.remove': '刪除',
    'security.actions.cancel': '取消',
    'security.totp.title': '驗證器應用程式',
    'security.totp.subtitle': '由 Google Authenticator 或 1Password 等應用程式產生的一次性代碼。',
    'security.totp.label': '驗證器應用程式',
    'security.totp.added': '新增於 {date}',
    'security.totp.empty': '尚未設定驗證器應用程式。',
    'security.totp.add': '新增驗證器應用程式',
    'security.totp.modalTitle': '設定驗證器應用程式',
    'security.totp.confirmRemove': '確定要移除您的驗證器應用程式嗎？',
    'security.passkeys.title': '安全金鑰和通行金鑰',
    'security.passkeys.subtitle': '已為此帳戶註冊的硬體金鑰、Touch ID、Windows Hello 及其他驗證器。',
    'security.passkeys.empty': '尚未註冊任何安全金鑰。',
    'security.passkeys.unnamedDevice': '未命名裝置',
    'security.passkeys.lastUsed': '最後使用：{date}',
    'security.passkeys.added': '新增於 {date}',
    'security.passkeys.add': '新增安全金鑰',
    'security.passkeys.confirmRemove': '確定要移除此金鑰嗎？移除後將無法再使用此裝置登入。',
    'security.passkeys.ceremonyFailed': '註冊已取消或瀏覽器拒絕了請求，請重試。',
    'security.passkeys.requestFailed': '發生錯誤，請重試。',
    'security.allowedIps.title': '允許的 IP 位址',
    'security.allowedIps.subtitle':
        '將您的登入限制為 IP 或 CIDR 範圍清單。允許清單中的 IP 也會略過 CAPTCHA 與鎖定計數器。',
    'security.allowedIps.empty': '無限制。您可以從任何 IP 位址登入。',
    'security.allowedIps.add': '新增',
    'security.allowedIps.placeholder': '192.168.1.1 或 10.0.0.0/24',
    'security.allowedIps.invalid': 'IP 位址或 CIDR 範圍無效。',
    'security.allowedIps.confirmRemoveTitle': '移除此 IP 位址？',
    'security.allowedIps.confirmRemove': '此位址將不再允許登入您的帳戶。',
    'security.allowedIps.cancel': '取消',
    'security.allowedIps.warning': '警告：只要清單中至少包含一個項目，您將無法從其他 IP 登入。',
    'sidebar.billing': '我的帳單空間',
    'sidebar.ioPay': '付款',
    'sidebar.news': '最新消息',
    'sidebar.analytics': 'Analytics',
    'message.message': '訊息',
    'name.name': '姓名',
    'name.firstName': '名字',
    'name.lastName': '姓氏',
    'notFound.message': '抱歉，找不到您的頁面。',
    'notFound.backToHome': '返回首頁',
    'permissionDenied.title': '存取被拒',
    'permissionDenied.message': '很抱歉，您沒有存取此頁面的權限。',
    'permissionDenied.backToHome': '返回首頁',
    'errorPage.message': '很抱歉，我們遇到了技術問題。我們正盡一切努力解決此問題！',
    'errorPage.support': '聯繫我們的客服',
    'file.noFile': '無檔案',
    'file.cannotProcessJson': '無法處理 JSON 檔案，請確認其格式是否正確。',
    'file.fileNotAllowed': '不允許此類型的檔案。允許的副檔名：{allowedExtensionsString}',
    'file.fileTemplate': '檔案範本',
    'file.metabaseLink': 'Metabase 連結',
    'fileInput.placeholder.title': '插入您的檔案！',
    'fileInput.placeholder.drop': '將檔案拖放至此！',
    'fileInput.placeholder': '將一個或多個檔案拖放至視窗中',
    'fileInput.browse': '從電腦匯入',
    'imageInput.section.modal.title': '新增圖片',
    'imageInput.section.modal.resize.label': '背景圖片模式',
    'imageInput.section.modal.resize.details': '當您上傳的圖片將用作自助點餐機或線上訂餐的背景時，請使用此選項。',
    'imageInput.section.library.title': '從相簿選取',
    'imageInput.section.upload.title': '從電腦上傳',
    'languages.fr_FR': '法文',
    'languages.en_EN': '英文',
    'languages.it_IT': '義大利文',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': '西班牙文',
    'languages.zh-CN_ZH-CN': '中文（簡體）',
    'languages.zh-TW_ZH-TW': '中文（繁體）',
    'languages.ar_AR': '阿拉伯文',
    'languages.de_DE': '德文',
    'button.add': '新增',
    'button.delete': '刪除',
    'button.edit': '編輯',
    'button.configure': '設定',
    'button.cancel': '取消',
    'button.close': '關閉',
    'button.generate': '產生',
    'button.save': '儲存',
    'button.import': '匯入',
    'button.publish': '發佈',
    'button.saveAndPublish': '儲存並發佈',
    'button.uploadFile': '上傳檔案',
    'button.previous': '上一步',
    'button.next': '下一步',
    'button.ok': '確定',
    'button.validate': '確認',
    'button.refresh': '重新整理',
    'button.confirm': '確認',
    'button.yes': '是',
    'button.understand': '我已了解',
    'button.convertToCrossSell': '轉換為附加銷售',
    'button.convertToCustomization': '轉換為客製化',
    'button.skipStep': '略過此步驟',
    'button.block': '封鎖',
    'button.unblock': '解除封鎖',
    'select.selectAll': '全選',
    'switch.activate': '啟用',
    'form.preventLeave': '您有未儲存的變更，確定要離開此頁面嗎？',
    'field.required': '此欄位為必填',
    'field.optional': '（選填）',
    'field.greaterThanZero': '此欄位必須大於 0',
    'field.invalidEmail': '此電子郵件無效',
    'field.invalidURL': '此 URL 無效',
    'field.atLeastOneEventType': '至少須選擇一種事件類型',
    'field.unmatchedPassword': '兩次輸入的密碼必須一致',
    'field.invalidPassword': '密碼長度必須至少 8 個字元',
    'field.invalidPhoneNumber': '電話號碼無效',
    'field.duplicate_email': '此電子郵件已存在',
    'field.duplicate_student_number': '此用餐者編號已存在',
    'field.duplicate_badge_number': '此徽章號碼已存在',
    'field.minTwo': '此欄位至少需要 2 個字元',
    'field.ewallet_is_not_null_to_postpayment': '若要將用餐者轉換為後付款帳戶類型，其餘額必須為 0€',
    'select.enabled': '已啟用',
    'select.customised': '已客製化',
    'select.disabled': '已停用',
    'table.search': '搜尋',
    'table.searchColumn': '搜尋 {name}',
    'table.searchColumn.placeholder': '搜尋數值',
    'table.searchColumn.placeholder.from': '最小值',
    'table.searchColumn.placeholder.to': '最大值',
    'table.searchColumn.clearFilter': '清除篩選',
    'table.clearAllFilters': '清除所有篩選',
    'table.rowsPerPage': '每頁列數',
    'table.firstPage': '第一頁',
    'table.lastPage': '最後一頁',
    'table.noRowsAfterFilter': '無符合搜尋條件的結果',
    'table.noRowsAfterFilter.dateRangeHint': '您是否嘗試過變更日期範圍？',
    'table.noRowsAfterFilter.dateRangePresetHint': '過去 {days} 天內無結果。',
    'table.noRowsAfterFilter.dateRangeCustomHint': '所選期間內無結果。',
    'table.noRowsAfterFilter.dateRangeAction': '請調整日期範圍以顯示訂單。',
    'table.sort': '依 {name} 排序',
    'table.columnSelection.button': '欄位管理',
    'table.columnSelection.buttonFiltered': '欄位管理（{count}）',
    'table.columnSelection.header': '篩選欄位',
    'table.columnSelection.placeholder': '搜尋欄位',
    'table.columnSelection.allEntries': '所有欄位',
    'table.selection.count': '已選擇 {count} 列{count, plural, =1 {} other {}}',
    'table.empty': '無可用資料',
    'pagination.previous': '上一頁',
    'pagination.next': '下一頁',
    'navigation.back': '返回',
    'navigation.next': '下一步',
    'navigation.disabled': '返回',
    'navigation.backToV1': '返回舊版',
    'savingBar.changesDone': '{changesCount, plural, =0 {} one {已完成 # 項修改} other {已完成 # 項修改}}',
    'ticketLabel.name.mismatch.confirmation': '注意：產品名稱已變更，但生產標籤保持不變。確認此變更嗎？',
    'form.validation.integer': '此欄位必須為整數',
    'form.validation.positive': '此欄位必須為正數',
    'form.validation.positiveOrZero': '此欄位必須為正數或零',
    'form.validation.length': '此欄位必須包含 {length} 個字元',
    'form.validation.maxLength': '此欄位超過允許的長度',
    'form.validation.email': '此欄位必須為有效的電子郵件',
    'form.validation.mustMatchValue': '此欄位必須為 {value1} 或 {value2 }',
    'form.validation.siret.length': 'SIRET 號碼長度必須為 14 個字元（不含空格）',
    'form.validation.siret.invalid': 'SIRET 號碼無效',
    'integrations.section.title': '付款解決方案',
    'integrations.section.subtitle': '付款解決方案可讓您提供線上信用卡付款或銷售點 POS 機刷卡等功能。',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription': '將 Stripe 整合至您的網站，讓客戶輕鬆連結其帳戶，享有最佳線上訂餐體驗。',
    'integrations.configured': '已設定',
    'integrations.notConfigured': '未設定',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        '所有 Webhook 整合均列於此處。您可以點擊「+」按鈕新增 Webhook，或點擊現有 Webhook 進行編輯。狀態指示器顯示設定狀態。',
    'pricingRule.emptyMessage': '此品牌尚未關聯任何定價方案。',
    'pricingRule.tableCard.title': '定價方案',
    'pricingRule.tableCard.subtitle': '定價方案是由一個或多個入場費、補助及營業額外項目所組成的集合。',
    'pricingRule.tableCard.description':
        '若定價方案同時包含百分比補助和固定金額補助，請將應從訂單總金額扣除的補助置於第一位。後續補助將依前面補助扣除後的剩餘金額計算。',
    'pricingRule.tableCard.action': '+ 建立新定價方案',
    'pricingRule.code': '代碼',
    'pricingRule.applyScope': '策略',
    'pricingRule.strategy': '策略',
    'pricingRule.labelTicket': '收據標籤',
    'pricingRule.grants_fees.amount': '金額',
    'pricingRule.grants_fees.dailyLimit': '每日上限',
    'pricingRule.grants': '補助',
    'pricingRule.entranceFees': '入場費',
    'pricingRule.excludedTurnover': '營業額外項',
    'pricingRule.associatedPricingRules': '關聯定價方案',
    'pricingRule.action': '操作',
    'pricingRule.product': '餐飲部分',
    'pricingRule.fee': '費用（含入場費）',
    'pricingRule.modal.warning': '注意',
    'pricingRule.modal.required': '「定價方案」欄位為必填',
    'pricingRule.modal.confirmDelete': '您確定要刪除嗎？',
    'pricingRule.modal.delete.error.detail': '此定價方案已關聯一個或多個用餐者',
    'pricingRule.modal.unassociatedUser': '用餐者將不再有定價方案',
    'pricingRule.modal.unassociatedUsers': '位用餐者將不再有定價方案',
    'pricingRule.form.title': '定價方案',
    'pricingRule.form.description': '透過分組現有補助，設定定價方案。',
    'pricingRule.form.creation': '建立定價方案',
    'pricingRule.form.update': '修改定價方案',
    'pricingRule.form.pricingRuleCode': '定價方案代碼',
    'pricingRule.form.applyScope': '策略',
    'pricingRule.form.authorizedChannels': '授權通路',
    'pricingRule.form.isUrssafEnabled': '是否對此定價方案套用 URSSAF 最低標準？',
    'pricingRule.form.composition': '定義此定價方案的組成',
    'pricingRule.form.compositionDescription': '定價方案是由一個或多個入場費、補助及營業額外項目所組成的集合。',
    'pricingRule.emptyGrant': '此定價方案尚未關聯任何補助。',
    'pricingRule.emptyEntranceFee': '此定價方案尚未關聯任何入場費。',
    'pricingRule.emptyTurnoverExcluded': '此定價方案尚未關聯任何營業額外項目。',
    'pricingRule.emptyAssociatedPricingRule': '此定價方案尚未關聯任何定價方案。',
    'pricingRule.noResult': '無結果',
    'pricingRule.addGrant': '新增補助',
    'pricingRule.addEntranceFee': '新增入場費',
    'pricingRule.addComponentWithoutTurnover': '新增營業額外項目',
    'pricingRule.addAssociatedPricingRule': '新增關聯定價方案',
    'pricingRule.search': '搜尋定價方案',
    'pricingRule.channels.kiosk': '自助點餐機',
    'pricingRule.channels.pos': '收銀台',
    'pricingRule.channels.web': '線上訂餐',
    'pricingRule.channels.ewalletKiosk': '充值自助機',
    'pricingRule.channels.vendingMachine': '自動販賣機',
    'pricingRule.action.import': '匯入',
    'pricingRule.action.export': '匯出',
    'pricingRule.modal.import.title': '匯入入場費、補助及定價方案',
    'pricingRule.modal.import.firstPart': '下載 {fileTemplate} 至您的電腦',
    'pricingRule.modal.import.secondPart': '在範本檔案中填寫要新增或修改的入場費、補助及定價方案資訊',
    'pricingRule.modal.import.thirdPart': '點擊下方按鈕匯入您的新檔案',
    'pricingRule.modal.import.warning': '入場費、補助或定價方案的刪除僅能透過 Innovorder 後台執行',
    'pricingRule.modal.import.secondWarning':
        '⚠️\n匯入入場費或補助將永久刪除客製化數值。\n（依餐廳或服務時段設定的客製化數值）\n',
    'pricingRule.modal.import.report.title': '匯入報告',
    'pricingRule.modal.import.report.result': '匯入結果',
    'pricingRule.modal.import.report.success': '成功',
    'pricingRule.modal.import.report.error': '失敗',
    'pricingRule.modal.import.report.warning': '警告',
    'pricingRule.modal.import.report.entranceFees': '入場費',
    'pricingRule.modal.import.report.grants': '補助',
    'pricingRule.modal.import.report.pricingRules': '定價方案',
    'pricingRule.modal.import.report.successMessage': '• 建立：{created}\n • 修改：{updated}',
    'pricingRule.modal.import.report.errorMessage': '• 第 {line} 行 - {field}：{message}',
    'pricingRule.export.report.entranceFee.entranceFeeId': '入場費識別碼',
    'pricingRule.export.report.entranceFee.code': '入場費代碼',
    'pricingRule.export.report.entranceFee.labelTicket': '收據標籤',
    'pricingRule.export.report.entranceFee.amount': '金額（歐元）',
    'pricingRule.export.report.entranceFee.dailyLimit': '每日上限',
    'pricingRule.export.report.entranceFee.strategy': '策略（1 為始終 / 2 為每日上限 + 受影響產品）',
    'pricingRule.export.report.entranceFee.vat': '稅率',
    'pricingRule.export.report.entranceFee.type': '營業額（含/不含）',
    'pricingRule.export.report.entranceFee.type.admissionfee': '含',
    'pricingRule.export.report.entranceFee.type.royaltyfee': '不含',
    'pricingRule.export.report.entranceFee.active': '預設對所有餐廳啟用（是/否）（僅適用於建立）',
    'pricingRule.export.report.grant.grantId': '補助識別碼',
    'pricingRule.export.report.grant.code': '補助代碼',
    'pricingRule.export.report.grant.labelTicket': '收據標籤',
    'pricingRule.export.report.grant.threshold': '觸發門檻（歐元，無則留空）',
    'pricingRule.export.report.grant.type': '金額類型（固定/百分比）',
    'pricingRule.export.report.grant.type.absolute': '固定',
    'pricingRule.export.report.grant.type.rate': '百分比',
    'pricingRule.export.report.grant.ceiling': '補助上限（歐元，類型為百分比時為必填）',
    'pricingRule.export.report.grant.amount': '金額（歐元）',
    'pricingRule.export.report.grant.dailyLimit': '每日上限',
    'pricingRule.export.report.grant.strategy': '策略（1 為每日上限 + 金額 / 2 為每日上限 + 最低金額 + 受影響產品）',
    'pricingRule.export.report.grant.tag': '標籤（無標籤應用則留空）',
    'pricingRule.export.report.grant.active': '預設對所有餐廳啟用（是/否）',
    'pricingRule.export.report.pricingRule.pricingRuleId': '定價方案識別碼',
    'pricingRule.export.report.pricingRule.code': '定價方案代碼',
    'pricingRule.export.report.pricingRule.canals': '通路（收銀台、充值自助機、自動販賣機、自助點餐機及/或線上訂餐）',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        '是否套用 URSSAF 最低標準（僅適用於購物車 API）？（是/否）',
    'pricingRule.export.report.pricingRule.entranceFees': '含入場費（填寫代碼，多個時以逗號加空格分隔）',
    'pricingRule.export.report.pricingRule.grants': '含補助（填寫代碼，多個時以逗號加空格分隔）',
    'pricingRule.export.report.pricingRule.includeCA': '含營業額外項',
    'pricingRule.export.report.pricingRule.applyScope': '策略（費用（含入場費）及/或餐飲部分）',
    'pricingRule.export.report.pricingRule.applyScope.product': '餐飲部分',
    'pricingRule.export.report.pricingRule.applyScope.fee': '費用（含入場費）',
    'entranceFee.create': '建立入場費',
    'entranceFee.title': '入場費',
    'entranceFee.description': '請為所有門市填寫入場費的名稱、金額及規則。',
    'entranceFee.customUse': '入場費的特殊應用',
    'entranceFee.descCustomUse': '依餐廳啟用及客製化入場費',
    'entranceFee.warningForm': '請在餐廳啟用入場費前，確認填寫所有欄位。',
    'entranceFee.default': '預設',
    'entranceFee.code': '入場費代碼',
    'entranceFee.codeAlreadyUsed': '入場費代碼已使用',
    'entranceFee.labelTicket': '收據標籤',
    'entranceFee.amount': '金額',
    'entranceFee.vat': '稅率',
    'entranceFee.strategy': '策略',
    'entranceFee.dailyLimit': '每日上限',
    'entranceFee.type': '營業額',
    'entranceFee.select.always': '每日上限',
    'entranceFee.select.daily': '每日上限 + 受影響產品',
    'entranceFee.select.salesExcluded': '不含',
    'entranceFee.select.salesIncluded': '含',
    'entranceFee.emptyMessage': '此品牌尚未關聯任何入場費。',
    'entranceFee.table.state': '啟用狀態',
    'entranceFee.table.services': '已啟用服務',
    'entranceFee.table.state.enabled': '已啟用',
    'entranceFee.table.state.customised': '已啟用（使用客製化數值）',
    'entranceFee.table.state.disabled': '已停用',
    'entranceFee.tableCard.title': '入場費',
    'entranceFee.tableCard.subtitle': '建立並管理餐廳使用的各種入場費',
    'entranceFee.tableCard.action': '+ 建立新入場費',
    'entranceFee.restaurants': '餐廳',
    'entranceFee.restaurant': '餐廳',
    'entranceFee.action': '操作',
    'entranceFee.modal.warning': '注意',
    'entranceFee.modal.confirmDelete': '您確定要刪除嗎？',
    'entranceFee.search': '搜尋入場費',
    'entranceFee.configuration.title': '入場費特殊應用 - {name}',
    'entranceFee.configuration.header.title': '管理此餐廳的服務',
    'entranceFee.configuration.search': '搜尋服務',
    'entranceFee.configuration.table.activation': '啟用',
    'entranceFee.configuration.table.name': '服務名稱',
    'entranceFee.configuration.table.time': '時間',
    'entranceFee.configuration.table.days': '期間',
    'entranceFee.configuration.table.amount': '金額',
    'entranceFee.configuration.table.vat': '稅率',
    'entranceFee.configuration.table.defaultShift': '預設服務時段',
    'entranceFee.warningShifts.title': '確認修改',
    'entranceFee.warningShifts.shift': '服務：{time} - 金額：{amount} - 差異：{variation}',
    'entranceFee.warningShifts.shift.amount': '\n入場費金額：{amount}',
    'entranceFee.warningShifts.confirm': '確定要繼續嗎？',
    'grant.create': '建立補助',
    'grant.title': '補助',
    'grant.description': '請為所有門市填寫補助金額及適用規則。',
    'grant.description.title1': '策略 1：每日上限 + 金額',
    'grant.customUse': '補助的特殊應用',
    'grant.descCustomUse': '依餐廳啟用及客製化補助',
    'grant.warningLimit': '⚠️ 客製化每日上限不得高於預設值。',
    'grant.warningForm': '請在餐廳啟用補助前，確認填寫所有欄位。',
    'grant.desc1':
        '補助適用於購物車中的所有產品，並遵循以下規則：\n若設定門檻，則僅對超過門檻的購物車金額產生影響。\n若設定上限，補助金額不得超過此上限。\n若設定標籤，則僅具有該標籤的產品受補助影響。\n',
    'grant.description.title2': '策略 2：每日上限 + 金額 + 受影響產品',
    'grant.desc2':
        '補助遵循上述相同規則，另外：\n若補助為百分比，則僅標記為可補助的產品受影響。\n若補助為固定金額，則只有當購物車包含至少 1 個標記為可補助的產品時才觸發。',
    'grant.amount': '金額',
    'grant.default': '預設',
    'grant.code': '補助代碼',
    'grant.codeAlreadyUsed': '補助代碼已使用',
    'grant.strategy': '策略',
    'grant.dailyLimit': '每日限額',
    'grant.type': '金額類型',
    'grant.tags': '僅套用至具有以下標籤的商品：',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': '收據標籤',
    'grant.select.rate': '百分比',
    'grant.select.absolute': '絕對值',
    'grant.select.minimum': '每日限額 + 金額',
    'grant.select.minimumAndProduct': '每日限額 + 最低金額 + 受影響商品',
    'grant.threshold': '觸發門檻',
    'grant.ceiling': '補貼上限',
    'grant.restaurants': '餐廳',
    'grant.action': '操作',
    'grant.emptyMessage': '此品牌未關聯任何補貼。',
    'grant.tableCard.title': '補貼',
    'grant.tableCard.subtitle': '建立並管理您餐廳使用的各種補貼',
    'grant.tableCard.action': '+ 新增補貼',
    'grant.settings.button': '設定',
    'grant.settings.modal.title': '補貼設定',
    'grant.settings.modal.subtitle': '設定適用於您品牌補貼的規則。',
    'grant.settings.modal.toggle.label': '當套用補貼時，停用餐券付款',
    'grant.settings.modal.toggle.description':
        '啟用後，購物車中包含補貼的用餐者將無法在線上訂購（CELV2）中使用餐券付款方式（Edenred、Paygreen）。',
    'grant.settings.modal.cancel': '取消',
    'grant.settings.modal.save': '儲存',
    'grant.table.enabled': '啟用',
    'grant.table.state': '啟用狀態',
    'grant.table.services': '已啟用服務',
    'grant.table.state.enabled': '已啟用',
    'grant.table.state.customised': '已啟用（使用自訂值）',
    'grant.table.state.disabled': '已停用',
    'grant.table.restaurant': '餐廳',
    'grant.table.threshold': '觸發條件',
    'grant.table.ceiling': '上限',
    'grant.table.dailyLimit': '每日限額',
    'grant.table.strategy': '策略',
    'grant.table.action': '操作',
    'grant.modal.warning': '警告',
    'grant.modal.confirmDelete': '確定要刪除嗎？',
    'grant.search': '搜尋補貼',
    'grant.configuration.title': '補貼特定應用 - {name}',
    'grant.configuration.header.title': '管理此餐廳的服務',
    'grant.configuration.search': '搜尋服務',
    'grant.configuration.table.activation': '啟用',
    'grant.configuration.table.name': '服務名稱',
    'grant.configuration.table.time': '時間',
    'grant.configuration.table.days': '期間',
    'grant.configuration.table.amount': '金額',
    'grant.configuration.table.threshold': '觸發條件',
    'grant.configuration.table.ceiling': '上限',
    'grant.configuration.table.defaultShift': '預設班次',
    'grant.warningShifts.title': '確認修改',
    'grant.warningShifts.shift': '{time} - 金額：{amount} - 差異：{variation}',
    'grant.warningShifts.shift.amount': '\n補貼金額：{amount}',
    'grant.warningShifts.confirm': '確定要繼續嗎？',
    'group.tableCard.title': '群組',
    'group.tableCard.action': '+ 建立新群組',
    'group.tableCard.subtitle': '定義您的賓客按群組分組的可能性，並關聯各種費率制度。',
    'group.tableCard.subtitle2': '在此定義您賓客的各種組織可能性。',
    'group.emptyMessage': '此品牌未關聯任何群組。',
    'group.name': '群組',
    'group.action': '操作',
    'group.pricingRules': '費率制度',
    'group.guestsCount': '賓客數量',
    'group.guestsCountLabel': '賓客',
    'group.modal.warning': '警告',
    'group.modal.confirmDelete': '確定要刪除嗎？',
    'group.modal.deleteError': '您無法刪除此群組。',
    'group.modal.deleteErrorReason': '請先解除關聯的賓客，才能完成此刪除。',
    'group.warning.group_name_already_exist.message': '群組名稱已存在。',
    'group.warning.group_name_already_exist.description': '請提出新的群組名稱，或將所選費率制度關聯至現有群組。',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        '您要從目前群組取消關聯的一個或多個費率制度已指派給現有賓客。',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        '請先從現有賓客中取消指派這些費率制度，才能從群組可用費率制度清單中刪除它們',
    'group.modal.import.title': '匯入群組、區段、子區段和費率制度',
    'group.modal.import.firstPart': '將 {fileTemplate} 下載至您的電腦',
    'group.modal.import.secondPart': '在範本檔案中填寫要新增或修改的群組、區段、子區段和費率制度資訊',
    'group.modal.import.thirdPart': '點擊下方按鈕匯入您的新檔案',
    'group.modal.import.warning': '群組、區段、子區段和費率制度的刪除只能透過 Innovorder 後台進行',
    'group.modal.import.report.title': '匯入報告',
    'group.export.group': '群組',
    'group.export.section': '區段',
    'group.export.subsection': '子區段',
    'group.export.pricingRule': '關聯的費率制度',
    'group.modal.conflict.error.message': '您無法修改此群組',
    'group.modal.conflict.error.description': '請在修改此群組前重新指派賓客',
    'group.modal.conflict.export.button': '匯出賓客',
    'group.modal.import.report.groups': '群組',
    'group.modal.import.report.sections': '區段',
    'group.modal.import.report.subsections': '子區段',
    'group.modal.import.report.successMessage': '• 建立：{created}\n • 修改：{updated}',
    'group.modal.import.report.errorMessage': '• 第 {line} 行 - 欄位 {field}：{message}',
    'group.delete.modal.conflict.error.message': '您無法刪除此群組',
    'group.delete.modal.conflict.error.description': '請在刪除此群組前重新指派賓客',
    'group.delete.modal.conflict.export.button': '匯出賓客',
    'groups.export.student.customerId': '客戶識別碼',
    'groups.export.student.email': '電子郵件',
    'groups.export.student.password': '密碼',
    'groups.export.student.firstName': '名',
    'groups.export.student.lastName': '姓',
    'groups.export.student.phone': '電話',
    'groups.export.student.piCode': 'PIN 碼',
    'groups.export.student.badgeNumber': '徽章號碼',
    'groups.export.student.studentNumber': '賓客號碼',
    'groups.export.student.group': '群組',
    'groups.export.student.section': '區段',
    'groups.export.student.subSection': '子區段',
    'groups.export.student.accountType': '帳戶類型',
    'groups.export.student.tariffCode': '費率代碼',
    'groups.export.student.grantCode': '補貼代碼',
    'groups.export.student.entranceFeeCode': '入場費代碼',
    'groups.export.student.pricingRuleCode': '費率制度',
    'groups.export.student.ewalletOverdraftAmount': '自訂透支金額',
    'groups.export.student.exitDate': '封存日期',
    'groups.export.student.accessFrom': '到達日期',
    'groups.export.student.accessUntil': '離開日期',
    'groups.export.student.inactive': '非啟用',
    'groups.export.student.active': '啟用',
    'groups.export.student.yes': '是',
    'groups.export.student.no': '否',
    'section.tableCard.title': '區段',
    'section.tableCard.subtitle': '定義您的賓客按區段分組的可能性，並關聯各種費率制度。',
    'section.tableCard.action': '+ 建立新區段',
    'section.name': '區段',
    'group.warning.section_name_already_exist.message': '區段名稱已存在。',
    'group.warning.section_name_already_exist.description': '請提出新的區段名稱，或將所選費率制度關聯至現有區段。',
    'section.modal.conflict.error.message': '您無法修改此區段',
    'section.modal.conflict.error.description': '請在修改此區段前重新指派賓客',
    'section.delete.modal.conflict.error.message': '您無法刪除此區段',
    'section.delete.modal.conflict.error.description': '請在刪除此區段前重新指派賓客',
    'subsection.tableCard.title': '子區段',
    'subsection.tableCard.subtitle': '定義您的賓客按子區段分組的可能性，並關聯各種費率制度。',
    'subsection.tableCard.action': '+ 建立新子區段',
    'subsection.name': '子區段',
    'group.warning.sub_section_name_already_exist.message': '子區段名稱已存在。',
    'group.warning.sub_section_name_already_exist.description':
        '請提出新的子區段名稱，或將所選費率制度關聯至現有子區段。',
    'subsection.modal.conflict.error.message': '您無法修改此子區段',
    'subsection.modal.conflict.error.description': '請在修改此子區段前重新指派賓客',
    'subsection.delete.modal.conflict.error.message': '您無法刪除此子區段',
    'subsection.delete.modal.conflict.error.description': '請在刪除此子區段前重新指派賓客',
    'options.main': '一般',
    'options.educationMode': '集體餐飲',
    'options.birthdate': '生日',
    'options.tripAdvisorUsername': 'TripAdvisor 使用者名稱',
    'options.advancedSecurityRules': '啟用 12 字元密碼',
    'options.optIn': 'Opt-in',
    'options.productionDeclaration': '生產申報',
    'options.grantsAndEntranceFee': '補貼與入場費',
    'options.pinCodeDoubleAuth': '使用 PIN 碼保護終端機上的驗證',
    'options.charlemagneExport': '匯出 Charlemagne 資料',
    'options.handleBadgeForChar': '徽章搜尋時僅處理最後 4 個字元',
    'options.autoBilling': '啟用「自動計費」模組',
    'options.linkProductImageBySku': '自動連結名稱包含商品 SKU 的圖片（匯入時）',
    'options.externalIdsMapping': '啟用 ID 轉換',
    'options.ewalletAutoReload': '啟用 E-wallet 自動儲值（透過 Stripe）',
    'options.foodCourt': 'CEL v2 - Food Court',
    'options.foodCourtMode': '啟用 Food Court 模式',
    'options.shuffleRestaurants': '隨機顯示餐廳順序',
    'options.enableSodexoDictionary': '啟用 Sodexo 字典',
    'options.enableOrderDetailV2': '啟用訂單詳情 V2',
    'options.usePickupPoints': '啟用取餐點',
    'options.linkProductSkuToExternalMapping': '自動將商品 SKU 連結至 ID 轉換',
    'options.linkStudentNumberToExternalMapping': '自動將賓客號碼連結至 ID 轉換',
    'options.multiRestaurant': '終端機 - 多餐廳',
    'options.multiRestaurantMode': '啟用多餐廳模式',
    'options.multiRestaurantModeMainRestaurant': '主餐廳',
    'options.multiRestaurantModeMainUser': '終端機使用者',
    'options.multiRestaurantModeAssignedRestaurants': '已指派餐廳',
    'options.enableLinkingMenuToPosAndWeb': '允許將菜單與收銀機及網路關聯',
    'options.configureSodexoConsumerTransaction': '啟用 Sodexo consumerTransactions Webhook',
    'options.families': '家族',
    'options.families.empty': '無家族',
    'options.families.new': '新家族',
    'options.families.namePlaceholder': '名稱',
    'options.families.add': '新增',
    'options.families.delete': '刪除',
    'options.families.deleteTitle': '確認刪除家族 {name}',
    'options.families.deleteConfirmation': '確定要刪除家族「{name}」嗎？',
    'brandInfo.title': '資訊',
    'brandInfo.ewalletOverdraft.title': 'E-wallet 透支',
    'brandInfo.ewalletOverdraft.description': '允許客戶在其 E-wallet 上持有負餘額，最高至指定金額。',
    'brandInfo.ewalletOverdraft.enable': '啟用 E-wallet 透支',
    'brandInfo.ewalletOverdraft.amount': '最高透支金額',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0.00',
    'brandInfo.ewalletOverdraft.cannotDisable': '無法停用透支：{count} 位客戶目前已啟用後付款。',
    'restaurant.search': '搜尋餐廳',
    'restaurant.name': '餐廳名稱',
    'restaurant.options.main': '一般',
    'restaurant.options.includeDepositsInTurnover': '將押金計入營業額',
    'adminBanner.message': '您已登入為',
    'adminBanner.backToAdmin': '切換回管理員',
    'auto.billing.buttons.referential': '參照資料',
    'auto.billing.buttons.billing': '計費申請',
    'auto.billing.request.card.title': '計費申請',
    'auto.billing.request.card.subtitle':
        '自動計費模組可整合所有指派給第三方的賓客消費，並根據設定規則計算每個第三方的營業額和已收款項。',
    'auto.billing.request.wizard.validate': '完成',
    'auto.billing.request.wizard.title': '提出計費申請',
    'auto.billing.request.card.action': '提出計費申請',
    'auto.billing.request.popup.confirm.title': '您即將申請自動計費',
    'auto.billing.request.popup.confirm.text': '請確認此操作？',
    'auto.billing.request.popup.success.title': '您的計費申請已確認',
    'auto.billing.request.popup.fail.title': '錯誤',
    'auto.billing.request.popup.pending.title': '處理中...',
    'auto.billing.request.popup.success.cancel': '關閉',
    'auto.billing.request.popup.success.text': '您的計費申請已成功提交',
    'auto.billing.request.popup.fail.text': '發生錯誤，請稍後再試',
    'auto.billing.request.preview.emptyMessage': '所選期間內無銷售記錄',
    'auto.billing.request.preview.errorUndefinedReferential': '此品牌未定義任何參照資料',
    'auto.billing.request.preview.error': '發生錯誤，請稍後再試',
    'auto.billing.request.preview.code': '代碼',
    'auto.billing.request.preview.label': '描述',
    'auto.billing.request.preview.quantity': '數量',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': '未含稅單價',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': '未含稅金額',
    'auto.billing.request.preview.totalTax': '稅額',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': '含稅總金額',
    'auto.billing.request.preview.cdpf': '發行方 CDPF',
    'auto.billing.request.preview.clientCode': '客戶代碼',
    'auto.billing.request.preview.clientLabel': '客戶名稱',
    'auto.billing.request.preview.billingPeriod': '計費期間',
    'auto.billing.request.preview.billingPeriod.from': '從',
    'auto.billing.request.preview.billingPeriod.to': '至',
    'auto.billing.request.preview.invoiceSelector.GROUP': '群組',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': '帳戶類型',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': '費率制度',
    'auto.billing.request.preview.total.amountWithTaxIncluded': '含稅總計',
    'auto.billing.request.preview.total.amountWithTaxExcluded': '未含稅總計',
    'auto.billing.request.preview.total.tax': '稅額總計',
    'auto.billing.request.filter.title': '篩選條件',
    'auto.billing.request.filter.entities.title': '選擇計費實體',
    'auto.billing.request.filter.entities.all': '所有實體',
    'auto.billing.request.filter.restaurants.title': '選擇餐廳',
    'auto.billing.request.filter.dropDown.errorMessage': '您至少必須選擇一個選項',
    'auto.billing.request.filter.restaurants.all': '所有餐廳',
    'auto.billing.request.filter.pricingRules.title': '費率方案',
    'auto.billing.request.filter.pricingRules.all': '所有費率制度',
    'auto.billing.request.filter.pricingRules.noPricingRules': '無費率制度',
    'auto.billing.request.accountPaymentTypes.title': '管理模式',
    'auto.billing.request.filter.accountPaymentTypes.all': '所有管理模式',
    'auto.billing.request.accountPaymentTypes.CASH': '現金',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': '預付款',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': '後付款',
    'auto.billing.request.history.table.emptyMessage': '尚無計費申請記錄',
    'auto.billing.request.history.table.date': '產生日期',
    'auto.billing.request.history.table.period': '期間',
    'auto.billing.request.history.table.user': '使用者',
    'auto.billing.request.history.table.previewButton': '預覽',
    'auto.billing.request.history.table.downloadButton': '下載',
    'auto.billing.referential.serviceCodes.card.title': '服務代碼',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': '計費實體',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ 新增實體',
    'auto.billing.referential.billingEntities.form.create.title': '建立計費實體',
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': '計算模式',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': '標籤',
    'auto.billing.referential.billingEntities.table.code': '代碼',
    'auto.billing.referential.billingEntities.table.groups': '關聯群組',
    'auto.billing.referential.billingEntities.table.groupingBy': '分組依據',
    'auto.billing.referential.billingEntities.table.emptyMessage': '此品牌未定義任何計費實體',
    'auto.billing.referential.billingEntities.form.label.title': '標籤',
    'auto.billing.referential.billingEntities.form.code.title': '代碼',
    'auto.billing.referential.billingEntities.form.code.text': '代碼',
    'auto.billing.referential.billingEntities.form.groups.text': '目標',
    'auto.billing.referential.billingEntities.form.groupingBy.title': '分組類型',
    'auto.billing.referential.billingEntities.form.label.subtitle': '建立計費實體',
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': '費率制度',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': '無分組',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': '群組',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': '管理模式',
    'auto.billing.referential.billingEntities.errors.duplicate.code': '代碼 {code} 已與計費實體 {entity} 關聯',
    'auto.billing.referential.billingEntities.errors.duplicate.group': '計費實體 {entity} 已具有以下群組：{groups}',
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': '代收款項',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': '按入場費等級計費',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': '按固定費用大量計費',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': '代收款項',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': '代碼',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': '增值稅',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ 新增代碼',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': '未填寫任何代碼',
    'auto.billing.referential.accountingCostCompute.constantCost': '按固定費用大量計費',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': '按區間計費',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': '按餐位計費',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': '固定費用',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': '按餐位',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': '區間從',
    'auto.billing.referential.accountingCostCompute.modal.to': '至',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': '固定費用',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': '按餐位',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': '計費模式',
    'auto.billing.referential.accountingCostCompute.modal.title': '新增區間',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin': '最大區間必須大於最小值',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection': '此區間與 [{from} - {to}] 重疊',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': '值必須為正數',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ 新增區間',
    'auto.billing.referential.accountingCostCompute.amount': '含稅金額',
    'auto.billing.filters.entity': '計費實體',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX 群組代碼',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': '餐位數量',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': '計算模式',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': '值',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage': '此計費模式未定義任何區間',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': '至',
    'route.brands': '品牌',
    'route.brandInfo': '資訊',
    'route.brandInfoV2': '資訊',
    'route.brandMedias': '媒體',
    'route.configIOPay': 'Adyen 設定',
    'route.configEdenred': 'Edenred 設定',
    'route.configPaygreen': 'Paygreen 設定',
    'route.integrations': '整合',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': '補貼與入場費',
    'route.options': '選項',
    'route.brandHistory': '歷史記錄',
    'route.groups': '層級結構',
    'route.brandChannels': '頻道',
    'route.brandMenus': '菜單',
    'route.brandMenu': '資訊',
    'route.brandRestaurants': '餐廳',
    'route.brandUsers': '使用者',
    'route.billing': '我的計費空間',
    'route.home': '首頁',
    'route.pricingRule': '費率制度',
    'route.logout': '登出',
    'route.configUbereats': 'Uber Eats 整合',
    'route.configDeliveroo': 'Deliveroo 整合',
    'route.configDeliverect': 'Deliverect 整合',
    'route.configCrous': 'Crous 整合',
    'route.createGrant': '新補貼',
    'route.grant': '補貼',
    'route.createEntranceFee': '新入場費',
    'route.entranceFee': '入場費',
    'route.createPricingRule': '新費率規則',
    'route.analytics': '概覽',
    'route.restaurantIntegration': '整合',
    'route.autoBilling': '自動計費',
    'route.autoBilling.referential': '參照資料',
    'route.autoBilling.request': '計費申請',
    'route.autoBilling.referential.createEntity': '建立計費實體',
    'route.autoBilling.referential.editEntity': '編輯計費實體',
    'route.orders': '訂單',
    'route.orderDetails': '訂單詳情',
    'route.restaurantInfo': '資訊',
    'route.restaurantChannels': '頻道',
    'route.restaurantUsers': '使用者',
    'route.restaurantMenus': '菜單',
    'route.restaurantMenu': '資訊',
    'route.restaurantTickets': '收據',
    'route.restaurantMedias': '媒體',
    'route.restaurantIntegrations': '整合',
    'route.restaurantPayments': '付款方式',
    'route.restaurantOptions': '選項',
    'route.restaurantPricingRevaluation': '價格重估',
    'route.createGroup': '新群組',
    'route.createSection': '新區段',
    'route.createSubSection': '新子區段',
    'route.editGroup': '編輯群組',
    'route.editSection': '編輯區段',
    'route.editSubSection': '編輯子區段',
    'route.adminTools': '管理員工具',
    'route.menus': '菜單',
    'route.menuOperations': '菜單操作',
    'route.posLayout': 'POS 按鍵配置',
    'route.categories': '類別',
    'route.products': '商品',
    'route.steps': '步驟',
    'route.tags': '標籤',
    'route.functions': '功能',
    'route.brandCustomer': '客戶',
    'route.brandOrders': '訂單',
    'route.crossSelling': 'Cross-selling',
    'route.tableLayout': '桌位配置',
    'route.tableLayout.room': '廳室',
    'route.salesSummary': '財務摘要',
    'route.tickets': '收據',
    'route.reportStatus': '報告狀態',
    'route.pos': 'POS',
    'route.posConfiguration': '設定',
    'route.posDevices': '收銀機',
    'route.posAccess': '角色與權限',
    'route.posAccess.users': '收銀機使用者',
    'route.posAccess.roles': '收銀機角色',
    'route.posAccess.groups': '收銀機群組',
    'route.accessFlags': '授權',
    'route.userRestaurants': '關聯餐廳',
    'route.updateUserPassword': '修改密碼',
    'route.userInfo': '資訊',
    'route.badgeReader': '徽章讀卡機',
    'route.posDeviceInformation': '資訊',
    'route.posDeviceConfiguration': '設定',
    'route.posDeviceAdditionalDevices': '周邊設備',
    'route.posDeviceArchives': '財務檔案',
    'route.posDeviceFeatures': '選項',
    'route.posDevicePreferences': '偏好設定',
    'route.posDeviceCatalogHistory': '目錄歷史記錄',
    'route.listCustomers': '客戶',
    'route.customerSettings': '參數',
    'route.customerPricingRules': '費率制度',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': '取餐點',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': '營運區域',
    'route.createBrandWebhook': '建立 Webhook',
    'route.editBrandWebhook': '編輯 Webhook',
    'operationZones.page.title': '營運區域',
    'operationZones.page.description': '定義您品牌營運的地區。必須為參考法律實體指定主要區域。',
    'operationZones.emptyState': '未選擇任何區域',
    'operationZones.emptyState.description': '請從下方清單中選擇一個或多個地區以定義您的營運區域。',
    'operationZones.availableTerritories': '可用地區',
    'operationZones.selectedCount': '已選 {count} 個',
    'operationZones.solution': '解決方案',
    'operationZones.warning.title': '設定不完整',
    'operationZones.warning.description':
        '{count, plural, one {{count} 個已選區域需要設定才能投入運作。} other {{count} 個已選區域需要設定才能投入運作。}}',
    'operationZones.warning.hint': '請透過「設定」按鈕完善法律和技術資訊。',
    'operationZones.immutabilityNotice':
        '餐廳建立後，營運區域無法修改。如有需要，請<supportLink>聯絡支援</supportLink>。',
    'operationZones.primaryZone': '主要區域',
    'operationZones.setPrimary.disabled': '請先設定此區域，再將其設為主要區域',
    'operationZones.cannotRemoveLastZone': '餐廳必須至少有一個營運區域',
    'operationZones.primaryBadge': '主要',
    'operationZones.secondaryZonesActive': '+ {count} 個{count, plural, one {次要活躍區域} other {次要活躍區域}}',
    'operationZones.configure': '設定',
    'operationZones.viewVatRates': '查看稅率',
    'operationZones.toConfigure': '待設定',
    'operationZones.entity': '實體',
    'operationZones.vat': '增值稅',
    'operationZones.posConfig': 'POS 設定',
    'operationZones.notFilled': '未填寫',
    'operationZones.pending': '待處理',
    'operationZones.initialized': '已初始化',
    'operationZones.configured': '已設定',
    'operationZones.noPosDevice': '請先建立 POS 再設定此區域',
    'operationZones.configModal.title': '設定：{zoneName}',
    'operationZones.configModal.subtitle': '法律和稅務參數（{code}）',
    'operationZones.configModal.entitySection': '實體資訊',
    'operationZones.configModal.socialReason': '公司名稱',
    'operationZones.configModal.address': '地址',
    'operationZones.configModal.postalCode': '郵遞區號',
    'operationZones.configModal.city': '城市',
    'operationZones.configModal.vatNumber': '增值稅號碼',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': '儲存',
    'operationZones.configModal.socialReason.placeholder': '例如：Restaurant SARL',
    'operationZones.configModal.address.placeholder': '123 Rue de la ...',
    'operationZones.configModal.postalCode.placeholder': '75000',
    'operationZones.configModal.city.placeholder': 'Paris',
    'operationZones.configModal.vatNumber.placeholder': '例如：FR 12 345678901',
    'operationZones.configModal.siret.placeholder': '例如：522 296...',
    'operationZones.multiProvider': '任選',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': '例如：B12345678',
    'operationZones.configModal.fiscalRepresentative': '稅務代表',
    'operationZones.configModal.fiscalRepresentative.placeholder': '稅務代表姓名',
    'operationZones.configModal.fiscalIdCode': '稅務識別代碼',
    'operationZones.configModal.fiscalIdCode.placeholder': '例如：RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': '增值稅號碼（BTW）',
    'operationZones.configModal.vatNumberBtw.placeholder': '例如：BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': '企業編號',
    'operationZones.configModal.enterpriseNumber.placeholder': '例如：0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': '例如：12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': '例如：001234567000045',
    'operationZones.configModal.selectProvider': '選擇合規模式',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription': '收銀機稅務合規中介軟體',
    'operationZones.configModal.noIntegration': '無整合',
    'operationZones.configModal.noIntegrationDescription': '不設定任何稅務中介軟體',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': '法國稅務合規認證',
    'operationZones.configModal.boiteNoire': 'Boîte Noire',
    'operationZones.configModal.boiteNoireDescription': '比利時稅務合規模組',
    'operationZones.configModal.middlewareSection': '中介軟體設定（Fiskaltrust）',
    'operationZones.configModal.cashboxId': 'Cashbox ID',
    'operationZones.configModal.cashboxId.placeholder': '例如：a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'Access Token',
    'operationZones.configModal.accessToken.placeholder': '例如：AZE123...',
    'operationZones.configModal.back': '返回',
    'operationZones.deactivate.title': '停用營運區域',
    'operationZones.deactivate.message':
        '確定要停用此營運區域嗎？所有已設定的資訊（法律實體、稅務、POS 設定）將會遺失。',
    'adminTools.confirmModal.description': '確定要觸發此操作嗎？',
    'brand.adminTools.editCustomerLoyalties.title': '為此品牌的客戶新增/移除 IO 忠誠點數',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'nom@domaine.com 或 A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 等於 4 歐元',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': '客戶的電子郵件或忠誠卡號碼',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': '金額',
    'brand.adminTools.editCustomerLoyalties.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editCustomerLoyalties.form.success': '腳本已成功執行。',
    'brand.adminTools.unarchiveCustomer.title': '取消封存賓客',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': '要取消封存的 CustomerId',
    'brand.adminTools.unarchiveCustomer.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.unarchiveCustomer.form.success': '腳本已成功執行。',
    'brand.adminTools.deleteTransaction.title': '刪除交易',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': '要刪除的交易',
    'brand.adminTools.deleteTransaction.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.deleteTransaction.form.success': '腳本已成功執行。',
    'brand.adminTools.addUserToRestaurant.title': '將餐廳帳戶指派給同品牌的另一家餐廳',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'exemple@restaurant.com',
    'brand.adminTools.addUserToRestaurant.form.email': '帳戶電子郵件',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': '要指派的餐廳 RestaurantId',
    'brand.adminTools.addUserToRestaurant.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.addUserToRestaurant.form.success': '腳本已成功執行。',
    'brand.adminTools.deleteUnassignedImages.title': '刪除此品牌的未使用圖片',
    'brand.adminTools.deleteUnassignedImages.description1': '用於刪除所有未使用圖片的腳本（例如已刪除商品/菜單的圖片）',
    'brand.adminTools.deleteUnassignedImages.description2':
        '建議在執行此腳本前先刪除品牌及其餐廳所有不需要的菜單，以確保清理效果。',
    'brand.adminTools.deleteUnassignedImages.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.deleteUnassignedImages.form.success': '腳本已成功執行。',
    'brand.adminTools.importGeojsonPolygon.title': '將 geoJson 匯入為配送區域',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': '要建立的配送區域名稱',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': '輸入 geoJson 的多邊形座標',
    'brand.adminTools.importGeojsonPolygon.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.importGeojsonPolygon.form.success': '腳本已成功執行。',
    'brand.adminTools.deleteCustomer.title': '刪除客戶/賓客',
    'brand.adminTools.deleteCustomer.description1':
        '輸入您要刪除的 customerId（可輸入多個 customerId，以逗號分隔，不加空格，例如：1234567,1234568,1234569）',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': '要刪除的 CustomerId',
    'brand.adminTools.deleteCustomer.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.deleteCustomer.form.success': '腳本已成功執行。',
    'brand.adminTools.razCustomer.title': '將客戶/賓客歸零',
    'brand.adminTools.razCustomer.description1':
        '輸入您要將 E-Wallet 餘額歸零的 customerId（可輸入多個 customerId，以逗號分隔，不加空格，例如：1234567,1234568,1234569）',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': '要歸零的 CustomerId（以逗號分隔）',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        '要歸零的 BrandId（如果輸入 brandId，此品牌所有後付款客戶將被歸零，上方 customerId 欄位將被忽略）',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date': '歸零應用日期（時間為早上 5 點），若要立即歸零請留空',
    'brand.adminTools.razCustomer.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.razCustomer.form.success': '腳本已成功執行。',
    'brand.adminTools.copySchedules.title': '將取餐或 CEL 時間表從一家餐廳複製到一家或多家其他餐廳',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup 或 cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': '要複製的時間表類型（輸入 pickup 或 cel）',
    'brand.adminTools.copySchedules.form.idSource': '來源 RestaurantId',
    'brand.adminTools.copySchedules.form.idsDestination':
        '目標 RestaurantId（可輸入多個 restaurantId，以逗號分隔，不加空格，例如：901,902,903）',
    'brand.adminTools.copySchedules.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.copySchedules.form.success': '腳本已成功執行。',
    'brand.adminTools.changeOrderDateInReport.title': '編輯報告中的訂單日期（這也會更改交易日期）',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId': '訂單號碼（orderId），可以逗號分隔',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': '日',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': '例如：14',
    'brand.adminTools.changeOrderDateInReport.form.month': '月',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': '例如：7',
    'brand.adminTools.changeOrderDateInReport.form.year': '年',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': '例如：2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': '時',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': '例如：10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': '分',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': '例如：35',
    'brand.adminTools.changeOrderDateInReport.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.changeOrderDateInReport.form.success': '腳本已成功執行。',
    'brand.adminTools.editPasswordExpiresAt.title': '強制品牌/賓客變更密碼',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force 或 cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword': '強制變更密碼（force）或取消密碼變更（cancel）',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': '目標品牌',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        '目標賓客，可輸入多個 customerId，以逗號分隔，不加空格，例如：123456,234567,345678）。留空可目標整個品牌',
    'brand.adminTools.editPasswordExpiresAt.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editPasswordExpiresAt.form.success': '腳本已成功執行。',
    'brand.adminTools.editProductSkuFromProductId.title': '從 Excel 檔案編輯多個商品的 SKU',
    'brand.adminTools.editProductSkuFromProductId.description': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.editProductSkuFromProductId.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editProductSkuFromProductId.form.success': '腳本已成功執行。',
    'brand.adminTools.importProductInMenu.title': '將商品匯入現有菜單',
    'brand.adminTools.importProductInMenu.description': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.importProductInMenu.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.importProductInMenu.form.success': '腳本已成功執行。',
    'brand.adminTools.importProductFromSku.title': '依 SKU 編輯並匯入商品',
    'brand.adminTools.importProductFromSku.description1':
        '使用此 {metabaseLink} 取得菜單中的商品清單，您可以編輯或新增商品（新商品的 SKU 非必填）。',
    'brand.adminTools.importProductFromSku.description1bis':
        '請勿編輯現有商品的 SKU，這是商品的唯一識別碼。請勿更改欄位名稱',
    'brand.adminTools.importProductFromSku.description2': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.importProductFromSku.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.importProductFromSku.form.success': '腳本已成功執行。',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': '來源菜單的 menuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': '來源菜單的 MenuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': '目標菜單的 menuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': '目標菜單的 MenuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '（選填）',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': '類別篩選',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '（選填）',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': '標籤篩選',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': '將商品從一個菜單複製到另一個菜單',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        '輸入來源菜單和目標菜單的 menuId。您也可以按類別和/或標籤篩選商品，僅複製特定商品。',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2': '請注意，外部參考和步驟將不會被複製',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        '只有當目標菜單與來源菜單在同一家餐廳，或來源菜單在品牌層級而目標菜單在同品牌的餐廳層級時，圖片才會被複製',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': '腳本已成功執行。',
    'brand.adminTools.importBackofficeUsers.title': '匯入後台使用者',
    'brand.adminTools.importBackofficeUsers.description': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.importBackofficeUsers.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.importBackofficeUsers.form.success': '腳本已成功執行。',
    'brand.adminTools.editProductInfoFromProductId.title': '從 Excel 檔案編輯商品',
    'brand.adminTools.editProductInfoFromProductId.description1':
        '使用此 {metabaseLink} 取得菜單中的商品清單，填寫專用編輯欄位後上傳檔案。（請勿更改欄位名稱）',
    'brand.adminTools.editProductInfoFromProductId.description2': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.editProductInfoFromProductId.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editProductInfoFromProductId.form.success': '腳本已成功執行。',
    'brand.adminTools.editStepInfoFromStepId.title': '從 Excel 檔案編輯步驟',
    'brand.adminTools.editStepInfoFromStepId.description0':
        '此腳本允許批量修改步驟的名稱、參考和標籤，不修改商品清單。',
    'brand.adminTools.editStepInfoFromStepId.description1':
        '使用此 {metabaseLink} 取得菜單中的步驟清單，填寫專用編輯欄位後上傳檔案。（請勿更改欄位名稱）',
    'brand.adminTools.editStepInfoFromStepId.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editStepInfoFromStepId.form.success': '腳本已成功執行。',
    'brand.adminTools.editProductPriceInAdminTools.title': '從 Excel 檔案編輯商品價格（步驟內外的商品）',
    'brand.adminTools.editProductPriceInAdminTools.description1':
        '使用此 {metabaseLink} 取得菜單中的商品清單，填寫新價格欄位後上傳檔案。（請勿更改欄位名稱）',
    'brand.adminTools.editProductPriceInAdminTools.description2': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.editProductPriceInAdminTools.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editProductPriceInAdminTools.form.success': '腳本已成功執行。',
    'brand.adminTools.editProductTagFromProductId.title': '從 Excel 檔案為多個商品新增一個或多個標籤',
    'brand.adminTools.editProductTagFromProductId.description': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.editProductTagFromProductId.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.editProductTagFromProductId.form.success': '腳本已成功執行。',
    'brand.adminTools.makeEwalletTransaction.title': '從 Excel 檔案進行 E-Wallet 交易',
    'brand.adminTools.makeEwalletTransaction.description': '將 {fileTemplate} 下載至您的電腦',
    'brand.adminTools.makeEwalletTransaction.form.error': '執行腳本時發生錯誤。',
    'brand.adminTools.makeEwalletTransaction.form.success': '腳本已成功執行。',
    'brand.adminTools.bulkUploadDualScreenImage.title': '批量上傳雙螢幕圖片至品牌所有收銀機',
    'brand.adminTools.bulkUploadDualScreenImage.description':
        '上傳圖片（PNG 或 JPG）並輸入 brandId。圖片將套用至品牌所有收銀機。',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': '輸入 Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': '圖片已上傳至所有收銀機。',
    'brand.adminTools.transformGuestFile.title': '將從新網站取得的賓客資料轉換為 Innovorder 格式',
    'brand.adminTools.transformGuestFile.fileFormat': '原始檔案格式',
    'brand.adminTools.transformGuestFile.form.success': '檔案已成功轉換',
    'brand.adminTools.transformGuestFile.form.url': '點擊此處下載檔案',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': '將 IO 銷售數據同步至 SI Sodexo',
    'brand.adminTools.generateSalesReport.description':
        '將特定餐廳的 IO 銷售數據同步至 SI Sodexo（如果使用期間，將同步所選期間的銷售數據）',
    'brand.adminTools.generateSalesReport.form.checkbox': '使用期間',
    'brand.adminTools.generateSalesReport.form.restaurant': '選擇餐廳',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title': '將商品 SKU 連結至外部 ID 映射',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        '為特定菜單的內部 productId 和商品 SKU 建立映射',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': '餐廳',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': '菜單',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': '腳本已成功執行。',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error': '執行腳本時發生錯誤。',
    'spotlight.search.placeholder': '您想做什麼？',
    'spotlight.section.suggestion': '建議',
    'spotlight.section.history': '歷史記錄',
    'spotlight.context.brand': '品牌',
    'spotlight.context.restaurant': '餐廳',
    'spotlight.error.noHistory': '您的歷史記錄中尚無符合條件的網址',
    'orderList.title': '訂單',
    'orderList.subtitle': '查詢您的客戶和親密朋友的訂單',
    'orderList.filters.allRestaurants': '所有餐廳',
    'orderList.filters.restaurantHeader': '我的餐廳',
    'orderList.filters.restaurantPlaceholder': '搜尋餐廳',
    'orderList.filters.dateRange.lastXdays': '最近 {days} 天',
    'orderList.filters.dateRange.custom': '自訂',
    'orderList.generation_history': '生成歷史',
    'orderList.export': '匯出',
    'orderList.generate': '生成',
    'orderList.export.title': '匯出',
    'orderList.export.selectOneDay': '選擇一天',
    'orderList.export.selectPeriod': '選擇期間',
    'orderList.export.format': '選擇匯出格式',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': '您最多只能選擇 31 天',
    'orderList.export.presetDate.currentWeek': '本週',
    'orderList.export.presetDate.currentMonth': '本月',
    'orderList.export.presetDate.lastMonth': '上個月',
    'orderList.export.presetDate.chooseDate': '請選擇一個期間',
    'orderList.export.includeOrderStates': '包含各訂單狀態',
    'order.field.ticketNumber': '票號',
    'order.field.status': '狀態',
    'order.field.restaurant': '餐廳',
    'order.field.channel': '通路',
    'order.field.customerName': '姓名',
    'order.field.customerNameMassCatering': '用餐者姓名',
    'order.field.badgeNumber': '徽章號碼',
    'order.field.phone': '電話號碼',
    'order.field.pricingRule': '定價方案',
    'order.field.pricingRuleInOrder': '已套用定價方案',
    'order.field.company': '公司',
    'order.field.orderId': '訂單號碼',
    'order.field.consumptionMode': '用餐模式',
    'order.field.orderDate': '訂單日期',
    'order.field.expectedDate': '預計送達日期',
    'order.field.ticketDate': '票券日期',
    'order.field.totalWithVat': '含稅總計',
    'order.field.turnoverWithVat': '含稅營業額',
    'order.field.paymentMethod': '付款方式',
    'order.field.paymentStatus': '付款狀態',
    'order.field.paymentAmount': '付款金額',
    'order.status.PAID': '已付款',
    'order.status.CANCELLED': '已取消',
    'order.status.VALIDATED': '已確認',
    'order.status.PAID_CANCELLED': '已付款（已取消）',
    'order.status.CONTRA_ENTRY': '對沖分錄',
    'order.status.INCOHERENT': '訂單不一致',
    'order.channel.': '未知',
    'order.channel.1': '自助點餐機',
    'order.channel.2': 'CEL',
    'order.channel.5': '收銀機',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': '外送',
    'order.consumptionMode.2': '外帶',
    'order.consumptionMode.3': '內用',
    'order.consumptionMode.4': '得來速',
    'order.webPaymentStatus.PAYMENT_OK': '已付款',
    'order.webPaymentStatus.PAYMENT_PENDING': '未付款',
    'order.webPaymentStatus.PAYMENT_REFUSED': '付款被拒',
    'order.webPaymentStatus.PAYMENT_REFUNDED': '已退款',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': '現金',
    'order.paymentMethod.Change': '找零',
    'order.paymentMethod.Check': '支票',
    'order.paymentMethod.CreditCard': '信用卡',
    'order.paymentMethod.CreditNote': '信用票據',
    'order.paymentMethod.CreditNoteIssued': '已開具信用票據',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': '電子餐券',
    'order.paymentMethod.EWallet': '電子錢包',
    'order.paymentMethod.ExternalPayment': '外部付款',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': '餐券',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': '線上信用卡',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': '轉帳',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': '其他',
    'order.paymentMethod.Unknown2': '其他 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': '請聯絡客服以處理訂單',
    'orderDetail.title.1': '自助點餐機',
    'orderDetail.title.2': '線上訂單',
    'orderDetail.title.5': '收銀機',
    'orderDetail.title.8': '自動販賣機',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': '對沖分錄訂單',
    'orderDetail.status.PAID': '收款',
    'orderDetail.status.VALIDATED': '帳單',
    'orderDetail.status.CANCELLED': '已取消',
    'orderDetail.tabStatus.PAID': '已付款銷售',
    'orderDetail.tabStatus.VALIDATED': '已確認購物車',
    'orderDetail.tabStatus.CANCELLED': '取消',
    'orderDetail.paymentStatus.PAID': '已付款',
    'orderDetail.paymentStatus.CANCELLED': '已取消',
    'orderDetail.paymentStatus.REFUNDED': '已退款',
    'orderDetail.shift.default': '預設班次',
    'orderDetail.header.guestNumber': '用餐人數：',
    'orderDetail.header.currency': '貨幣：',
    'orderDetail.header.orderedAt': '訂購時間',
    'orderDetail.header.deliverAt': '預計送達時間',
    'orderDetail.header.deliverAtRange': '預約時段：',
    'orderDetail.header.status': '狀態',
    'orderDetail.header.payment': '付款',
    'orderDetail.header.table': '桌號',
    'orderDetail.kpi.date': '{date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': '{start, date, ::HHmm} 至 {end, date, ::HHmm}',
    'orderDetail.ticketInfo': '訂單詳細資訊',
    'orderDetail.comment': '備註',
    'orderDetail.userName': '客戶姓名',
    'orderDetail.taxInfo': '稅務詳細資訊',
    'orderDetail.paymentInfo': '付款方式',
    'orderDetail.customerInfo': '客戶資訊',
    'orderDetail.deliveryInfo': '外送',
    'orderDetail.loyaltyInfo': '忠誠度',
    'orderDetail.posInfo': '收銀機資訊',
    'orderDetail.transactionInfo': '交易詳細資訊',
    'orderDetail.orderPhotos': '訂單相關照片',
    'orderDetail.customer.name': '名字與姓氏',
    'orderDetail.customer.email': '電子郵件',
    'orderDetail.customer.phone': '電話號碼',
    'orderDetail.customer.badgeNumber': '徽章號碼',
    'orderDetail.customer.pricingRule': '定價方案',
    'orderDetail.customer.pricingRuleAssigned': '已分配定價方案',
    'orderDetail.customer.group': '群組',
    'orderDetail.customer.section': '部門',
    'orderDetail.customer.subSection': '子部門',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': '訂單前電子錢包餘額',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': '訂單後電子錢包餘額',
    'orderDetail.Pos.restaurant': '餐廳',
    'orderDetail.Pos.seller': '操作員',
    'orderDetail.Pos.deviceName': '收銀機名稱',
    'orderDetail.Pos.deviceId': 'POS ID',
    'orderDetail.action.text': '訂單操作',
    'orderDetail.action.cancel': '取消',
    'orderDetail.action.refund': '退款',
    'orderDetail.action.cancelWithContraEntry': '取消訂單（對沖分錄）',
    'orderDetail.cancel.title.reason': '取消訂單',
    'orderDetail.cancel.title.manualPaymentMethod': '退款付款方式',
    'orderDetail.cancel.text1': '如有需要，您可以取消客戶的訂單。',
    'orderDetail.cancel.text2': '您必須在下方選擇取消原因。',
    'orderDetail.cancel.text3': '若原因不在清單中，請點選「其他」。',
    'orderDetail.cancel.text4': '您選擇的原因將透過電子郵件發送給客戶。',
    'orderDetail.cancel.text5': '已扣除的產品數量將返回庫存。',
    'orderDetail.cancel.text6': '您可以選擇退款的付款方式。',
    'orderDetail.cancel.text7': '⚠️ 請務必以實體方式退款給客戶，以避免帳目差異。',
    'orderDetail.cancel.reason.description.label': '自由欄位（選填）',
    'orderDetail.cancel.reason.placeholder': '選擇取消原因',
    'orderDetail.cancel.reason.description.placeholder': '最多 250 個字元',
    'orderDetail.cancel.manualPaymentMethod.placeholder': '選擇付款方式',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': '無法完成訂單',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': '訂購錯誤',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER': '客戶不滿意（數量不返回庫存）',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': '客戶未到場',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': '客戶已離開',
    'orderDetail.cancel.reason.LEARNING_MODE': '培訓',
    'orderDetail.cancel.reason.TECHNICAL': '技術錯誤',
    'orderDetail.cancel.reason.OTHER': '其他...',
    'orderDetail.cancel.manualPaymentMethod.Cash': '現金',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': '信用卡',
    'orderDetail.cancel.confirm': '取消訂單',
    'orderDetail.cancel.validate': '確認取消',
    'orderDetail.ticket.itemSum': '商品總計',
    'orderDetail.ticket.grantSum': '補助總計',
    'orderDetail.ticket.entranceFeeSum': '入場費總計',
    'orderDetail.ticket.pricingRule': '定價方案：',
    'orderDetail.ticket.discountSum': '折扣總計',
    'orderDetail.ticket.tvaSum': '稅務總計',
    'orderDetail.ticket.finalPrice': '總計',
    'orderDetail.ticket.discount': '折扣碼：',
    'orderDetail.tax.taxrate': '稅率',
    'orderDetail.tax.totalExclTax': '未稅',
    'orderDetail.tax.totalTax': '稅額',
    'orderDetail.tax.totalInclTax': '含稅',
    'orderDetail.transaction.transactionIds': '交易識別碼',
    'orderDetail.payment.quantity': '數量',
    'orderDetail.payment.price': '價格',
    'orderDetail.delivery.address': '地址',
    'orderDetail.delivery.apartmentNumber': '公寓號碼',
    'orderDetail.delivery.digicode': '門禁密碼',
    'orderDetail.delivery.phoneNumber': '電話號碼',
    'orderDetail.delivery.additionalInfo': '補充資訊',
    'orderDetail.linkedOrder.title.origin': '與對沖分錄訂單的連結',
    'orderDetail.linkedOrder.title.contra_entry': '與已取消訂單的連結',
    'orderDetail.linkedOrder.date.origin': '對沖分錄訂單日期',
    'orderDetail.linkedOrder.date.contra_entry': '已取消訂單日期',
    'orderDetail.contraEntryInfo.title': '對沖分錄資訊',
    'orderDetail.contraEntryInfo.validator': '審核員',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': '自由欄位',
    'route.ioPayTransactions': '交易',
    'route.ioPayReports': '報告',
    'route.ioPayTransfers': '撥款',
    'route.ioPayConfiguration': '設定',
    'route.ioPayTransferDetail': '撥款詳細資訊',
    'route.ioPayTransactionDetail': '交易詳細資訊',
    'ioPay.title': 'Adyen',
    'transactions.title': '交易',
    'transactions.detail.title': '交易資料表',
    'transactions.subtitle': '查詢您客戶的交易記錄',
    'transaction.field.id': 'ID',
    'transaction.field.type': '類型',
    'transaction.field.brand': '品牌',
    'transaction.field.customerEmail': '電子郵件',
    'transaction.field.date': '日期',
    'transaction.field.paymentMethod': '付款方式',
    'transaction.field.paymentStatus': '付款模式',
    'transaction.field.paymentAmount': '付款金額',
    'transaction.field.paymentAmount.tooltip': '客戶支付的金額',
    'transaction.field.reversalAmount': 'Innovorder 返還金額',
    'transaction.field.reversalAmount.tooltip':
        '僅扣除付款手續費後返還的金額（若資金未經 Innovorder 轉手而直接入帳，金額可能為負數）',
    'transaction.field.amount': '交易金額',
    'transaction.field.amount.tooltip': 'Innovorder 返還金額總和減去退款',
    'transaction.field.fee': '手續費',
    'transaction.field.channel': '通路',
    'transaction.field.transfer': '撥款',
    'transaction.field.currency': '貨幣',
    'transaction.field.status': '狀態',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': '姓名',
    'transaction.field.email': '電子郵件',
    'transaction.field.customerId': '客戶 ID',
    'transaction.field.badgeNumber': '徽章號碼',
    'transaction.field.lastUpdate': '更新日期',
    'transaction.field.source': '來源',
    'transaction.field.orderId': '訂單號碼',
    'transaction.field.error': '錯誤',
    'transaction.field.restaurant': '餐廳',
    'transaction.field.paymentMethodType.WEB': '線上信用卡',
    'transaction.field.paymentMethodType.PROXIMITY': '信用卡',
    'transaction.field.paymentMethod.MEAL_VOUCHER': '餐券',
    'transaction.field.paymentMethod.BANK_CARD': '信用卡',
    'transaction.status.PENDING': '處理中',
    'transaction.status.PENDING_3DS': '3DS 驗證中',
    'transaction.status.DONE': '成功',
    'transaction.status.FAILED': '被拒',
    'transaction.status.ERROR': '錯誤',
    'transaction.type.CAPTURE': '付款',
    'transaction.type.REFUND': '退款',
    'transaction.channel.WEB': '網路',
    'transaction.channel.PROXIMITY': '近端',
    'transaction.source.WEBORDERING': '線上訂單',
    'transaction.source.EWALLET': '電子錢包儲值',
    'transaction.source.KIOSK': '自助點餐機',
    'transaction.source.NOTIFICATION': '通知',
    'transaction.detail.card.main': '交易詳細資訊',
    'transaction.detail.card.finance': '財務資料',
    'transaction.detail.card.web': '網路資料資訊',
    'transaction.detail.card.customer': '客戶資訊',
    'transaction.detail.card.order': '關聯訂單',
    'transaction.detail.card.paymentMethod': '付款方式',
    'transfers.title': '撥款',
    'transfers.subtitle': '撥款至您的帳戶',
    'configuration.iopay.title': 'Adyen 設定',
    'configuration.iopay.subtitle':
        '您可在此找到您為企業建立的所有法律實體。我們為您提供餐廳和電子錢包的清晰概覽，以便輕鬆設定。',
    'configuration.error.unaccessible': '找不到或權限不足',
    'transfer.field.id': 'ID',
    'transfer.field.ref': '參考',
    'transfer.field.configurationName': '商家',
    'transfer.field.amount': '撥款金額',
    'transfer.field.transactionCount': '交易筆數',
    'transfer.field.status': '狀態',
    'transfer.field.executedAt': '執行日期',
    'transfer.status.PENDING': '處理中',
    'transfer.status.SUCCESS': '已確認',
    'transfer.status.SENT_OUT': '已發送',
    'transfer.status.FAILED': '失敗',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': '撥款詳細資訊',
    'transfer.transactions.title': '撥款交易記錄',
    'legalEntity.field.entity': '法律實體',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': '城市',
    'legalEntity.field.status': '狀態',
    'legalEntity.field.associatedRestaurants': '關聯餐廳',
    'legalEntity.field.actions': '操作',
    'legalEntity.create.title': '建立法律實體',
    'legalEntity.status.1': 'KYC 錯誤',
    'legalEntity.status.2': '待完善',
    'legalEntity.status.3': '處理中',
    'legalEntity.status.4': '正常',
    'legalEntity.action.addRestaurant': '新增餐廳',
    'legalEntity.action.addEwallet': '新增電子錢包',
    'legalEntity.action.completeKyc': '完成 KYC',
    'legalEntity.action.updateKyc': '更新 KYC',
    'legalEntity.wizard.step1.title': '建立新的法律實體',
    'legalEntity.wizard.step1.legalName': '公司法定名稱',
    'legalEntity.wizard.step1.legalName.placeholder': '請輸入與 SIRET 上完全一致的公司法定名稱',
    'legalEntity.wizard.step1.legalName.tooltip': '與 SIRET 上完全一致的公司法定名稱',
    'legalEntity.wizard.step1.organizationType': '組織類型',
    'legalEntity.wizard.step1.organizationType.placeholder': '請選擇您的組織類型',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': '請輸入您的 SIRET',
    'legalEntity.wizard.step1.siret.tooltip': '公司的 SIRET',
    'legalEntity.wizard.step1.addressStreet': '法律實體地址',
    'legalEntity.wizard.step1.addressStreet.placeholder': '請輸入法律實體的地址',
    'legalEntity.wizard.step1.addressStreet2': '地址補充（選填）',
    'legalEntity.wizard.step1.addressStreet2.placeholder': '如有需要請輸入地址補充資訊',
    'legalEntity.wizard.step1.addressZipcode': '郵遞區號',
    'legalEntity.wizard.step1.addressZipcode.placeholder': '請輸入您的郵遞區號',
    'legalEntity.wizard.step1.addressCity': '城市',
    'legalEntity.wizard.step1.addressCity.placeholder': '請輸入您的城市',
    'legalEntity.wizard.step1.industryCode': '行業代碼',
    'legalEntity.wizard.step1.contactEmail': '聯絡電子郵件',
    'legalEntity.wizard.step1.contactEmail.placeholder': '請輸入與此法律實體關聯的電子郵件地址',
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': '請輸入法律實體的 IBAN',
    'legalEntity.wizard.step1.iban.tooltip': '法律實體的 IBAN',
    'legalEntity.wizard.step2.title': '新增餐廳',
    'legalEntity.wizard.step2.titleMassCatering': '新增餐廳或電子錢包',
    'legalEntity.wizard.step2.chooseRestaurant': '選擇餐廳',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': '選擇餐廳或電子錢包',
    'legalEntity.wizard.step2.completeFieldsTitle': '待填寫欄位',
    'legalEntity.wizard.step2.conecsTitle': 'CONECS 識別碼',
    'legalEntity.wizard.step2.conecsTitleOptional': '（選填）',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        '填入 CONECS 識別碼（ID）以便在此餐廳啟用 CONECS 近端付款方式',
    'legalEntity.wizard.step2.ewallet': '電子錢包',
    'legalEntity.wizard.step2.selectRestaurant': '餐廳',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': '餐廳或電子錢包',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': '請選擇一間餐廳',
    'legalEntity.wizard.step2.phoneNumber': '電話號碼',
    'legalEntity.wizard.step2.phoneNumber.placeholder': '請輸入與此餐廳關聯的電話號碼',
    'legalEntity.wizard.step2.shopperStatement': '銀行對帳單標題',
    'legalEntity.wizard.step2.shopperStatement.placeholder': '請輸入將顯示於銀行對帳單上的標題',
    'legalEntity.wizard.step2.shopperStatement.tooltip': '最終客戶銀行對帳單上的說明文字',
    'legalEntity.wizard.step2.restaurantAddressStreet': '餐廳地址',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': '請輸入餐廳地址',
    'legalEntity.wizard.step2.restaurantAddressStreet2': '地址補充（選填）',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder': '如有需要請輸入地址補充資訊',
    'legalEntity.wizard.step2.restaurantAddressZipcode': '餐廳郵遞區號',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': '請輸入餐廳郵遞區號',
    'legalEntity.wizard.step2.restaurantAddressCity': '城市',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': '請輸入餐廳所在城市',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': '請輸入資金轉移用的 IBAN',
    'legalEntity.wizard.step2.restaurantIban.tooltip': '填入 CONECS 識別碼（ID）以便在此餐廳啟用 CONECS 近端付款方式',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder': '請輸入您歸戶卡上的 CONECS MID',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'CONECS 合約關聯 SIRET',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder': '請輸入與 CONECS 合約關聯的 SIRET',
    'legalEntity.organizationType.1': '私人公司',
    'legalEntity.organizationType.2': '上市公司',
    'legalEntity.organizationType.3': '合夥企業',
    'legalEntity.organizationType.4': '非營利組織或慈善機構',
    'legalEntity.organizationType.5': '政府機構',
    'legalEntity.organizationType.6': '法人社團',
    'legalEntity.industryCode.specialFoodServices': '特殊餐飲服務',
    'legalEntity.industryCode.fullServiceRestaurants': '全服務餐廳',
    'legalEntity.industryCode.limitedServiceRestaurants': '限制服務餐廳（速食）',
    'legalEntity.industryCode.cafeteriasGrillBuffets': '自助餐廳、燒烤及自助餐',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': '小吃與無酒精飲料吧',
    'legalEntity.industryCode.bakeries': '烘焙坊',
    'billing.title': '我的帳單空間',
    'billing.subtitle': '歡迎，此空間旨在簡化發票管理。',
    'billing.description':
        '您可以在此按時間順序找到按付款服務分類的發票，輕鬆查看近期付款、下載發票並一鍵追蹤發票歷史記錄。',
    'billing.information.edit': '修改帳單資訊',
    'billing.noIssuedInvoices': '無已開立發票',
    'billing.table.creationDate': '建立日期',
    'billing.table.amount': '金額',
    'billing.table.status': '狀態',
    'billing.table.service': '服務',
    'billing.table.invoiceNumber': '發票號碼',
    'billing.table.invoiceName': '發票名稱',
    'billing.table.dueDate': '到期日',
    'billing.table.downloadPDF': '下載 PDF',
    'billing.editConfiguration.selectEntityStep.title': '法律實體',
    'billing.editConfiguration.selectEntityStep.subtitle': '選擇一個法律實體以修改帳單資訊',
    'billing.editConfiguration.selectEntityStep.legalEntity': '法律實體',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': '請從清單中選擇',
    'billing.editConfiguration.selectEntityStep.noLabel': '未命名法律實體',
    'billing.editConfiguration.configureBillingStep.title': '帳單資訊',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': '受益人姓名',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': '發票關聯電子郵件地址',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': '受益人地址',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': '補充資訊',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': '郵遞區號',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': '城市',
    'billing.editConfiguration.configureBillingStep.recipients': '發票收件人',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': '收件人電子郵件地址',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel': '將電子郵件地址「{email}」加入收件人',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage': '建立或修改設定資訊時發生錯誤',
    'billing.invoices.download': '下載',
    'billing.invoices.status.1': '待付款',
    'billing.invoices.status.2': '已付款',
    'billing.invoices.psp.4': 'Stripe',
    'billing.invoices.name.4': '統一 Stripe 發票',
    'reports.title': 'Adyen 報告',
    'reports.subtitle':
        '查看已轉入您銀行帳戶的交易，並了解每筆轉帳的詳細資訊。此報告可幫助您確認 Adyen 電子錢包交易的帳務可靠性。',
    'reports.text': '生成一種或多種報告類型',
    'reports.choosePeriod': '選擇期間',
    'reports.chooseReport': '選擇一種或多種報告類型',
    'reports.outgoingTransfers': '撥款',
    'reports.reportType': '報告類型',
    'reports.error.missingDates': '請選擇兩個日期',
    'reports.error.missingReportType': '請選擇一份報告',
    'reports.error.missingBrand': '目前使用者沒有關聯品牌',
    'pricingRevaluation.tableCard.title': '價格重新評估',
    'pricingRevaluation.tableCard.subtitle':
        '請輸入所需的重新評估比率，是否應用至選項及附加項目，然後選擇要重新評估的菜單並點選確認按鈕。',
    'pricingRevaluation.input.placeholder': '重新評估比率',
    'consumptionMode.MODE_DELIVERY': '外送',
    'consumptionMode.MODE_TAKE_AWAY': '外帶',
    'consumptionMode.MODE_SIT_IN': '內用',
    'consumptionMode.MODE_DRIVE': '得來速',
    'paymentMethods.tableCard.title': '管理與設定',
    'paymentMethods.tableCard.subtitle': '您的付款方式',
    'paymentMethods.tab.pos': '收銀機',
    'paymentMethods.tab.web': '線上訂單',
    'paymentMethods.tab.kiosk': '自助點餐機',
    'paymentMethods.tab.kiosk.integration.title': '即時付款',
    'paymentMethods.tab.kiosk.integration.desc1': '在自助點餐機上使用信用卡付款，需要餐廳擁有 Ingenico 帳號。',
    'paymentMethods.tab.kiosk.integration.desc2': '若您在自助點餐機上啟用身份驗證，還有其他即時付款方式可供使用。',
    'paymentMethods.tab.kiosk.payment.title': '取餐時付款',
    'paymentMethods.tab.kiosk.payment.desc': '告知使用者餐廳櫃台接受的付款方式。',
    'paymentMethods.tab.kiosk.payment': '付款',
    'paymentMethods.tab.kiosk.payment.accepted': '已接受',
    'paymentMethods.tab.kiosk.payment.refused': '已拒絕',
    'paymentMethods.consumptionMode': '選擇用餐模式',
    'paymentMethods.externalId': '外部代碼',
    'configure.ingenico': '設定 Ingenico',
    'configure.nepting': '設定 Nepting',
    'configure.stripe': '設定 Stripe',
    'configure.edenred': '設定 Edenred',
    'configure.iopay': '設定 Adyen',
    'configure.paygreen': '設定 Paygreen',
    'configure.ewallet': '設定電子錢包',
    'configure.yavin': '設定 IOPay',
    'configure.yavin.neptingConfigured': '無法設定 IOPay，因為 Nepting 正在使用中。',
    'configure.nepting.yavinConfigured': '無法設定 Nepting，因為 IOPay 正在使用中。',
    'configure.stripe.iopayConfigured': '無法設定 Stripe，因為 Adyen 正在使用中。',
    'configure.iopay.stripeConfigured': '無法設定 Adyen，因為 Stripe 正在使用中。',
    'customer.form.modalDescription': '請填寫必填資訊 *',
    'customer.form.firstName': '名字 *',
    'customer.form.lastName': '姓氏 *',
    'customer.form.badgeNumber': '徽章號碼 {index} *',
    'customer.form.badgeType': '徽章類型',
    'customer.form.badge.default': '設為主要',
    'customer.form.badgeType.placeholder': '請填寫徽章類型',
    'customer.form.addBadge': '新增徽章',
    'customer.form.email': '電子郵件地址 *',
    'customer.form.phoneNumber': '電話號碼（選填）',
    'customer.form.arrivalDate': '到達日期（選填）',
    'customer.form.departureDate': '離開日期（選填）',
    'customer.form.password': '密碼 *',
    'customer.form.confirmPassword': '確認密碼 *',
    'customer.form.clientInfoSection': '用餐者一般資訊',
    'customer.form.pricingRuleSection': '定價規則設定',
    'customer.form.accountPaymentTypeLabel': '客戶帳戶類型 *',
    'customer.form.accountPaymentTypePlaceHolder': '請選擇客戶帳戶類型',
    'customer.form.guestGroupIdLabel': '群組 *',
    'customer.form.guestGroupIdPlaceHolder': '請選擇一個群組',
    'customer.form.pricingRuleCodeLabel': '定價方案代碼 *',
    'customer.form.pricingRuleCodePlaceHolder': '請選擇定價方案',
    'customer.form.tariffCode': '費率代碼（選填）',
    'customer.form.studentNumber': '用餐者號碼（選填）',
    'customer.form.pricingRuleInfo': '您的定價方案代碼未出現在清單中？請在此建立',
    'customer.form.groupInfo': '若要定義您的群組，請前往品牌 > 階層架構頁面',
    'customer.form.sectionInfo': '若要定義您的部門，請前往品牌 > 階層架構頁面',
    'customer.form.subSectionInfo': '若要定義您的子部門，請前往品牌 > 階層架構頁面',
    'customer.form.here': '此處',
    'customer.form.section': '部門（選填）',
    'customer.form.subSection': '子部門（選填）',
    'customer.form.selectOptions.cash': '現付',
    'customer.form.selectOptions.prepayment': '預付',
    'customer.form.selectOptions.postpayment_bankdebit': '後付：薪資扣除',
    'customer.form.selectOptions.postpayment_guest': '後付：訪客',
    'brand.customers.action.import': '匯入',
    'brand.customers.action.export': '匯出',
    'brand.customers.page.title': '客戶',
    'brand.customers.page.description': '您可以在此找到已註冊於您品牌的完整客戶清單。',
    'customer.modal.import.title': '匯入客戶',
    'customer.modal.import.firstPart': '在您的電腦上下載 {fileTemplate}',
    'customer.modal.import.secondPart': '以客戶資料填寫檔案',
    'customer.modal.import.thirdPart': '上傳檔案以匯入您的客戶',
    'customer.modal.import.report.title': '匯入報告',
    'customer.modal.import.report.result': '結果',
    'customer.modal.import.report.success': '成功',
    'customer.modal.import.report.error': '錯誤',
    'customer.modal.import.report.message': '{created} 已建立，{updated} 已更新，{unchanged} 未變更',
    'customer.modal.import.warning':
        '注意！「費率代碼」、「補助代碼」、「入場費代碼」和「定價方案代碼」欄位已棄用，匯入時將被忽略。請使用定價方案表格來設定這些資訊。',
    'customer.modal.import.addNew.title': '新增客戶',
    'customer.modal.import.addNew.step1': '在您的電腦上下載 {link}',
    'customer.modal.import.addNew.step1.link': '範本檔案',
    'customer.modal.import.addNew.step2': '以新客戶資料填寫檔案',
    'customer.modal.import.addNew.step3': '上傳填好的檔案至下方',
    'customer.modal.import.update.title': '更新現有客戶',
    'customer.modal.import.update.step1': '在您的電腦上下載 {link}',
    'customer.modal.import.update.step1.link': '目前客戶資料庫',
    'customer.modal.import.update.step1.loading': '載入中...',
    'customer.modal.import.update.step2': '修改您想要更新的客戶資料',
    'customer.modal.import.update.step3': '上傳修改後的檔案至下方',
    'customer.modal.import.update.warning': '注意：客戶識別碼必須對應至現有客戶，才能進行更新。',
    'customer.modal.import.options.title': '匯入選項',
    'customer.modal.import.options.multiBadge': '多徽章匯入',
    'customer.modal.import.options.autoImportGuestHierarchy': '自動匯入階層架構（群組、部門、子部門）',
    'customer.modal.import.error.noResponse': '匯入失敗 - 伺服器無回應',
    'customer.modal.import.error.invalidResponse': '伺服器回應無效',
    'customer.modal.import.error.fileTooLarge': '檔案過大（最大 20 MB）',
    'customer.modal.import.loading.reading': '正在讀取檔案...',
    'customer.modal.import.loading.importing': '匯入中...',
    'customer.modal.import.result.lineError': '第 {lineNumber}{nameDisplay} 行：{error}',
    'customer.modal.import.result.fieldError': '欄位（{fields}）未修改（第 {line} 行）',
    'customer.modal.import.result.genericError': '發生錯誤',
    'customer.modal.import.result.created': '已建立客戶：{count}',
    'customer.modal.import.result.updated': '已更新客戶：{count}',
    'customer.modal.import.result.unchanged': '未修改/未建立客戶：{count}',
    'customer.modal.import.result.errors': '錯誤',
    'customer.modal.import.result.warnings': '警告',
    'customer.modal.import.result.otherWarning.PRICING_RULE': '系統中不存在某些定價規則：',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': '系統中不存在某些入場費：',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': '某些用餐者的群組為空（行號：',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP': '某些用餐者群組不存在（行號：',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE': '某些定價規則不適用於該群組（行號：',
    'customer.modal.import.result.restrictedFieldsInfo':
        '「密碼」、「PIN 碼」和「餘額」欄位只有在客戶尚未進行任何交易時才能更新。',
    'customer.create.modalTitle': '建立新用餐者',
    'customer.update.modalTitle': '修改用餐者',
    'customer.tab.info': '資訊',
    'customer.tab.ewallet': '電子錢包',
    'customer.tab.student': '團膳',
    'customer.tab.orders': '訂單歷史',
    'route.customerPricingPolicy': '定價政策',
    'customer.pricingPolicy.defaultTitle': '預設政策',
    'customer.pricingPolicy.defaultDescription': '預設定價政策將套用於透過網路訂購模組建立帳戶的所有客戶。',
    'customer.pricingPolicy.customTitle': '自訂政策',
    'customer.pricingPolicy.entranceFee': '入場費',
    'customer.pricingPolicy.pricingPolicy': '定價方案',
    'customer.pricingPolicy.group': '群組',
    'customer.pricingPolicy.groupPlaceholder': '我的群組',
    'customer.pricingPolicy.domainName': '網域名稱',
    'customer.pricingPolicy.delete': '刪除',
    'customer.pricingPolicy.noEntranceFee': '無入場費',
    'customer.pricingPolicy.noPricingRule': '無定價規則',
    'customer.pricingPolicy.noGroup': '無群組',
    'customer.pricingPolicy.enableWhitelisting': '限制只允許已申報網域註冊',
    'customer.pricingPolicy.enableWhitelistingInfo': '啟用此選項後，只有已申報的網域才能進行線上註冊',
    'customer.pricingPolicy.save': '儲存',
    'customer.student.info.title': '資訊',
    'customer.student.info.desctiption': '與團膳模式相關的資訊。',
    'customer.student.info.account.type': '徽章類型',
    'customer.student.info.group': '群組',
    'customer.student.info.section': '部門',
    'customer.student.info.sub.section': '子部門',
    'customer.student.info.badge.number': '徽章號碼',
    'customer.student.info.pricing.code': '費率代碼',
    'customer.student.info.student.number': '用餐者號碼',
    'customer.student.pricing.rules.title': '定價規則',
    'customer.student.pricing.rules.desctiption':
        '您可以為每位客戶分配特定的定價規則。客戶可以擁有補助代碼和/或入場費代碼，或是定價方案代碼（包含入場費和/或補助的組合）。',
    'customer.student.pricing.rules.deprecated':
        '⚠️ 入場費代碼和補助代碼欄位現已棄用，請改用定價方案代碼欄位（包含入場費和補助）。{moreInfo}',
    'customer.student.pricing.rules.more_info': '更多資訊',
    'customer.student.pricing.rules.grant.code': '補助代碼',
    'customer.student.pricing.rules.entrance.fee.code': '入場費代碼',
    'customer.student.pricing.rules.code': '定價方案代碼',
    'customer.student.overdraft.title': '允許電子錢包透支',
    'customer.student.overdraft.desctiption': '您可以為客戶自訂使用電子錢包的最大允許透支金額。',
    'customer.student.overdraft.price.label': '允許電子錢包透支金額',
    'customer.student.overdraft.disabled': '此客戶適用預設電子錢包透支設定。',
    'customer.student.badge.title': '封鎖用餐者主要徽章',
    'customer.student.badge.description': '您可以暫時封鎖主要徽章的功能。',
    'customer.student.badge.table.default': '主要',
    'customer.student.badge.table.number': '徽章號碼',
    'customer.student.badge.table.type': '類型',
    'customer.student.badge.table.status': '狀態',
    'customer.student.badge.table.action': '操作',
    'customer.student.badge.table.status.active': '✓ 已啟用',
    'customer.student.badge.table.status.blocked': '✕ 已封鎖',
    'customer.student.add.badge': '+ 新增徽章',
    'customer.student.badge.form.add': '新增徽章',
    'customer.student.badge.form.update': '編輯徽章',
    'customer.student.badge.form.default': '設為主要',
    'customer.ordersList.title': '訂單',
    'customer.ordersList.subtitle': '查詢您客戶的訂單',
    'customer.ordersList.downloadTickets': '下載票券',
    'customer.ordersList.exportStarted': '正在匯出票券，請稍候...',
    'customer.ordersList.exportSuccess': '票券匯出成功！',
    'customer.ordersList.exportFailed': '票券匯出失敗，請重試。',
    'customer.ordersList.exportNoTicketsForDates': '所選日期無任何票券。',
    'customer.ordersList.downloadChoice.all': '所有票券',
    'customer.ordersList.downloadChoice.selectedRange': '僅限所選日期',
    'order.field.downloadTicket': '下載',
    'pricingRevaluation.options.exceeding': '套用於超額部分',
    'pricingRevaluation.options.options': '套用於選項',
    'pricingRevaluation.options.updateInPlace': '冰箱連網/掃描托盤菜單',
    'pricingRevaluation.options.updateInPlace.tooltip':
        '若勾選此核取方塊，重新評估將直接套用於原始菜單以保留 ID（將建立一份未重新評估的菜單副本）。\n若取消勾選，重新評估將套用於菜單副本（新 ID），原始菜單不會變更。',
    'pricingRevaluation.table.menu.name': '菜單名稱',
    'pricingRevaluation.table.menu.isActive': '菜單啟用中',
    'pricingRevaluation.table.menu.channels': '通路',
    'pricingRevaluation.table.menu.selected': '已選取',
    'pricingRevaluation.table.emptyMessage': '此餐廳找不到任何菜單',
    'pricingRevaluation.table.search': '搜尋菜單',
    'pos_layout.name': 'POS 按鍵版面配置',
    'pos_layout.page.title': 'POS 按鍵版面配置',
    'pos_layout.page.description': '整理您的按鍵版面配置，然後部署至關聯的 POS。',
    'pos_layout.sort': '重新排序',
    'pos_layout.sort.random': '隨機',
    'pos_layout.sort.by_name': '依名稱',
    'pos_layout.sort.by_price': '依價格',
    'pos_layout.tabletSize': '平板尺寸',
    'pos_layout.inches': '英寸',
    'pos_layout.publishDescription': '您確定要儲存並發布菜單和按鍵版面配置至關聯的 POS 嗎？',
    'pos_layout.assignPos': '關聯 POS',
    'pos_layout.modal.warning': '注意',
    'pos_layout.modal.publish.description':
        '按鍵版面配置中以下類別沒有關聯的產品：\n• {categories} \n您確定要發布此按鍵版面配置嗎？',
    'pos_layout.modal.save.description':
        '按鍵版面配置中以下類別沒有關聯的產品：\n• {categories} \n您確定要儲存此按鍵版面配置嗎？',
    'pos_layout.customPrice': '自訂價格',
    'pos_layout.functions.create.title': '新增功能按鍵',
    'pos_layout.functions.edit.title': '編輯功能按鍵',
    'pos_layout.functions.type': '按鍵類型',
    'pos_layout.functions.type.placeholder': '選擇類型',
    'pos_layout.functions.type.webview': '網頁連結 / URL',
    'pos_layout.functions.name': '按鍵名稱',
    'pos_layout.functions.url': '目標網頁連結/URL',
    'pos_layout.functions.submit': '儲存',
    'pos_layout.functions.verifyLink': '驗證連結',
    'pos_layout.functions.widthPercent': '寬度',
    'pos_layout.functions.heightPercent': '高度',
    'pos_device.role.independent': '獨立',
    'pos_device.role.master': '主要',
    'pos_device.role.slave': '附屬',
    'pos_device.role.independent.plural': '獨立（複數）',
    'pos_device.role.master.plural': '主要（複數）',
    'pos_device.role.slave.plural': '附屬（複數）',
    'action.action': '操作',
    'action.edit': '編輯',
    'action.duplicate': '複製',
    'action.copy': '複製',
    'action.export': '匯出',
    'action.publish': '發布',
    'action.delete': '刪除',
    'action.hide': '隱藏',
    'customers.page.title': '客戶',
    'customers.page.description': '查詢您的客戶',
    'customers.id': 'ID',
    'customers.name': '客戶',
    'customers.email': '電子郵件',
    'customers.phone': '電話號碼',
    'customers.totalSpentAmount': '總消費金額',
    'customers.orderCount': '訂單數量',
    'customers.averageCart': '平均消費',
    'customers.lastOrder': '最後一筆訂單',
    'customers.frequency': '頻率',
    'customers.status': '狀態',
    'customers.ewalletBalance': '電子錢包餘額',
    'customers.archivedAt': '封存日期',
    'customers.disabledAt': '停用日期',
    'customers.showArchivedCustomers': '顯示已封存客戶',
    'customers.showDisabledCustomers': '顯示已停用客戶',
    'customers.options': '選項',
    'customers.domainNames': '網域名稱',
    'customers.selectDomainNames': '選取網域名稱',
    'customers.groups': '群組',
    'customers.selectGroups': '選取群組',
    'menu.name': '菜單名稱',
    'menu.categories': '類別',
    'menu.products': '產品',
    'menu.functions': '功能',
    'menu.page.title': '菜單',
    'menu.page.description': '建立並管理您的菜單',
    'menu.table.associatedChannels': '關聯頻道',
    'menu.action.newMenu': '+ 新增菜單',
    'menu.action.manualImportCrous': '強制匯入 Crous',
    'menu.action.seeOperations': '檢視操作',
    'menu.action.changeColor': '變更顏色',
    'menu.action.editProduct': '編輯產品',
    'menu.action.editCategory': '編輯類別',
    'menu.action.editFunction': '編輯功能',
    'menu.action.import': '匯入菜單',
    'menu.action.noImport': '我不想匯入檔案',
    'menu.modal.manualImportCrous.title': '手動匯入 CROUS 目錄',
    'menu.modal.manualImportCrous.description': '您確定要為此餐廳手動匯入 CROUS 目錄嗎？',
    'menu.action.aiMenuScan': 'AI 掃描（測試版）',
    'menu.modal.aiMenuScan.title': '掃描您的新菜單（測試版）',
    'menu.modal.aiMenuScan.description.part1': '以 PDF 或圖片格式匯入您的新菜單',
    'menu.modal.aiMenuScan.description.part2': '點擊「生成 Excel 菜單」',
    'menu.modal.aiMenuScan.description.part3': '自動下載包含可用資訊的新菜單 Excel 檔案',
    'menu.modal.aiMenuScan.action.cancel': '取消',
    'menu.modal.aiMenuScan.action.generate': '生成 Excel 菜單',
    'menu.modal.bannersDeactivated': '{count, plural, one {# 個促銷橫幅已停用} other {# 個促銷橫幅已停用}}',
    'menu.modal.create.importMenu': '匯入菜單',
    'menu.modal.create.createMenu': '建立菜單',
    'menu.modal.error.wrongName': '請輸入有效名稱',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': '收銀機',
    'menu.modal.create.import.excel.title': '新增菜單',
    'menu.modal.create.import.excel.description.firstPart': '將 {fileTemplate} 下載到您的電腦',
    'menu.modal.create.import.excel.description.secondPart': '用構成新菜單的產品資訊填寫範本檔案',
    'menu.modal.create.import.excel.description.thirdPart': '點擊下方按鈕匯入您的新檔案',
    'menu.modal.create.import.pos.title': '匯入現有菜單',
    'menu.modal.create.import.pos.description.firstPart': '選擇您想匯入菜單的 innovorder 收銀機',
    'menu.modal.create.import.json.title': '匯入現有菜單',
    'menu.modal.create.import.json.description.firstPart': '請確認您的檔案為 JSON 格式',
    'menu.modal.create.import.json.description.secondPart': '點擊下方按鈕匯入您的新檔案',
    'menu.modal.duplicate.title': '複製菜單',
    'menu.modal.delete.title': '刪除菜單',
    'menu.modal.delete.description': '您確定要刪除菜單：「{menuName}」 嗎？',
    'menu.modal.copy.title': '複製菜單',
    'menu.modal.publish.title': '發布菜單',
    'menu.modal.publish.autoPublish': '驗證後重新載入終端機',
    'menu.modal.publish.devicePublish': '在以下 POS 上發布菜單：',
    'menu.modal.publish.deliverooPublish': '在以下 Deliveroo 品牌上發布菜單：',
    'menu.modal.publish.ubereatsPublish': '在以下 UberEats 品牌上發布菜單：',
    'menu.modal.publish.duplicateBarCode': '\n- 條碼 {barCode} 在以下產品中重複：{products}',
    'menu.modal.error.name': '請在指定欄位中輸入名稱',
    'menu.modal.error.channels': '必須停用與關聯收銀機同步的選項',
    'menu.modal.menu.name': '菜單名稱',
    'menu.modal.message.defaultIncompatibleDisclaimer': '您只能關聯版本 7.0 以上的主收銀機或獨立收銀機',
    'menu.modal.message.versionIncompatibleDisclaimer': '您只能關聯版本 {values} 以上的收銀機',
    'menu.modal.message.roleIncompatibleDisclaimer': '您無法關聯 {values} 收銀機',
    'menu.modal.channels.shouldSyncPos': '與收銀機同步',
    'menu.modal.channels.isSyncFromPosEnabled': '從關聯收銀機修改時更新菜單',
    'menu.modal.channels.selectActive': '在以下頻道上啟用菜單',
    'menu.modal.channels.associatedChannels': '關聯頻道',
    'menu.modal.channels.pos.selectActive': '選取要關聯至菜單的收銀機',
    'menu.modal.channels.deliveroo.selectActive': '選取要關聯至菜單的 Deliveroo 品牌',
    'menu.modal.channels.ubereats.selectActive': '選取要關聯至菜單的 UberEats 品牌',
    'menu.modal.channels.pos.notFound': '未找到任何收銀機。',
    'menu.modal.channels.associatePos': '關聯收銀機',
    'menu.modal.channels.associateDeliveroo': '關聯 Deliveroo 品牌',
    'menu.modal.channels.associateUberEats': '關聯 UberEats 品牌',
    'menu.modal.channels.editMenu': '編輯菜單',
    'menu.modal.channels.createMenu': '建立菜單',
    'menu.modal.channels.selectPos': '選取收銀機',
    'menu.modal.channels.selectDeliveroo': '選取 Deliveroo 品牌',
    'menu.modal.channels.selectUberEats': '選取 UberEats 品牌',
    'menu.modal.externalId': '外部代碼',
    'menu.modal.warn.shift.title': '危險操作',
    'menu.modal.warn.shift.text': '在服務期間編輯菜單可能會影響關聯終端機上的客戶體驗。',
    'menu.modal.warn.shift.button': '確定',
    'menu.importPOS.cancel': '暫不處理',
    'menu.importPOS.title': '將後台缺少的收銀機菜單匯入',
    'menu.importPOS.step1.title': '新功能：只需一鍵即可在此添加您的收銀機菜單！',
    'menu.importPOS.step1.bullet.1': '更簡單、更深入地管理觸控方案和菜單',
    'menu.importPOS.step1.bullet.2': '可以提前準備觸控方案並一鍵啟用',
    'menu.importPOS.step1.bullet.3': '可以對收銀機、終端機和線上訂購使用相同的菜單',
    'menu.importPOS.step1.info': '只有版本高於 7 且類別為獨立或主收銀機才能在後台管理其菜單',
    'menu.importPOS.step2.pos': '已匯入後台的收銀機',
    'menu.importPOS.step2.switch': '從關聯收銀機進行未來修改時更新菜單',
    'menu.importPOS.step3.title': '一切就緒！',
    'menu.importPOS.step3.subtitle': '您現在可以直接從後台管理您的收銀機了！',
    'menu.importPOS.step3.link': '存取說明文件',
    'menu.importPOS.step3.info1': '點擊您選擇的菜單以查看並修改它',
    'menu.importPOS.step3.info2': '您可以複製菜單以準備您的下一份菜單，或為每個菜單修改關聯的收銀機和其他消費模式',
    'menu.importPOS.step3.info3':
        '只要您不發布菜單，關聯收銀機上的菜單將保持不變。\n<strong>因此，您必須執行發布操作，才能讓後台對菜單的修改在收銀機上更新。</strong>\n這可以在菜單頁面上每個菜單的選項中完成，也可以從觸控方案頁面完成。',
    'menuoperation.page.title': '菜單操作',
    'menuoperation.page.description': '查看您餐廳的菜單操作',
    'menuoperation.type': '類型',
    'menuoperation.type.update': '更新',
    'menuoperation.type.publish': '發布',
    'menuoperation.type.propagation': '傳播',
    'menuoperation.message.from': '來自',
    'menuoperation.message.from.brandMenu': '來自品牌菜單：',
    'menuoperation.message.to': '至',
    'menuoperation.errorModal.title': '發布報告',
    'menuoperation.errorModal.message': '無法完成發布。',
    'menuoperation.errorModal.checklist.intro': '請在再次確認之前檢查以下幾點：',
    'menuoperation.errorModal.checklist.requiredFields': '產品的所有必填欄位均已填寫',
    'menuoperation.errorModal.checklist.requiredMenuImage': '菜單有圖片',
    'menuoperation.errorModal.checklist.noSubCategories': '菜單沒有子類別',
    'menuoperation.errorModal.checklist.imageFormats': '圖片符合所需格式（320x320px 至 6000x6000px 之間）',
    'menuoperation.errorModal.checklist.syncSettings': '同步設定已正確配置',
    'menuoperation.errorModal.checklist.stepDepthLimit': '步驟深度限制未超過（Deliveroo 最多 2 層）。',
    'menuoperation.actions': '操作',
    'menuoperation.action.download': '前一個菜單',
    'menuoperation.action.download.before': '初始菜單',
    'menuoperation.action.download.after': '最終菜單',
    'menuoperation.download.error.title': '下載失敗',
    'menuoperation.download.error': '無法下載已封存的菜單。請稍後再試。',
    'menu.tags.title': '標籤',
    'menu.tags.table.name': '名稱',
    'menu.tags.create.link': '建立新標籤',
    'menu.tags.create.error.alreadyTaken': '此標籤已存在',
    'menu.tags.edit.title': '編輯標籤',
    'menu.tags.create.title': '建立標籤',
    'menu.tags.form.color.label': '顏色',
    'menu.tags.delete.confirm': '您確定要刪除 {count} 個標籤嗎？',
    'menu.functions.title': '功能',
    'menu.functions.subtitle': '新增、修改並將功能指派到您的觸控方案',
    'menu.functions.table.name': '名稱',
    'menu.functions.table.type': '類型',
    'menu.functions.table.status': '狀態',
    'menu.functions.table.action': '操作',
    'menu.functions.status.active': '啟用',
    'menu.functions.status.inactive': '停用',
    'menu.functions.noData': '尚未建立任何功能',
    'menu.functions.delete.confirm': '您確定要刪除 {count} 個功能嗎？',
    'menu.steps.title': '步驟',
    'menu.steps.add.title': '新增步驟',
    'menu.steps.duplicate': '複製',
    'menu.steps.convert': '轉換',
    'menu.steps.delete.confirm': '您確定要刪除 {count} 個步驟嗎？',
    'menu.steps.convert.toCustomization.confirm': '轉換後，您需要設定自訂步驟的詳細資訊和選項，您要繼續嗎？',
    'menu.steps.convert.toCrossSelling.confirm':
        '轉換步驟後，最小/最大選擇數量和已啟用選項的資訊將不會保留，您要繼續嗎？',
    'menu.steps.bulkConvertError': '若要進行批量轉換，所有步驟必須為相同類型（附加銷售或自訂）',
    'menu.steps.column.name': '名稱',
    'menu.steps.column.choices': '可選選項',
    'menu.steps.column.min': '最小值',
    'menu.steps.column.max': '最大值',
    'menu.steps.column.stepRef': '參考',
    'menu.steps.column.parentsProducts': '父產品數量',
    'menu.steps.edit.title': '編輯步驟',
    'menu.steps.editCustomization.title': '編輯自訂步驟',
    'menu.steps.editCrossSelling.title': '編輯附加銷售步驟',
    'menu.steps.createCustomization.title': '建立自訂',
    'menu.steps.createCrossSelling.title': '建立附加銷售',
    'menu.steps.convert.title': '注意',
    'menu.steps.column.type': '類型',
    'menu.steps.typeName.1': '自訂',
    'menu.steps.typeName.2': '附加銷售',
    'menu.steps.form.ticketLabel': '收據標籤',
    'menu.steps.form.minChoice': '最小選擇',
    'menu.steps.form.maxChoice': '最大選擇',
    'menu.steps.form.stepRef': '參考',
    'menu.steps.form.maxChoice.error.greaterThanMin': '必須大於最小值',
    'menu.steps.form.isDescriptionDisplayEnabled': '顯示描述',
    'menu.steps.form.options': '選項',
    'menu.steps.form.isExcessAllowed': '允許超額',
    'menu.steps.form.isGroupEnabled': '啟用分組',
    'menu.steps.form.isImageDisplayEnabled': '顯示圖片',
    'menu.steps.form.isQuantitySelectionEnabled': '數量',
    'menu.steps.form.isWeightStrategyEnabled': '使用重量',
    'menu.steps.form.stepProduct': '選項清單',
    'menu.steps.form.stepProduct.add': '新增選項',
    'menu.steps.form.stepProduct.orderByName': '依名稱排序',
    'menu.steps.form.stepProduct.orderByPrice': '依價格排序',
    'menu.steps.form.stepProduct.setForAllOption': '傳播數值',
    'menu.steps.form.stepProduct.name': '名稱',
    'menu.steps.form.stepProduct.price': '價格',
    'menu.steps.form.stepProduct.excessPrice': '超額價格',
    'menu.steps.form.stepProduct.weight': '單位重量',
    'menu.steps.form.stepProduct.group': '群組',
    'menu.steps.form.stepProduct.maxQuantity': '最大數量',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': '預設已選取 (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': '最小數量 (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': '預設數量 (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': '顯示 POS 屬性',
    'menu.steps.form.stepProduct.import': '匯入',
    'menu.steps.form.stepProduct.importWithPrice': '含價格匯入',
    'menu.steps.form.stepProduct.importWithoutPrice': '不含價格匯入',
    'menu.steps.propagate.title': '傳播步驟',
    'menu.categories.title': '類別',
    'menu.categories.subtitle': '編輯您的菜單類別',
    'menu.categories.addCategory': '建立類別',
    'menu.categories.noData': '菜單中沒有類別。',
    'menu.categories.addProduct': '新增產品',
    'menu.categories.createProduct': '建立產品',
    'menu.categories.deleteCategory': '刪除',
    'menu.categories.removeProduct': '移除',
    'menu.categories.deleteCategory.confirm':
        '您確定要刪除此類別嗎？\n它將不再可用，其子項目（產品和子類別）將成為孤立項目。',
    'menu.categories.create.title': '建立類別',
    'menu.categories.edit.title': '編輯類別',
    'menu.categories.products': '{productCount, plural, =0 {無產品} one {# 個產品} other {# 個產品}}',
    'menu.categories.create.error.alreadyTaken': '此類別已存在',
    'menu.products.title': '產品',
    'menu.products.table.image': '圖片',
    'menu.products.table.name': '名稱',
    'menu.products.table.categories': '類別',
    'menu.products.table.price': '價格',
    'menu.products.table.vat': '增值稅',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': '標籤',
    'menu.products.reload.kiosk': '重新載入',
    'menu.products.create.link': '建立產品',
    'menu.products.massEdit': '批量編輯',
    'menu.products.duplicate': '複製',
    'menu.products.copy': '傳播',
    'menu.products.copy.title': '傳播產品',
    'menu.products.copy.form.restaurants.title': '選取目標餐廳',
    'menu.products.copy.form.restaurants.label': '目的地',
    'menu.products.copy.form.restaurants.tooltip': '選擇將接收產品和/或其步驟傳播的品牌餐廳。',
    'menu.products.copy.form.restaurants.tooltip.title': '選取目標餐廳',
    'menu.products.copy.form.restaurants.tooltip.example':
        '從品牌菜單中，您決定僅將布朗尼甜點傳播到餐廳 A 和 B → 只有這些餐廳會擁有這個新產品。',
    'menu.products.copy.form.updateIgnoreAttributes.title': '傳播時，我不希望覆蓋以下屬性：',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        '將品牌產品傳播到已存在該產品的餐廳（單獨或通過步驟）時，您可以選擇保留該單個產品的某些屬性：標籤、父類別、圖片、價格、增值稅、名稱和描述。',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title': '傳播已存在產品時保留某些屬性',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        '單個產品 Cookie 已在餐廳中存在，有自訂圖片和特定價格 → 如果您勾選「圖片」和「價格」，即使從品牌傳播後，這些值也會被保留。\n\n👉 對於新產品，品牌的所有屬性都會自動傳播。',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products': '已存在於目標餐廳菜單中的產品',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps': '已存在於目標餐廳菜單中的步驟',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title': '傳播已存在步驟時保留某些屬性',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        '將品牌步驟傳播到已存在該步驟的餐廳時，您可以選擇保留該步驟的某些屬性：步驟中的產品價格、每個產品的最大數量（如果數量選項已啟用）和超額價格。',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        '在餐廳中，「選擇甜點」步驟有一個 2 歐元的 Cookie，最大數量為 3。\n品牌在步驟中傳播一個 1 歐元的 Cookie，最大數量為 1。\n→ 如果您保留「產品價格」和「最大數量」，餐廳仍保持 Cookie 為 2 歐元，最大數量為 3。\n\n👉 對於新步驟，品牌的所有屬性都會自動傳播。',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder': '傳播時，我不希望覆蓋以下屬性',
    'menu.products.copy.form.attribute.price': '價格',
    'menu.products.copy.form.attribute.vat': '增值稅',
    'menu.products.copy.form.attribute.name': '名稱',
    'menu.products.copy.form.attribute.description': '描述',
    'menu.products.copy.form.attribute.categories': '父類別',
    'menu.products.copy.form.attribute.tags': '標籤',
    'menu.products.copy.form.attribute.imageId': '圖片',
    'menu.products.copy.form.attribute.exceedPrice': '超額價格',
    'menu.products.copy.form.attribute.maxProductQuantity': '最大數量',
    'menu.products.copy.form.publishAfterCopy.title': '傳播時，我希望：',
    'menu.products.copy.form.publishAfterCopy.tooltip': '自動在關聯收銀機上發布菜單',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': '自動發布',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        '如果啟用，菜單將自動在與目標餐廳關聯的所有收銀機上發布。',
    'menu.products.copy.form.publishAfterCopy': '自動在關聯收銀機上發布菜單',
    'menu.products.copy.form.publishAfterCopy.disclaimer': '⚠️ 注意，需要在觸控方案上新增傳播的新產品',
    'menu.products.copy.form.strategy.title': '目標菜單上已存在步驟的傳播策略',
    'menu.products.copy.form.strategy.tooltip': '餐廳中已存在的步驟將被品牌菜單上設定的步驟（包括產品和價格）所取代。',
    'menu.products.copy.form.strategy.tooltip.title': '策略：更新現有步驟',
    'menu.products.copy.form.strategy.tooltip.example':
        '餐廳 A 的「選擇甜點」步驟有法式吐司、水果、Cookie（2 歐元）。\n品牌傳播 Cookie（1 歐元）、布朗尼（2 歐元）→ 餐廳 A 現在將有 Cookie（1 歐元）、布朗尼（2 歐元）。\n\n👉 單個產品 Cookie 已更新，單個產品布朗尼已建立，法式吐司已從步驟中移除。',
    'menu.products.copy.form.strategy.replace': '用從品牌菜單傳播的步驟更新餐廳菜單中現有的步驟',
    'menu.products.copy.form.strategy.replace.tooltip.title': '策略：更新現有步驟',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        '餐廳中已存在的步驟將被品牌菜單上設定的步驟（包括產品和價格）所取代。',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        '餐廳 A 的「選擇甜點」步驟有法式吐司、水果、Cookie（2 歐元）。\n品牌傳播 Cookie（1 歐元）、布朗尼（2 歐元）→ 餐廳 A 現在將有 Cookie（1 歐元）、布朗尼（2 歐元）。\n\n👉 單個產品 Cookie 已更新，單個產品布朗尼已建立，法式吐司已從步驟中移除。',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        '更新餐廳菜單中現有的步驟，並保留品牌菜單步驟中不存在的現有產品',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title': '策略：更新並保留現有產品',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        '餐廳的步驟會以品牌的步驟更新，但已存在且品牌菜單中不存在的產品將被保留。',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        '餐廳 A 的「選擇甜點」步驟有法式吐司（1 歐元）、水果（2 歐元）、Cookie（2 歐元）。\n品牌傳播 Cookie（1 歐元）、布朗尼（2 歐元）→ 餐廳 A 將有法式吐司（1 歐元）、水果（2 歐元）、Cookie（1 歐元）、布朗尼（2 歐元）。\n\n👉 單個產品 Cookie 已更新，單個產品布朗尼已建立，法式吐司在步驟中被保留。',
    'menu.products.copy.form.strategy.keep_existing': '不修改目標菜單中已存在的步驟',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': '策略：不修改現有步驟',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description': '傳播時，餐廳中已存在的步驟不會被修改。',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        '餐廳 A 的「選擇甜點」步驟有法式吐司（1 歐元）、水果（2 歐元）、Cookie（2 歐元）。\n品牌傳播 Cookie（1 歐元）、布朗尼（2 歐元）→ 餐廳 A 保留法式吐司（1 歐元）、水果（2 歐元）、Cookie（2 歐元）。\n\n👉 單個產品 Cookie 已更新，單個產品布朗尼已建立。',
    'menu.products.copy.form.channel.title': '選取目標頻道',
    'menu.products.copy.form.channel.tooltip':
        '選擇要套用產品和/或其步驟傳播的頻道（例如：收銀機、線上訂購 (CEL)、終端機）。',
    'menu.products.copy.form.channel.tooltip.title': '選取目標頻道',
    'menu.products.copy.form.channel.tooltip.example':
        '您傳播布朗尼甜點但只選擇終端機 → 該產品只會在所選餐廳的終端機菜單上可見。',
    'menu.products.copy.form.channel.web': '線上或桌邊訂購',
    'menu.products.copy.form.channel.kiosk': '終端機',
    'menu.products.copy.form.channel.pos': '收銀機',
    'menu.products.copy.form.channel.marketplace': 'Marketplace（UberEats/Deliveroo）',
    'menu.products.copy.form.channel.null': '未關聯',
    'menu.products.copy.form.other.strategies.title': '新產品建立',
    'menu.products.copy.form.other.strategies.tooltip':
        '傳播新產品時，品牌在步驟中傳播一個 2 歐元的 Cookie，最大數量為 3。如果您保留「產品價格」和「最大數量」，餐廳將保持 Cookie 為 2 歐元，最大數量為 3。→ 如果您保留「產品價格」和「最大數量」，餐廳將保持 Cookie 為 2 歐元，最大數量為 3。',
    'menu.products.copy.form.other.strategies.tooltip.title': '新產品建立',
    'menu.products.copy.form.other.strategies.tooltip.example':
        '傳播新產品時，品牌在步驟中傳播一個 2 歐元的 Cookie，最大數量為 3。如果您保留「產品價格」和「最大數量」，餐廳將保持 Cookie 為 2 歐元，最大數量為 3。\n→ 如果您保留「產品價格」和「最大數量」，餐廳將保持 Cookie 為 2 歐元，最大數量為 3。',
    'menu.products.copy.form.other.strategies.tags': '即時建立產品缺少的標籤',
    'menu.products.copy.form.other.strategies.categories': '即時建立產品缺少的類別',
    'menu.products.copy.form.posMenus.title': '收銀機的啟用菜單',
    'menu.products.copy.form.posMenus.description':
        '此表格僅顯示有多個啟用收銀機菜單的餐廳。如果只有一個收銀機菜單啟用，傳播預設在該菜單上進行。',
    'menu.products.copy.form.posMenus.tooltip': '選取您希望為每個餐廳傳播產品的收銀機菜單。',
    'menu.products.copy.form.posMenus.tooltip.title': '選取收銀機菜單',
    'menu.products.copy.form.posMenus.tooltip.example':
        '如果餐廳有多個收銀機菜單，您可以選擇傳播到一個或多個特定菜單。',
    'menu.products.copy.form.posMenus.column.restaurant': '餐廳名稱',
    'menu.products.copy.form.posMenus.column.menus': '啟用中的菜單',
    'menu.products.copy.form.posMenus.empty': '所選餐廳沒有可用的收銀機菜單',
    'menu.products.copy.form.posMenus.placeholder': '選取菜單...',
    'menu.products.copy.form.posMenus.warning': '⚠️ 注意，預設情況下，餐廳的所有啟用菜單都被選取用於產品傳播。',
    'menu.products.copy.form.marketplaceMenus.title': 'Marketplace 的啟用菜單',
    'menu.products.copy.form.marketplaceMenus.description':
        '此表格僅顯示有多個啟用 Marketplace 菜單的餐廳。如果只有一個 Marketplace 菜單啟用，傳播預設在該菜單上進行。',
    'menu.products.copy.form.marketplaceMenus.tooltip': '選取您希望為每個餐廳傳播產品的 Marketplace 菜單。',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': '選取 Marketplace 菜單',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        '如果餐廳有多個 Marketplace 菜單，您可以選擇傳播到一個或多個特定菜單。',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': '餐廳名稱',
    'menu.products.copy.form.marketplaceMenus.column.menus': '啟用中的菜單',
    'menu.products.copy.form.marketplaceMenus.empty': '所選餐廳沒有可用的 Marketplace 菜單',
    'menu.products.copy.form.marketplaceMenus.placeholder': '選取菜單...',
    'menu.products.copy.form.marketplaceMenus.warning': '⚠️ 注意，預設情況下，餐廳的所有啟用菜單都被選取用於產品傳播。',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': '傳播時，我希望：',
    'menu.products.copy.form.publishAfterCopy.marketplace': '自動在關聯的 Marketplace 上發布菜單',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer': '菜單將在與餐廳關聯的 Marketplace 上發布。',
    'menu.products.copy.form.disclaimer':
        '⚠️ 注意，此（些）產品將被複製到所有已選取的餐廳及其所有菜單中。儲存前，請檢查名稱、描述、圖片、增值稅、價格。',
    'menu.copy.validate.title': '驗證要傳播的產品/步驟',
    'menu.copy.validate.success': '所有要傳播的產品/步驟都有已配置的 SKU/步驟參考',
    'menu.copy.validate.warning': '品牌菜單的產品資料中未填寫 SKU',
    'menu.copy.validate.error': '品牌菜單中存在重複的 SKU 或未填寫的步驟參考',
    'menu.copy.validate.step.missing.identifier.detail': '步驟上未填寫步驟參考',
    'menu.copy.validate.product.missing.identifier.detail': '產品上未填寫 SKU',
    'menu.copy.validate.step.duplicate.identifier.detail': '步驟之間的參考 <b>{identifier}</b> 發生衝突',
    'menu.copy.validate.product.duplicate.identifier.detail': '產品之間的 SKU <b>{identifier}</b> 發生衝突',
    'menu.products.overwrite': '勾選左側核取方塊以編輯欄位',
    'menu.products.overwriteRelations': '勾選左側核取方塊以替換所有元素而非新增',
    'menu.products.error.alreadyTaken': '此產品已存在',
    'menu.products.error.billingCodeRequired': '自動計費需要填寫此欄位',
    'menu.products.add.title': '新增產品',
    'menu.products.edit.title': '編輯產品',
    'menu.products.propagate.title': '傳播產品',
    'menu.products.create.title': '建立產品',
    'menu.products.delete.confirm': '您確定要刪除 {count} 個產品嗎？',
    'menu.products.form.price': '含稅價格',
    'menu.product.form.pricePerkg': '含稅價格 / 公斤',
    'menu.products.form.priceType': '價格類型',
    'menu.products.form.priceType.placeholder': '價格類型',
    'menu.products.form.priceType.fixed': '固定價格',
    'menu.products.form.priceType.customizablePrice': '自由定價產品',
    'menu.products.form.priceType.customizablePriceAndLabel': '自由定價與標籤產品',
    'menu.products.form.measurementUnit': '計量單位',
    'menu.products.form.measurementUnit.placeholder': '計量單位',
    'menu.products.form.measurementUnit.unit': '單位',
    'menu.products.form.measurementUnit.kg': '公斤',
    'menu.products.form.kg.channelRestriction': '公斤計量的產品不適用於終端機頻道。',
    'menu.products.form.availability': '依頻道的可用性',
    'menu.products.form.webAvailability': '網頁',
    'menu.products.form.kioskAvailability': '終端機',
    'menu.products.form.servingCount': '用餐人數',
    'menu.products.form.barCode': '條碼',
    'menu.products.form.ticketLabel': '生產標籤',
    'menu.products.form.ticketLabel.checkbox': '使用與產品名稱不同的生產標籤',
    'menu.products.form.noVat': '產品不含增值稅',
    'menu.products.form.vat': '預設增值稅',
    'product.vatGroup': '增值稅群組',
    'product.vatGroup.withHint': '增值稅群組（內用/外帶/外送）',
    'product.selectVatGroup': '選取增值稅群組',
    'product.vatGroup.noOperationZone': '此餐廳未配置任何營業區域',
    'product.vatGroup.eatIn': '內用',
    'product.vatGroup.takeAway': '外帶',
    'product.vatGroup.delivery': '外送',
    'product.vatGroup.hint': '若要按消費模式變更增值稅，請修改「增值稅群組（內用/外帶/外送）」欄位',
    'menu.products.form.image.placeholder': '圖片',
    'menu.products.form.externalId': '外部代碼',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': '選擇 SKU',
    'menu.products.form.sku.noOption': '新 SKU 只能在品牌層級建立',
    'menu.products.form.createSku': '建立 SKU「{value}」',
    'menu.products.form.replaceSkuAll': '將 SKU「{currentSku}」替換為「{value}」（所有具有相同 SKU 的產品）',
    'menu.products.form.replaceSkuThisProduct': '將 SKU「{currentSku}」替換為「{value}」（僅此產品）',
    'menu.products.form.createTag': '建立標籤「{value}」',
    'menu.products.form.billingCode': '發票代碼',
    'menu.products.form.purchasePrice': '合約價格',
    'menu.products.form.description': '描述',
    'menu.products.form.description.tooLong': '描述不得超過 1500 個字元',
    'menu.products.form.additionalInformation': '附加資訊',
    'menu.products.form.section.options': '選項',
    'menu.products.form.section.quantity': '庫存管理',
    'menu.products.form.section.externalData': '外部資料',
    'menu.products.form.currentQuantitySwitch': '啟用產品的庫存管理',
    'menu.products.form.defaultQuantitySwitch': '每日庫存重置',
    'menu.products.form.currentQuantityInput': '庫存數量',
    'menu.products.form.defaultQuantityInput': '每日起始數量',
    'menu.products.form.defaultQuantityHint': '每天凌晨 4 點到 5 點之間，數量將重置為預設值',
    'menu.products.form.isEligibleLuncheon': '符合餐飲券資格',
    'menu.products.form.isFinalProduct': '最終產品',
    'menu.products.form.subsidizable': '可補貼產品',
    'menu.products.form.admissible': '可入場產品',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants': '每次加入購物車時乘以入場費/補貼',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        '啟用此選項後，如果產品多次加入購物車，或另一個帶有相同選項的產品加入購物車，則入場費（和補貼）將在訂單中倍增。倍增在定價方案中定義的每日限制和上限內進行。',
    'menu.products.form.excludedFromUrssaf': '不計入 URSSAF 最低限額',
    'menu.products.form.section.pos': '收銀機專屬屬性',
    'menu.products.form.minQuantity': '最小數量',
    'menu.products.form.alwaysAskForCustomization': '始終詢問步驟',
    'menu.products.form.discountable': '允許產品折扣',
    'menu.products.form.isDeposit': '押金類型產品',
    'menu.products.form.posPrice': '押金金額',
    'menu.products.form.vatSitIn': '內用增值稅',
    'menu.products.form.vatDelivery': '外送增值稅',
    'menu.products.form.vatTakeAway': '外帶增值稅',
    'menu.products.form.section.kitchenOptions': '廚房螢幕選項',
    'menu.products.form.isMenu': '是菜單',
    'menu.products.form.is_customization': '是自訂',
    'menu.products.form.isProducible': '顯示在摘要中',
    'menu.products.form.no_kitchen': '不在廚房螢幕上顯示',
    'menu.products.form.section.consumptionMode': '依消費模式的產品可用性',
    'menu.products.form.consumptionModeType.mode_sit_in': '內用',
    'menu.products.form.consumptionModeType.mode_delivery': '外送',
    'menu.products.form.consumptionModeType.mode_take_away': '外帶',
    'menu.products.form.consumptionModeType.mode_drive': '得來速',
    'menu.products.form.tags': '標籤',
    'menu.products.form.tags.placeholder': '搜尋要關聯的標籤',
    'menu.products.form.steps': '步驟',
    'menu.products.form.steps.page': '第 {pageNumber} 頁',
    'menu.products.form.steps.addToNewPage': '新增至新頁面',
    'menu.products.form.steps.addEachToNewPage': '將每個步驟新增至新頁面',
    'menu.products.form.steps.addToPage': '新增步驟的頁面',
    'menu.products.form.steps.addEmptyPage': '新增頁面',
    'menu.products.form.categories': '父類別',
    'menu.products.form.productType': '類型',
    'menu.products.form.productType.placeholder': '產品類型',
    'menu.products.form.productType.product': '產品',
    'menu.products.form.productType.deposit': '押金',
    'menu.products.form.categories.placeholder': '搜尋父類別',
    'menu.products.form.externalReference': '外部參考',
    'menu.products.form.externalReference.placeholder': '參考名稱',
    'menu.products.form.externalReference.name': '名稱',
    'menu.products.form.externalReference.value': '值',
    'menu.products.form.machineCode': '產品的 Nayax 機器代碼',
    'menu.products.form.steps.add': '新增步驟',
    'menu.products.form.steps.addPage': '將步驟拖曳到此處以建立新頁面',
    'menu.products.form.steps.column.name': '名稱',
    'menu.products.form.steps.column.type': '類型',
    'menu.products.form.steps.column.choices': '可選選項',
    'menu.products.form.steps.column.position': '頁面',
    'menu.products.form.steps.column.subPosition': '位置',
    'menu.products.form.steps.column.min': '最小值',
    'menu.products.form.steps.column.max': '最大值',
    'menu.products.form.steps.column.parentsProducts': '父產品數量',
    'menu.products.form.steps.cross-selling.add': '新增附加銷售',
    'menu.products.form.steps.customization.add': '新增自訂',
    'menu.products.form.steps.type.cross-selling': '附加銷售',
    'menu.products.form.steps.type.customization': '自訂',
    'reportGenerationsHistory.title': '生成歷史',
    'reportGenerationsHistory.subtitle': '您可以在此找到匯出的生成歷史。',
    'reportGenerationsHistory.tableCard.title': '匯出',
    'reportGenerationsHistory.tableCard.subtitle': '匯出清單',
    'reportGenerationsHistory.tableCard.actionLabel': '重新整理頁面',
    'reportGenerationsHistory.emptyMessage': '您的生成歷史為空',
    'reportGenerationsHistory.tableHeader.createdAt': '日期',
    'reportGenerationsHistory.tableHeader.fileName': '檔案名稱',
    'reportGenerationsHistory.tableHeader.reportType': '狀態',
    'reportGenerationsHistory.tableHeader.status': '進度',
    'reportGenerationsHistory.tableHeader.action': '下載',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': '預開票',
    'reportGenerationsHistory.tableRow.reportType.orders': '訂單',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': '徽章異動',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': '財務摘要',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary': '依管理模式的財務摘要',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': '每位客戶的徽章餘額',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        '依管理模式的不含稅財務摘要',
    'reportGenerationsHistory.tableRow.reportType.ewallet': '電子錢包',
    'reportGenerationsHistory.tableRow.reportType.accounting': '會計',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': '月度銷售報告',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': '完成',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': '進行中',
    'reportGenerationsHistory.tableRow.generationStatus.failed': '失敗',
    'reportGenerationsHistory.tableRow.action.download': '下載',
    'report.emptyMessage': '無結果',
    'report.title.monthly_sales_report': '月度銷售報告',
    'report.selectDateRangeButton.text': '從 {startDate} 至 {endDate}',
    'report.calendarModal.dateRage.errorMessage': '您不能選取超過 {maxRangeInDays} 天',
    'report.calendarModal.title': '選擇期間',
    'report.calendarModal.submit': '確認',
    'report.filtersButton.text': '篩選器',
    'report.filtersModal.title': '選擇篩選器',
    'report.filtersModal.submit': '篩選',
    'report.filtersModal.form.restaurantLabel': '餐廳',
    'report.filtersModal.form.devicesLabel': '收銀機',
    'report.filtersModal.form.sourcesLabel': '訂購頻道',
    'report.filtersModal.form.tagsLabel': '標籤',
    'report.filtersModal.form.consumptionModesLabel': '消費模式',
    'report.filtersModal.form.sellersLabel': '銷售員',
    'report.filtersModal.form.vatsLabel': '增值稅',
    'report.filtersModal.form.categoriesLabel': '類別',
    'report.filtersModal.form.loyaltyLabel': '僅顯示以忠誠度支付的訂單',
    'report.filtersModal.form.only_parentsLabel': '顯示父類別',
    'report.filtersModal.saveAs.placeholder': '另存新檔...',
    'report.filtersModal.saveAs.save': '儲存並套用',
    'report.exportButton.text': '匯出',
    'report.exportResultModal.title': 'CSV 匯出',
    'report.exportResultModal.resultSuccess': '正在生成匯出',
    'report.exportResultModal.stayInPage': '留在此頁面',
    'report.exportResultModal.redirectToGenerationHistory': '查看進行中的匯出',
    'report.exportResultModal.resultFail': 'A problem has occurred, please try again in a few moments',
    'report.savedFiltersDropdown.placeholder': '已儲存的篩選器',
    'report.savedFiltersDropdown.deleteModal.title': '注意',
    'report.savedFiltersDropdown.deleteModal.description': '您確定要刪除嗎？',
    'salesSummary.tableCard.title': '生成新的匯出',
    'salesSummary.tableCard.subtitle': '選取您的條件和篩選器，點擊「生成」。',
    'salesSummary.form.choosePeriod': '選擇期間',
    'salesSummary.form.reportType': '報告格式',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': '依管理模式的財務摘要',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax': '依管理模式的不含稅財務摘要',
    'salesSummary.form.reportType.salesSummary': '財務摘要',
    'salesSummary.form.restaurants': '餐廳',
    'salesSummary.form.groups': '群組',
    'salesSummary.form.pricingRules': '定價方案',
    'salesSummary.form.accountedOrders': '已計算訂單',
    'salesSummary.form.accountedOrders.all': '訂單 + 反向分錄',
    'salesSummary.form.accountedOrders.ordersOnly': '訂單',
    'salesSummary.form.accountedOrders.contraEntriesOnly': '反向分錄',
    'salesSummary.exportResultModal.title': '生成匯出',
    'shift.default': '預設',
    'shift.allDays': '每天',
    'shift.period': '從 {start} 至 {end}',
    'shift.days.MON': '星期一',
    'shift.days.TUE': '星期二',
    'shift.days.WED': '星期三',
    'shift.days.THU': '星期四',
    'shift.days.FRI': '星期五',
    'shift.days.SAT': '星期六',
    'shift.days.SUN': '星期日',
    'shift.amount.required': '金額為必填',
    'shift.amount.positive': '金額必須為正數',
    'shift.threshold.positive': '門檻必須為正數',
    'shift.ceiling.required': '百分比補貼為必填',
    'shift.vat.required': '增值稅為必填',
    'shift.vat.positive': '增值稅必須為正數',
    'brandHistory.tableCard.title': '歷史',
    'brandHistory.tableCard.subtitle': '搜尋在品牌上執行的操作',
    'brandHistory.emptyMessage': '未找到歷史記錄',
    'brandHistory.searchPlaceholder': '在歷史記錄中搜尋',
    'brandHistory.entityType': '實體類型',
    'brandHistory.entityType.GRANT': '補貼',
    'brandHistory.entityType.ENTRANCE_FEE': '入場費',
    'brandHistory.entityType.PRICING_RULE': '定價方案',
    'brandHistory.entityType.PRODUCT': '產品',
    'brandHistory.entityType.STEP': '步驟',
    'brandHistory.entityType.CATEGORY': '類別',
    'brandHistory.entityType.MENU': '菜單',
    'brandHistory.entityType.MODULE': '模組',
    'brandHistory.entityType.CUSTOMER': '客戶',
    'brandHistory.entityType.CUSTOMERS_IMPORT': '客戶匯入',
    'brandHistory.entityType.CUSTOMERS_UPDATE': '客戶修改',
    'brandHistory.entityType.USER': '使用者',
    'brandHistory.entityType.CHANNEL': '頻道',
    'brandHistory.entityType.CONSUMPTION_MODE': '消費模式',
    'brandHistory.entityType.ORDER': '訂單',
    'brandHistory.entityType.BRAND': '品牌',
    'brandHistory.entityType.RESTAURANT': '餐廳',
    'brandHistory.entityName': '實體名稱',
    'brandHistory.restaurant': '餐廳',
    'brandHistory.user': '使用者',
    'brandHistory.action': '操作',
    'brandHistory.eventDate': '日期',
    'brandHistory.action.create': '建立',
    'brandHistory.action.open': '開啟',
    'brandHistory.action.activate': '啟用',
    'brandHistory.action.duplicate': '複製',
    'brandHistory.action.delete': '刪除',
    'brandHistory.action.close': '關閉',
    'brandHistory.action.deactivate': '停用',
    'brandHistory.action.cancel': '取消',
    'brandHistory.action.update': '修改',
    'brandHistory.action.import': '匯入',
    'brandHistory.action.unknown': '未知',
    'brandHistory.modal.title': '已執行操作的報告',
    'brandHistory.modal.actions': '操作報告',
    'brandHistory.modal.logs': '日誌報告',
    'brandHistory.modal.informations': '關聯資訊',
    'brandHistory.modal.entityName': '實體名稱',
    'brandHistory.modal.user': '使用者：',
    'brandHistory.modal.date': '變更日期：',
    'brandHistory.modal.close': '關閉',
    'brandHistory.modal.empty': '此處什麼都找不到 😰',
    'crossSelling.name': '附加銷售頁面名稱',
    'crossSelling.page.title': '附加銷售',
    'crossSelling.page.description': '建立並管理您的附加銷售頁面',
    'crossSelling.action.newCrossSelling': '+ 新增附加銷售頁面',
    'crossSelling.modal.duplicate.title': '複製附加銷售頁面',
    'crossSelling.modal.create.title': '建立您的附加銷售頁面',
    'crossSelling.modal.delete.title': '刪除附加銷售頁面',
    'crossSelling.modal.delete.description': '您確定要刪除頁面：「{crossSellingName}」 嗎？',
    'crossSelling.modal.error.name': '請在指定欄位中輸入名稱',
    'crossSelling.modal.menu.name': '附加銷售頁面名稱',
    'crossSelling.page.create.title': '建立附加銷售頁面',
    'crossSelling.page.update.title': '修改附加銷售頁面「{crossSellingName}」',
    'crossSelling.page.create.description': '附加銷售頁面配置',
    'crossSelling.page.update.description': '附加銷售頁面配置',
    'crossSelling.products.image': '圖片',
    'crossSelling.products.name': '名稱',
    'crossSelling.products.price': '價格',
    'crossSelling.products.vat': '增值稅',
    'crossSelling.products.tags': '標籤',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': '菜單',
    'crossSelling.products.menuState': '菜單狀態',
    'crossSelling.products.restaurantName': '餐廳',
    'crossSelling.products.add': '新增產品',
    'crossSelling.products.menuState.enabled': '已啟用',
    'crossSelling.products.menuState.disabled': '已停用',
    'tableLayout.name': '桌位平面圖名稱',
    'tableLayout.page.title': '桌位平面圖',
    'tableLayout.page.description': '建立並管理您的桌位平面圖',
    'tableLayout.table.associatedPos': '關聯收銀機',
    'tableLayout.action.newTableLayout': '+ 新增桌位平面圖',
    'tableLayout.modal.create.title': '建立桌位平面圖',
    'tableLayout.modal.edit.title': '修改桌位平面圖「{tableLayoutName}」',
    'tableLayout.modal.delete.title': '刪除桌位平面圖',
    'tableLayout.modal.delete.description': '您確定要刪除桌位平面圖：「{tableLayoutName}」 嗎？',
    'tableLayout.modal.publish.title': '發布桌位平面圖',
    'tableLayout.modal.publish.description': '您確定要發布桌位平面圖：「{tableLayoutName}」 嗎？',
    'tableLayout.modal.error.name': '請在指定欄位中輸入名稱',
    'room.name': '廳室名稱',
    'room.page.title': '廳室',
    'room.page.description': '建立並管理您的廳室',
    'room.action.newRoom': '+ 新增廳室',
    'room.action.publish': '發布桌位平面圖',
    'room.modal.create.title': '建立廳室',
    'room.modal.edit.title': '修改廳室「{roomName}」',
    'room.modal.view.title': '廳室「{roomName}」',
    'room.modal.single': '新增桌子',
    'room.modal.single.placeholder': '主桌',
    'room.modal.multiple': '新增多張桌子',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': '整理桌子',
    'room.modal.delete.title': '刪除廳室',
    'room.modal.delete.description': '您確定要刪除廳室：「{roomName}」 嗎？',
    'room.modal.error.name': '請在指定欄位中輸入名稱',
    'room.modal.error.new_table_name': '請輸入桌子名稱或編號',
    'room.modal.error.fill_start_and_end': '請輸入起始值和結束值（必須大於起始值）',
    'room.modal.error.max_count_table': '每個廳室不能超過 {maxCount} 張桌子。',
    'pos.configuration': '設定',
    'pos.devices': '收銀機',
    'pos.access': '角色與權限',
    'pos.access.users': '使用者',
    'pos.access.roles': '角色',
    'pos.access.groups': '群組',
    'pos.users.page.title': '收銀機操作員',
    'pos.roles.page.title': '收銀機角色與權限',
    'pos.groups.page.title': '收銀機存取群組',
    'pos.users.page.description': '收銀機操作員可定義能與收銀機互動的使用者。',
    'pos.roles.page.description': '收銀機角色可為收銀機使用者定義權限群組。',
    'pos.groups.page.description': '存取群組管理使用者及其與餐廳收銀機的關聯',
    'pos.users.action.newUser': '建立新操作員',
    'posUser.name.form.label': '操作員名稱',
    'posUser.name.form.placeholder': '收銀機操作員名稱',
    'posUser.pinCode.form.label': '操作員 PIN 碼',
    'posUser.pinCode.form.placeholder': '收銀機操作員 PIN 碼',
    'posUser.role.form.label': '操作員角色',
    'posGroup.name.form.label': '群組名稱',
    'posGroup.name.form.placeholder': '輸入存取群組名稱',
    'posGroup.users.form.label': '操作員',
    'posGroup.users.form.placeholder': '選擇關聯的操作員',
    'posGroup.devices.form.label': '收銀機',
    'posGroup.devices.form.placeholder': '選擇關聯的收銀機',
    'posUser.create.form.title': '建立新收銀機操作員',
    'posGroup.create.form.title': '建立新存取群組',
    'posGroup.edit.form.title': '修改存取群組',
    'posUser.edit.form.title': '編輯收銀機操作員：',
    'posUser.form.description': '請填寫您的收銀機操作員資訊。',
    'posGroup.form.description': '請填寫您的收銀機存取群組資訊。',
    'posUser.form.creation': '建立收銀機操作員',
    'posUser.form.edit': '編輯收銀機操作員',
    'posUser.form.update': '編輯收銀機操作員',
    'posRole.form.title': '收銀機角色',
    'posRole.form.description': '您可以在此頁面更新您的收銀機角色權限',
    'posRole.form.creation': '建立收銀機角色',
    'posRole.form.update': '編輯收銀機角色',
    'posGroup.form.creation': '建立存取群組',
    'posGroup.form.update': '編輯存取群組',
    'posRole.form.rolePermissions': '角色權限',
    'posRole.form.name.title': '角色名稱',
    'posRole.form.name.placeholder': '角色',
    'pos.groups.action.create': '建立新群組',
    'permissions.permissions': '權限',
    'assiciated.devices': '關聯的收銀機',
    'assiciated.operators': '關聯的操作員',
    'posRole.Operator': '操作員',
    'posRole.Manager': '經理',
    'posRole.Owner': '負責人',
    'posRole.Auditor': '稽核員',
    'posRole.Treasurer': '財務員',
    'posRole.Support': '支援',
    'posRole.Trainer': '培訓員',
    'posRole.InCharge': '主管',
    'posRole.OperatorSupervisor': '操作員督導',
    'posRole.AssistantOperator': '操作員助理',
    'posRole.AssistantToTheRegionalManager': '助理經理',
    'posRole.CustomOperator1': '自訂操作員 1',
    'posRole.CustomOperator2': '自訂操作員 2',
    'posRole.CustomOperator3': '自訂操作員 3',
    'channels.page.title': '頻道清單',
    'channels.page.description': '訂購頻道讓您可以提供各種功能，例如線上訂購、銷售點自助服務機訂購或忠誠度管理。',
    'channels.installed': '已安裝應用程式',
    'channels.button.configure': '設定',
    'channels.button.disable': '停用',
    'channels.button.enable': '啟用',
    'channels.kiosk.name': '自助服務機',
    'channels.kiosk.description': '以最佳方式重新打造銷售點體驗。',
    'channels.web.name': '線上訂購',
    'channels.web.description': '透過您自己的網站新增銷售點。',
    'channels.reception.name': '接待',
    'channels.reception.description': '專為您的網路及自助機訂單設計的介面。',
    'channels.pos.name': 'POS',
    'channels.pos.description': '簡單且整合於您環境的結帳系統。',
    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': '透過完善的組織，進一步提升廚房效率。',
    'channels.loyalty.name': '忠誠度',
    'channels.loyalty.description': '建立忠誠度計畫，讓顧客回流銷售點。',
    'channels.ewallet_kiosk.name': 'E-Wallet 充值機',
    'channels.ewallet_kiosk.description': '快速充值 E-wallet 的全新頻道。',
    'channels.vending_machine.name': '自動販賣機',
    'channels.vending_machine.description': '在您的咖啡機和飲料販賣機上提供 e-wallet 支付。',
    'accessFlags.CAN_ACCESS_BRAND_HISTORY': '可存取品牌歷史頁面',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': '可存取客戶頁面',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION': '可存取補貼與入場費分頁',
    'accessFlags.CAN_ACCESS_IO_PAY': '可存取付款模組',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': '可封存客戶',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': '可建立金額為負的訂單',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE': '可建立使用者餘額轉為負數的訂單',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': '可以後付款方式為用餐者的 e-wallet 儲值',
    'accessFlags.CAN_EDIT_AREAS': '可編輯配送區域',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': '自動計費：可修改參考資料',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': '可編輯客戶憑證',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': '可匯出客戶資料並對 E-wallet 進行儲值/扣款',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE': '可強制新客戶修改預設提供的憑證',
    'accessFlags.CAN_MANAGE_BO_USERS': '可管理後台使用者',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT': '可管理品牌層級的允許透支',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': '可管理客戶層級的允許透支',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME': '僅可編輯產品及相關步驟的價格和名稱',
    'accessFlags.CAN_SYNC_SALES': '可同步銷售資料',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': '可修改桌位配置',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': '可建立自訂價格的訂單',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS': '可為所有產品建立自訂價格的訂單',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': '可建立或刪除分類',
    'accessFlags.MENU_CATEGORY_EDIT': '可編輯分類',
    'accessFlags.MENU_CREATE_OR_DELETE': '可建立或刪除菜單',
    'accessFlags.MENU_EDIT': '可編輯菜單',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': '可建立或刪除產品',
    'accessFlags.MENU_PRODUCT_EDIT': '可編輯產品',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': '限制編輯僅限產品價格',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': '僅封鎖產品價格的編輯',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': '可建立或刪除步驟',
    'accessFlags.MENU_STEP_EDIT': '可編輯步驟',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': '可建立或刪除標籤',
    'accessFlags.MENU_TAG_EDIT': '可編輯標籤',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': '可修改自己的密碼',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': '可取消訂單（對沖分錄）',
    'accessFlags.CAN_CREATE_SKU': '可建立 SKU',
    'accessFlagsGroups.customers': '客戶管理',
    'accessFlagsGroups.financial': '財務管理 / E-Wallet',
    'accessFlagsGroups.orders': '訂單管理',
    'accessFlagsGroups.catalog': '目錄管理',
    'accessFlagsGroups.subsidies': '補貼與入場費',
    'accessFlagsGroups.configuration': '餐廳設定',
    'accessFlagsGroups.administration': '管理與帳號',
    'accessFlagsGroups.others': '其他權限',
    'accessFlagsSubsections.categories': '分類',
    'accessFlagsSubsections.menus': '菜單',
    'accessFlagsSubsections.products': '產品',
    'accessFlagsSubsections.steps': '步驟',
    'accessFlagsSubsections.tags': '標籤',
    'accessFlagsControl.expandAll': '全部展開',
    'accessFlagsControl.collapseAll': '全部收合',
    'accessFlagsControl.permission': '權限',
    'accessFlagsControl.permissions': '權限',
    'userRestaurants.noRestaurants': '沒有可用的餐廳',
    'brandUsers.email': '電子郵件',
    'brandUsers.lastConnection': '最後登入',
    'brandUsers.login': '登入',
    'brandUsers.loginAs': '以此身份登入',
    'brandUsers.loginAsBrandGroup': '多品牌帳號（無法登入）',
    'brandUsers.newUser': '+ 新增使用者',
    'brandRestaurants.newRestaurant': '+ 新增餐廳',
    'brandRestaurants.create.restaurantInfo': '餐廳資訊',
    'brandRestaurants.create.restaurantName': '餐廳名稱',
    'brandRestaurants.create.phone': '電話號碼',
    'brandRestaurants.create.address': '地址',
    'brandRestaurants.create.locale': '語言',
    'brandRestaurants.create.currency': '貨幣',
    'brandRestaurants.create.operationZone': '營運區域',
    'brandRestaurants.create.operationZone.skip': '略過 - 稍後設定',
    'brandRestaurants.create.operationZoneConfigure': '營運區域設定',
    'brandRestaurants.create.operationZone.selectProvider': '選擇合規模式',
    'brandRestaurants.create.operationZone.currencyMismatch':
        '此區域使用與品牌不同的貨幣。需要新建品牌才能在此貨幣下營運。',
    'brandRestaurants.create.manager': '管理員',
    'brandRestaurants.create.selectExistingUser': '選擇現有使用者',
    'brandRestaurants.create.createNewUser': '建立新使用者',
    'brandRestaurants.create.skipManager': '略過此步驟',
    'brandRestaurants.create.letUserChoosePassword': '讓使用者自行選擇密碼',
    'brandRestaurants.create.done.title': '完成！',
    'brandRestaurants.create.done.message': '您已準備好設定 {name}',
    'brandRestaurants.create.done.configure': '設定',
    'user.create.title': '建立新使用者',
    'user.create.firstName': '名字',
    'user.create.lastName': '姓氏',
    'user.create.phone': '電話號碼',
    'user.create.email': '電子郵件',
    'user.create.password': '密碼',
    'user.create.confirmPassword': '確認密碼',
    'user.create.letUserChoosePassword': '讓使用者自行選擇密碼',
    'user.create.error.phone.length': '電話號碼必須包含 10 位數字。',
    'user.create.error.phone.valid': '此號碼無效',
    'user.create.error.password.min': '密碼無效（最少 12 個字元）',
    'user.create.error.passwordConfirm.sameAsPassword': '兩組密碼必須相同',
    'brands.restaurantscount': '餐廳數量',
    'brands.favorite': '我的最愛',
    'brands.create': '+ 新增品牌',
    'brands.form.title': '建立新品牌',
    'brands.form.brandInfo': '品牌資訊',
    'brands.form.brandInfo.title': '品牌名稱',
    'brands.form.selectUser': '選擇品牌負責人',
    'brands.form.selectUser.title': '建立品牌負責人',
    'brands.form.canals': '選擇品牌的訂購頻道',
    'brands.form.canals.title': '管理頻道',
    'brands.form.brandName': '名稱',
    'brands.form.region': '地區與語言',
    'brands.form.currency': '貨幣',
    'brands.form.firstName': '名字 *',
    'brands.form.lastName': '姓氏 *',
    'brands.form.phoneNumber': '電話號碼 *',
    'brands.form.email': '電子郵件 *',
    'brands.form.password': '密碼 *',
    'brands.form.confirmPassword': '確認密碼 *',
    'brands.form.error.phone.valid': '此號碼無效',
    'brands.form.error.password.min': '密碼無效（最少 12 個字元）',
    'brands.form.error.passwordConfirm.sameAsPassword': '兩組密碼必須相同',
    'posPermissions.accessPermissions': '存取權限',
    'posPermissions.otherPermissions': '其他權限',
    'posPermissions.ACCESS_CATALOG_SCREEN': '目錄',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': '客戶',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': '選項',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': '備用金',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': '促銷',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': '外送員',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': '桌位配置',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': '新訂單',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': '訂單追蹤',
    'posPermissions.ACCESS_PARAMETER_SCREEN': '設定',
    'posPermissions.ACCESS_PRINTER_SCREEN': '印表機',
    'posPermissions.ACCESS_RAZ_SCREEN': '報表',
    'posPermissions.ACCESS_TICKET_SCREEN': '收據',
    'posPermissions.ACCESS_USER_SCREEN': '使用者',
    'posPermissions.APPLY_DISCOUNT': '套用促銷',
    'posPermissions.CANCEL_ORDER': '取消訂單',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': '取消訂單中已驗證的產品',
    'posPermissions.CREATE_GROUP': '建立群組',
    'posPermissions.CREATE_PRODUCT': '建立產品',
    'posPermissions.DELETE_DEFAULT_PRINTER': '刪除預設印表機',
    'posPermissions.DISCONNECT': '斷開收銀機連線',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': '下單時輸入折扣',
    'posPermissions.EXPORT_ARCHIVE': '匯出封存檔案',
    'posPermissions.FORCE_ORDER_SHIFT': '強制訂單換班',
    'posPermissions.GENERATE_ARCHIVE': '產生財務封存檔案',
    'posPermissions.JUSTIFY_ORDERS': '為訂單提供說明',
    'posPermissions.LINK_A_BADGE': '關聯識別證',
    'posPermissions.MODIFY_FEATURE_OPTIONS': '修改選項',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': '長按修改功能',
    'posPermissions.MODIFY_GROUP_FROM_GRID': '長按修改群組',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': '修改購物車中產品的價格',
    'posPermissions.MODIFY_PASSWORD': '修改密碼',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': '顯示產品資料',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE': '修改產品代碼、計費及計費價格',
    'posPermissions.MODIFY_PRODUCT_PRICE': '修改產品資料中的價格',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': '修改產品資料中的其他屬性',
    'posPermissions.MODIFY_TICKET': '修改收據',
    'posPermissions.MODIFY_TICKET_GROUPS': '修改收據群組',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': '修改收據的訂單類型',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': '修改收據的訂單狀態',
    'posPermissions.MODIFY_TICKET_QUANTITY': '修改收據數量',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': '修改訂單中已驗證的產品',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': '提供免費產品',
    'posPermissions.OPEN_CASH_DRAWER': '開啟錢箱',
    'posPermissions.PRINT_VALID_TICKET': '列印已驗證的收據',
    'posPermissions.REFUND_CLIENT': '退款給客戶',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': '從目錄中刪除產品',
    'posPermissions.REOPEN_ORDER': '重新開啟訂單',
    'posPermissions.SEARCH_CLIENT': '手動搜尋客戶',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': '在新訂單畫面上顯示強制餐點按鈕',
    'posPermissions.SYNC_ARCHIVE': '同步封存檔案',
    'posPermissions.VIEW_AUDIT_TRAIL': '查看稽核軌跡',
    'posPermissions.VIEW_FEATURE_OPTIONS': '查看選項',
    'posPermissions.VIEW_ORDER_AUDIT': '查看訂單稽核',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': '在報表中顯示營業額',
    'posPermissions.VIEW_TICKET_AUDIT': '查看收據稽核',
    'posPermissions.VIEW_TICKET_TEMPLATE': '查看收據範本',
    'posPermissions.MODIFY_TICKET_PRINTER': '修改收據印表機',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': '驗證 TPE 操作',
    'multiBrand.user': '使用者',
    'badgeReader.empty': '未設定任何識別證讀取器',
    'badgeReader.notConfigured': '您似乎尚未設定識別證讀取器。請前往我們的',
    'badgeReader.help': '說明專區。',
    'badgeReader.create': '建立識別證讀取器',
    'badgeReader.table.title': '識別證讀取器',
    'badgeReader.table.name': '讀取器名稱',
    'badgeReader.table.deviceUuid': '讀取器 UUID',
    'badgeReader.table.driver': '讀取器技術',
    'badgeReader.table.driverConfigs': '技術變數',
    'badgeReader.table.readingConditions': '讀取規則',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': '條件 #{index}：',
    'badgeReader.readingCondition.stringLength': '• 若長度 = {stringLength} 個字元',
    'badgeReader.readingCondition.convertBefore.none': '• 不進行轉換',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• 轉換為十進位 = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• 轉換為 ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• 轉換為十六進位 = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• 刪除零值',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• 反轉字元',
    'badgeReader.readingCondition.convertBefore.prefix': '• 以字元 {prefix} 為前綴，直到 {substrLength} 個字元',
    'badgeReader.readingCondition.substrPositionStart': '• 從第 {substrPositionStart} 個字元開始讀取',
    'badgeReader.readingCondition.substrLength': '• 讀取 {substrLength} 個字元',
    'badgeReader.readingCondition.convertAfter.none': '• 不轉換這 {substrLength} 個字元',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• 將這些十進位字元轉換為 {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex': '• 將這些十六進位字元轉換為 {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• 將這些 ASCII 字元轉換為 {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• 刪除零值',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• 反轉這 {substrLength} 個字元',
    'badgeReader.delete.confirmation': '確定要刪除嗎？',
    'badgeReader.delete.warning': '警告',
    'badgeReader.cancel.confirmation': '確定要取消設定嗎？',
    'badgeReader.cancel.warning': '警告',
    'badgeReader.driver.keyboard': '鍵盤輸出',
    'badgeReader.driver.serial': '序列通訊協定（RS232）',
    'badgeReader.driver.toqla': 'Toqla',
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    'badgeReader.convertion.none': '不轉換',
    'badgeReader.convertion.hex-dec': '十六進位轉十進位',
    'badgeReader.convertion.hex-ascii': '十六進位轉 ASCII',
    'badgeReader.convertion.dec-hex': '十進位轉十六進位',
    'badgeReader.step.information': '建立讀取器',
    'badgeReader.step.driverConfigs': '技術變數',
    'badgeReader.step.readingCondition': '讀取規則',
    'badgeReader.form.name': '讀取器名稱',
    'badgeReader.form.deviceId': '讀取器 USB 識別碼',
    'badgeReader.form.deviceUuid': '讀取器 UUID',
    'badgeReader.form.driver': '讀取器技術',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': '鍵盤配置',
    'badgeReader.form.readingCondition.order': '條件編號',
    'badgeReader.form.readingCondition.stringLength': '長度',
    'badgeReader.form.readingCondition.convertBefore': '事前轉換？',
    'badgeReader.form.readingCondition.substrPositionStart': '起始 / 前綴',
    'badgeReader.form.readingCondition.substrLength': '長度',
    'badgeReader.form.readingCondition.convertAfter': '事後轉換？',
    'badgeReader.step.readingCondition.add': '新增 +',
    'badgeReader.form.convertion.none': '停用',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': '刪除零值',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': '逐位元反轉十六進位',
    'badgeReader.form.convertion.prefix': '前綴',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',
    'posDevice.catalogHistory.title': '目錄歷史記錄',
    'posDevice.catalogHistory.table.hash': '雜湊值',
    'posDevice.catalogHistory.table.date': '建立日期',
    'posDevice.catalogHistory.table.actions': '操作',
    'posDevice.catalogHistory.button.download': '下載',
    'passwordUpdate.title': '更新密碼',
    'passwordUpdate.currentPassword': '舊密碼',
    'passwordUpdate.newPassword': '新密碼',
    'passwordUpdate.confirmPassword': '確認新密碼',
    'passwordUpdate.update': '儲存',
    'passwordUpdate.passwordMismatch': '新密碼與確認密碼不相符。',
    'passwordUpdate.passwordMinLength': '密碼至少需要 12 個字元。',
    'passwordUpdate.success': '密碼更新成功',
    'notification.guestHierarchy.title': '最新消息',
    'notification.guestHierarchy.content': '帳戶階層設定已更新。',
    'notification.guestHierarchy.link': '點擊以了解更多',
    'guestHierarchyTraining.page1.title': '歡迎使用客戶路徑管理',
    'guestHierarchyTraining.page1.content':
        '客戶路徑管理可在後台 (BO) 對用餐者帳號進行嚴格設定。其基於<b>群組 → 區段 → 子區段</b>的階層架構，以及對這些元素指派<b>定價方案</b>。此架構確保最佳化且一致的管理。',
    'guestHierarchyTraining.page2.title': '存取階層設定',
    'guestHierarchyTraining.page2.content':
        '開啟新的<b>階層設定</b>分頁。此空間可<b>建立、修改</b>群組、區段及子區段。',
    'guestHierarchyTraining.page3.title': '建立或修改群組',
    'guestHierarchyTraining.page3.content':
        '• 前往<b>階層設定 > 群組。</b> {br}• 點擊<b>「建立群組」</b>或修改現有群組。 {br}• 群組需有<b>唯一標籤</b> (1) {br}• 為關聯至此群組的用餐者定義<b>允許的定價方案</b> (2)',
    'guestHierarchyTraining.page4.title': '建立或修改區段',
    'guestHierarchyTraining.page4.content':
        '• 前往<b>階層設定 > 區段。</b> {br}• 點擊<b>「建立區段」</b>或修改現有區段。 {br}• 將區段指派至<b>現有群組</b>。(1) {br}• 需有唯一標籤。(2) {br} • 為關聯至此區段的用餐者定義<b>允許的定價方案</b> (3)',
    'guestHierarchyTraining.page5.title': '建立或修改子區段',
    'guestHierarchyTraining.page5.content':
        '• 前往<b>階層設定 > 子區段。</b> {br}• 點擊<b>「建立子區段」</b>或修改現有子區段。 {br}• 將子區段指派至<b>現有區段</b>。(1 和 2) {br}• 需有唯一標籤。(3) {br} • 為關聯至此子區段的用餐者定義<b>允許的定價方案</b> (4)',
    'guestHierarchyInfo.title': '建立用餐者',
    'guestHierarchyInfo.content': '建立用餐者時，系統會根據所選的群組、區段或子區段自動篩選可用的定價方案。',
    'loyalty.features.title': '已啟用功能',
    'loyalty.features.MultiRewardSelection': '多重獎勵選擇',
    'loyalty.features.Promocode': '促銷代碼',
    'loyalty.features.Deals': '優惠',
    'loyalty.features.PointPayment': '點數支付',
    'splio.title': '整合 - Splio 忠誠度',
    'splio.integrationEnabled': '整合已於 {date} 啟用',
    'splio.description':
        '在以下欄位輸入 API 金鑰，將您的 Splio 計畫與您的餐廳及 Innovorder 產品關聯。\n此 API 金鑰可從您的 Splio 介面取得。',
    'splio.apiKey.placeholder': '輸入您的 Splio API 金鑰',
    'splio.apiKey': 'Splio API 金鑰',
    'splio.programId': '忠誠度計畫',
    'splio.allowCustomerRewardUsage': '允許客戶使用獎勵',
    'splio.formLink': '前往註冊表單的連結',
    'splio.optIn': '關聯行銷電子報的 OptIn',
    'splio.memberIdentifier': '建立帳號的識別碼',
    'splio.useCasualTone': '啟用非正式稱謂',
    'splio.authenticationMethods': '允許的忠誠度驗證方法',
    'splio.registerMethods': '允許的忠誠度註冊方法',
    'splio.methods.email': '電子郵件',
    'splio.methods.phone': '電話',
    'splio.methods.externalId': '忠誠度識別碼',
    'splio.update.success': 'Splio 整合已成功更新',
    'splio.subscriptionToMarketingNewsletter': '訂閱行銷電子報',
    'splio.subscriptionToLoyaltyNewsletter': '訂閱忠誠度電子報',
    'splio.deleteModal.title': '刪除 Splio 整合',
    'splio.deleteModal.text': '確定要刪除 Splio 整合嗎？',
    'splio.error.formLinkInvalid': '表單連結無效',
    'splio.error.changeProvider': '此餐廳已設定忠誠度整合，請先刪除',
    'pickupPoint.page.title': '取貨地點',
    'pickupPoint.page.description': '建立並管理您的取貨地點',
    'pickupPoint.action.create': '建立取貨地點',
    'pickupPoint.modal.createPickupPoint': '建立取貨地點',
    'pickupPoint.modal.editPickupPoint': '修改取貨地點',
    'pickupPoint.modal.deletePickupPoint': '刪除取貨地點',
    'pickupPoint.modal.delete.title': '刪除取貨地點',
    'pickupPoint.modal.delete.description': '確定要刪除取貨地點「{name}」嗎？',
    'pickupPoint.modal.pickupPoint.name': '名稱',
    'pickupPoint.modal.pickupPoint.address': '地址',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': '補充地址資訊',
    'pickupPoint.modal.pickupPoint.name.placeholder': '取貨地點名稱',
    'pickupPoint.modal.pickupPoint.address.placeholder': '取貨地點地址',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': '取貨地點補充地址資訊',
    'pickupPoint.modal.warn.shift.title': '警告',
    'pickupPoint.modal.warn.shift.text':
        '刪除此取貨地點前，請確認沒有進行中的訂單。刪除後，客戶將看不到此地點，進行中的訂單也將遺失。',
    'pickupPoint.modal.warn.shift.button': '已了解',
    'como.title': '整合 - Como 忠誠度',
    'como.description':
        '在以下欄位輸入 API 金鑰，將您的 Como 計畫與您的餐廳及 Innovorder 產品關聯。\n此 API 金鑰可從您的 Como 介面取得。',
    'como.apiKey': 'Como API 金鑰',
    'como.integrationEnabled': '整合已於 {date} 啟用',
    'como.apiKey.placeholder': '輸入您的 Como API 金鑰',
    'como.formLink': '前往註冊表單的連結',
    'como.useCasualTone': '啟用非正式稱謂',
    'como.authenticationMethods': '允許的忠誠度驗證方法',
    'como.registerMethods': '允許的忠誠度註冊方法',
    'como.methods.email': '電子郵件',
    'como.methods.phone': '電話',
    'como.methods.externalId': '忠誠度識別碼',
    'como.error.formLinkInvalid': '表單連結無效',
    'como.update.success': 'Como 整合已成功更新',
    'como.deleteModal.title': '刪除 Como 整合',
    'como.deleteModal.text': '確定要刪除 Como 整合嗎？',
    'como.error.changeProvider': '此餐廳已設定忠誠度整合，請先刪除',
    'como.error.invalidApiKey': '輸入的 API 金鑰無效。',
    'zerosix.title': '整合 - Zerosix 忠誠度',
    'zerosix.description':
        '在以下欄位輸入 API 金鑰，將您的 Zerosix 計畫與您的餐廳及 Innovorder 產品關聯。\n此 API 金鑰可從您的 Zerosix 介面取得。',
    'zerosix.apiKey': 'Zerosix API 金鑰',
    'zerosix.integrationEnabled': '整合已於 {date} 啟用',
    'zerosix.apiKey.placeholder': '輸入您的 Zerosix API 金鑰',
    'zerosix.formLink': '前往註冊表單的連結',
    'zerosix.useCasualTone': '啟用非正式稱謂',
    'zerosix.authenticationMethods': '允許的忠誠度驗證方法',
    'zerosix.registerMethods': '允許的忠誠度註冊方法',
    'zerosix.methods.email': '電子郵件',
    'zerosix.methods.phone': '電話',
    'zerosix.methods.externalId': '忠誠度識別碼',
    'zerosix.error.formLinkInvalid': '表單連結無效',
    'zerosix.update.success': 'Zerosix 整合已成功更新',
    'zerosix.deleteModal.title': '刪除 Zerosix 整合',
    'zerosix.deleteModal.text': '確定要刪除 Zerosix 整合嗎？',
    'zerosix.error.changeProvider': '此餐廳已設定忠誠度整合，請先刪除',
    'zerosix.error.invalidApiKey': '輸入的 API 金鑰無效。',
    'restaurantInfo.title': '餐廳資訊',
    'restaurantInfo.information.title': '關於餐廳',
    'restaurantInfo.name': '餐廳名稱',
    'restaurantInfo.address': '餐廳地址',
    'restaurantInfo.contactName': '聯絡人姓名',
    'restaurantInfo.contactEmail': '電子郵件地址',
    'restaurantInfo.contactPhone': '電話號碼',
    'restaurantInfo.externalId': '外部識別碼',
    'restaurantInfo.tag': '餐廳標籤',
    'restaurantInfo.families': '餐廳系列',
    'restaurantInfo.searchFamilies': '搜尋系列',
    'restaurantInfo.image': '餐廳圖片',
    'restaurantInfo.legal.title': '法律資訊',
    'restaurantInfo.legal.description': '此資訊用於產生訂購頻道的一般銷售條款及法律聲明',
    'restaurantInfo.legal.socialReason': '公司名稱',
    'restaurantInfo.legal.organizationType': '組織類型',
    'restaurantInfo.legal.capital': '股本',
    'restaurantInfo.legal.commerceRegistryCity': '商業登記城市',
    'restaurantInfo.legal.siren': '統一編號',
    'restaurantInfo.legal.taxNumber': '稅號',
    'restaurantInfo.legal.industryClassificationCode': '行業代碼',
    'restaurantInfo.legal.publicationDirectorName': '出版負責人姓名',
    'restaurantInfo.legal.publicationDirectorFunction': '出版負責人職稱',
    'restaurantInfo.legal.webmasterName': '網站管理員姓名',
    'restaurantInfo.legal.webmasterEmail': '網站管理員電子郵件',
    'restaurantInfo.ewalletMinimum.title': '掃描托盤上允許的最低 e-wallet 餘額設定',
    'restaurantInfo.ewalletMinimum.inputTitle': '最低金額',
    'restaurantInfo.ewalletMinimum.caseZero': '若不設定最低識別證金額，請在欄位中輸入 0 後儲存。',
    'restaurantInfo.delete.title': '刪除餐廳',
    'restaurantInfo.delete.description': '此餐廳建立於',
    'restaurantInfo.delete.button': '刪除此餐廳',
    'restaurantInfo.save.error': '儲存時發生錯誤，請重試。',
    'restaurantInfo.delete.error': '發生錯誤，請重新設定。',
    'restaurantInfo.delete.confirmTitle': '刪除餐廳',
    'restaurantInfo.delete.confirmDescription': '確定要刪除此餐廳嗎？此操作不可復原。',
    'restaurantInfo.schedule.title': '允許的取餐時間',
    'restaurantInfo.schedule.manualEdit': '手動編輯',
    'restaurantInfo.schedule.autoEdit': '自動編輯',
    'restaurantInfo.schedule.autoEditDescription': '可快速建立時間段。',
    'restaurantInfo.schedule.description':
        '您可以為您的餐廳設定不同的允許取餐時間。這些時段對應您的餐廳營業時間，您的客戶可在此時段內取回線上訂購的餐點。',
    'restaurantInfo.schedule.open': '開放',
    'restaurantInfo.schedule.closed': '關閉',
    'restaurantInfo.schedule.day.mon': '週一',
    'restaurantInfo.schedule.day.tue': '週二',
    'restaurantInfo.schedule.day.wed': '週三',
    'restaurantInfo.schedule.day.thu': '週四',
    'restaurantInfo.schedule.day.fri': '週五',
    'restaurantInfo.schedule.day.sat': '週六',
    'restaurantInfo.schedule.day.sun': '週日',
    'restaurantInfo.schedule.mass.startHour': '開始時間',
    'restaurantInfo.schedule.mass.endHour': '結束時間',
    'restaurantInfo.schedule.mass.granularity': '間隔',
    'restaurantInfo.schedule.mass.15min': '15 分鐘',
    'restaurantInfo.schedule.mass.30min': '30 分鐘',
    'restaurantInfo.schedule.mass.1h': '1 小時',
    'restaurantInfo.schedule.mass.overwrite': '覆蓋現有時間表',
    'restaurantInfo.schedule.mass.apply': '套用',
    'restaurantInfo.schedule.mass.noDays': '請至少選擇一天。',
    'restaurantInfo.schedule.mass.midnight': '午夜',
    'order.customer.loyalty.anonymous': '匿名 {email}',
    'route.vatRatesMatrix': '增值稅參考資料',
    'vatRatesMatrix.title': '全球增值稅參考資料',
    'vatRatesMatrix.subtitle': '所有 Innovorder 產品稅務的唯一真實來源。修改將自動套用至新產品。',
    'vatRatesMatrix.vatGroup': '增值稅類別',
    'vatRatesMatrix.codeLabel': '代碼',
    'vatRatesMatrix.eatIn': '內用',
    'vatRatesMatrix.takeAway': '外帶',
    'vatRatesMatrix.delivery': '外送',
    'vatRatesMatrix.exportCsv': '匯出 CSV',
    'vatRatesMatrix.exportError': '匯出 CSV 時發生錯誤，請重試。',
    'vatRatesMatrix.filterByZone': '依區域篩選',
    'vatRatesMatrix.filterByGroup': '依類別篩選',
    'vatRatesMatrix.filterByMode': '依模式篩選',
    'vatRatesMatrix.loading': '載入中...',
    'vatRatesMatrix.error': '載入資料時發生錯誤。',
    'vatRatesMatrix.family.FOOD': '食品',
    'vatRatesMatrix.family.NON_ALCOHOL': '無酒精',
    'vatRatesMatrix.family.ALCOHOL': '酒精',
    'vatRatesMatrix.family.NORMAL': '一般',
    'vatRatesMatrix.family.NONE': '無',
    'route.promotionalBanners': '促銷橫幅',
    'promotionalBanner.page.title': '橫幅管理',
    'promotionalBanner.page.subtitle': '建立並管理您的促銷橫幅，以在您的自助服務機上顯示。',
    'promotionalBanner.page.emptyState': '建立促銷橫幅以在您的自助服務機上推廣您的產品和分類。',
    'promotionalBanner.page.emptyStateCta': '建立橫幅',
    'promotionalBanner.page.noActiveMenu.title': '沒有活躍的自助機菜單',
    'promotionalBanner.page.noActiveMenu.desc': '👉 啟用自助機菜單以存取橫幅設定。',
    'promotionalBanner.page.noActiveMenu.cta': '管理我的菜單',
    'promotionalBanner.action.create': '建立橫幅',
    'promotionalBanner.action.edit': '修改',
    'promotionalBanner.action.view': '查看',
    'promotionalBanner.action.delete': '刪除',
    'promotionalBanner.action.activate': '啟用',
    'promotionalBanner.action.deactivate': '停用',
    'promotionalBanner.table.listTitle': '促銷橫幅清單',
    'promotionalBanner.modal.createTitle': '建立橫幅',
    'promotionalBanner.modal.editTitle': '修改橫幅',
    'promotionalBanner.modal.viewTitle': '查看橫幅',
    'promotionalBanner.modal.close': '關閉',
    'promotionalBanner.modal.name': '名稱',
    'promotionalBanner.modal.channel': '頻道',
    'promotionalBanner.modal.image': '圖片',
    'promotionalBanner.modal.linkType': '連結類型',
    'promotionalBanner.modal.linkTarget': '目標',
    'promotionalBanner.modal.activateAndSave': '啟用並儲存',
    'promotionalBanner.modal.saveAsDraft': '儲存為草稿',
    'promotionalBanner.modal.updateBanner': '更新橫幅',
    'promotionalBanner.modal.deactivateBanner': '停用橫幅',
    'promotionalBanner.modal.imageSizeError': '圖片不得超過 5 MB',
    'promotionalBanner.modal.nameHelper': '此名稱僅在後台可見。',
    'promotionalBanner.modal.nameLabel': '橫幅名稱',
    'promotionalBanner.modal.channelLabel': '目標頻道',
    'promotionalBanner.modal.channelKiosk': '自助服務機',
    'promotionalBanner.modal.channelKioskDesc': '在自助機訂購流程開始時顯示橫幅。',
    'promotionalBanner.modal.channelWeb': 'CEL',
    'promotionalBanner.modal.channelWebDesc': '在線上訂購流程中顯示。',
    'promotionalBanner.modal.channelWebDisabled': '即將推出。',
    'promotionalBanner.modal.imageLabel': '橫幅圖片',
    'promotionalBanner.modal.imageSpecs': 'JPG、PNG、WebP · 最大 5 MB · 3:1 格式',
    'promotionalBanner.modal.image.error.ratio': '格式必須為 3:1',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': '連結類型',
    'promotionalBanner.modal.linkNone': '無連結',
    'promotionalBanner.modal.linkNoneDesc': '僅供參考，不可點擊。',
    'promotionalBanner.modal.linkProduct': '產品',
    'promotionalBanner.modal.linkProductDesc': '點擊時導向產品頁面。',
    'promotionalBanner.modal.linkCategory': '分類',
    'promotionalBanner.modal.linkCategoryDesc': '點擊時導向分類頁面。',
    'promotionalBanner.modal.activateBanner': '啟用橫幅',
    'promotionalBanner.modal.replace': '取代',
    'promotionalBanner.modal.searchCategory': '搜尋分類...',
    'promotionalBanner.modal.searchProduct': '以名稱或 SKU 搜尋產品...',
    'promotionalBanner.table.name': '名稱',
    'promotionalBanner.table.status': '狀態',
    'promotionalBanner.table.source': '來源',
    'promotionalBanner.table.linkType': '連結類型',
    'promotionalBanner.table.actions': '操作',
    'promotionalBanner.table.sourceRestaurant': '餐廳',
    'promotionalBanner.table.sourceBrand': '品牌',
    'promotionalBanner.table.linkNone': '無連結',
    'promotionalBanner.table.linkCategory': '分類',
    'promotionalBanner.table.linkProduct': '產品',
    'promotionalBanner.table.statusActive': '啟用中',
    'promotionalBanner.table.statusInactive': '未啟用',
    'promotionalBanner.table.linkDeleted': '已刪除',
    'promotionalBanner.confirm.title': '目前有進行中的服務',
    'promotionalBanner.confirm.message': '此操作將重新載入所有自助機並中斷進行中的訂單。',
    'promotionalBanner.confirm.confirm': '確認',
    'promotionalBanner.confirm.cancel': '取消',
    'promotionalBanner.delete.title': '刪除橫幅',
    'promotionalBanner.delete.description': '確定要刪除此橫幅嗎？',
    'promotionalBanner.confirm.message.bulk': '此操作將重新載入 {count} 間餐廳的自助機並中斷進行中的訂單。',
    'promotionalBanner.action.duplicate': '複製',
    'promotionalBanner.duplicate.fallback.title': '橫幅已複製但無連結',
    'promotionalBanner.duplicate.fallback.product':
        '「{sourceName}」的副本已建立但無連結：在您的活躍自助機菜單中找不到該 SKU。',
    'promotionalBanner.duplicate.fallback.category':
        '「{sourceName}」的副本已建立但無連結：在您的活躍自助機菜單中找不到該分類。',
    'promotionalBanner.duplicate.fallback.dismiss': '我了解了',
    'route.brand.promotionalBanners': '促銷橫幅',
    'brandPromotionalBanner.page.title': '品牌促銷橫幅',
    'brandPromotionalBanner.page.subtitle': '設定並將橫幅推送至品牌旗下的餐廳。',
    'brandPromotionalBanner.page.empty': '目前沒有橫幅。',
    'brandPromotionalBanner.action.create': '建立橫幅',
    'brandPromotionalBanner.table.name': '名稱',
    'brandPromotionalBanner.table.status': '狀態',
    'brandPromotionalBanner.table.source': '來源',
    'brandPromotionalBanner.table.link': 'SKU 或分類',
    'brandPromotionalBanner.table.activeRestaurants': '{count} 間活躍餐廳',
    'brandPromotionalBanner.table.actions': '操作',
    'brandPromotionalBanner.modal.createTitle': '建立品牌橫幅',
    'brandPromotionalBanner.modal.editTitle': '修改橫幅',
    'brandPromotionalBanner.modal.name.label': '橫幅名稱',
    'brandPromotionalBanner.modal.image.label': '圖片',
    'brandPromotionalBanner.modal.image.hint': '3:1 格式，最大 5 MB',
    'brandPromotionalBanner.modal.image.error.ratio': '格式必須為 3:1',
    'brandPromotionalBanner.modal.image.error.size': '圖片超過 5 MB',
    'brandPromotionalBanner.modal.channel.label': '頻道',
    'brandPromotionalBanner.modal.channel.comingSoon': '即將推出',
    'brandPromotionalBanner.modal.link.label': '連結類型',
    'brandPromotionalBanner.modal.link.none': '無連結',
    'brandPromotionalBanner.modal.link.product': '產品（SKU）',
    'brandPromotionalBanner.modal.link.category': '分類',
    'brandPromotionalBanner.modal.link.product.hint':
        '若在某餐廳的活躍自助機菜單中找不到該 SKU，該餐廳的橫幅將顯示為無連結。',
    'brandPromotionalBanner.modal.link.category.hint':
        '若在某餐廳的活躍自助機菜單中找不到該分類，該餐廳的橫幅將顯示為無連結。',
    'brandPromotionalBanner.modal.restaurants.label': '目標餐廳',
    'brandPromotionalBanner.modal.restaurants.empty': '請至少選擇一間餐廳',
    'brandPromotionalBanner.modal.button.cancel': '取消',
    'brandPromotionalBanner.modal.button.saveDraft': '儲存為草稿',
    'brandPromotionalBanner.modal.button.activate': '啟用橫幅',
    'brandPromotionalBanner.modal.button.deactivate': '停用橫幅',
    'brandPromotionalBanner.modal.button.update': '更新橫幅',
    'brandPromotionalBanner.delete.title': '刪除橫幅？',
    'brandPromotionalBanner.delete.message': '此橫幅將從所有關聯的餐廳中移除。',
    'brandPromotionalBanner.carousel.title': '兩張橫幅之間的顯示間隔',
    'brandPromotionalBanner.carousel.description': '設定兩張活躍橫幅之間的顯示時間。',
    'brandPromotionalBanner.carousel.helper': '兩張活躍橫幅之間的等待時間。',
    'brandPromotionalBanner.carousel.seconds': '秒',
    'brandPromotionalBanner.carousel.save': '儲存',
    'brandPromotionalBanner.carousel.saved': '間隔已更新',
    'brandPromotionalBanner.carousel.help': '此間隔將在自助機下次重新載入時套用至品牌旗下的所有餐廳。',
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel': '此餐廳未啟用自助機。',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': '此餐廳沒有活躍的自助機菜單。',
};

export default translationZhTw;
